/*
    Prodect is following typical JS naming conventions - example https://www.robinwieruch.de/javascript-naming-conventions
        - constant in CAPITAL
        - variables and functions start with small letter
        - class start with capital
        - "obj" when referring to a generic JS object
        - "item" when referring to Prodect specific DB & UI object ( containing ATTR* attributes )
        - ATTR_* used only for DB attributes
            - note you may add UI attributes but use prefix ui_* for example ui_isSelected
        - DEBUG_ or debug* when only for testing purposes
        - use time to think about descriptive name for widely used variables like React state variables
 */


import {API} from "aws-amplify";
import {Storage} from "aws-amplify";
import config, {PRODECT_SW_FULL_VERSION, PROS_S3_URL, USE_PRODUCTION_SERVER, VERS_STRING} from "../config";
import {PROS_HTML_PATH} from "../config";
import {appProdectLogout, handleSessionException, refreshSession} from "../App";
import {v4 as uuidv4} from 'uuid';
import {refreshHelpProject, removeFromHelp} from "./HelpManager";
import {checkToWarnCloseToCapacityLimit, getDefaultColor, prosMultiFilterText, validateTextInput} from "./ProsCommonUi";
import {UI_IS_REPORT, UPDATED_BY_TITLE, UPDATED_TIME_TITLE} from "../containers/ProjectReports";
import * as projectLoader from "../prodect/ProjectLoader";
import prosAppNotif, {updateNotifHtmlElement} from "./ProsAppNotif";
import {
    gloGetMainView,
    MAIN_VIEW_MAIN_PRJ_SETTINGS,
    MAIN_VIEW_PROJECT_DASHBOARD,
    MAIN_VIEW_SUB_PROJECT_SETTINGS
} from "../containers/Home";
import {isLoadingProject, updateUiPollingActivity} from "./ProjectLoader";

let fileDownload = require('js-file-download');

const DEBUG_EXTENDED_PERMISSIONS = false;

export const DEBUG_LOG = false;
export const DEBUG_MENU = false;                // advanced menu to log object to console
export const DEBUG_LOG_SENDING_TO_AWS = false;
const DEBUG_AWS_CHANGES = false;
const DEBUG_TO_SAVE_UI_LIST = false;
export const DEBUG_MODE_TO_SAVE_SERVER_MSG = false;

const S3_IMAGE_FOLDER = "Images/";
export const S3_THUMP_FOLDER = 'ThumpNail/';
const S3_PDF_TO_IMAGE_FOLDER = "PdfToImage/";
const S3_PDF_FOLDER = "Pdf/";
export const S3_EXCEL_IN_FOLDER = "Excel-in/";
const S3_BASE64 = "Base64/";
const S3_VIDEO = "Video/";
const S3_VIDEO_HLS = "VideoHLS/"

const AWS_CUSTOM_PREFIX_IMAGES = {
    public:     S3_IMAGE_FOLDER,
    protected:  S3_IMAGE_FOLDER,
    private:    S3_IMAGE_FOLDER
}

const PROS_IMAGES_PATH = PROS_S3_URL + S3_IMAGE_FOLDER;
const PROS_THUMPS_PATH = PROS_S3_URL + S3_THUMP_FOLDER;
const PROS_AUDIO_PATH =  PROS_S3_URL + 'Sounds/';
const PROS_PDF_TO_IMAGE_PATH = PROS_S3_URL + S3_PDF_TO_IMAGE_FOLDER;
const PROS_VIDEO_PATH = PROS_S3_URL + S3_VIDEO
const PROS_VIDEO_HLS_PATH = PROS_S3_URL + S3_VIDEO_HLS

const AWS_CUSTOM_PREFIX_PDF_TO_IMAGE = {
    public:     S3_PDF_TO_IMAGE_FOLDER,
    protected:  S3_PDF_TO_IMAGE_FOLDER,
    private:    S3_PDF_TO_IMAGE_FOLDER
};

const AWS_CUSTOM_PREFIX_PDF = {
    public:     S3_PDF_FOLDER,
    protected:  S3_PDF_FOLDER,
    private:    S3_PDF_FOLDER
};

const AWS_CUSTOM_PREFIX_BASE64 = {
    public:     S3_BASE64,
    protected:  S3_BASE64,
    private:    S3_BASE64
};

const AWS_CUSTOM_PREFIX_VIDEO = {
    public:     S3_VIDEO,
    protected:  S3_VIDEO,
    private:    S3_VIDEO
};

export const IMPORT_IMG_FILE_TYPES = ['.jpg', '.jpeg', '.png', '.pdf']
export const IMPORT_VIDEO_FILE_TYPES = ['.mp4', '.mov']


const AWS_WEB_IF_VERSION = "3"
const AWS_WEB_REPORT_VERSION = "3"
export const PRODECT_CUSTOMER_CODE_FOR_TEMPLATES = '010-001'

export const STR_YES = "Y";
export const STR_NO  = "n";
export const STR_NO_VALUE = "?#?";

export const NO_DATE_STR = '?'

const OBS_DEFAULT_STATE = '0';
const ATTR_PREFIX_OBS_DEFAULT = 'default_';


export const OBJ_TYPE_ITM        =  "itm";
export const OBJ_TYPE_ITM_TITLE  =  "itm_title";
export const OBJ_TYPE_ITM_OBS    =  "itm_obs";
export const OBJ_TYPE_ITM_PICT   = "itm_pict";
export const ATTR_LOGO_FILE_NAME = "logo";
export const OBJ_TYPE_ITM_PICT_LOC = "itm_pict_loc";
export const OBJ_TYPE_ITM_VIDEO   = "itm_video";
//const OBJ_TYPE_ITM_PDF = "itm_pdf"; maybe not used
export const OBJ_TYPE_SOUND      = "itm_sound";
export const OBJ_TYPE_TXT_SOUND  = "itm_txt_sound";

export const OBJ_TYPE_PRJ =  "prj";

export const OBJ_TYPE_LST =  "lst";
export const OBJ_TYPE_LST_PROJ_PICT = "lst_proj_pict";
// const OBJ_TYPE_LST_USERS = "lst_users";
export const OBJ_TYPE_LST_REPORT_HISTORY = "lst_report_hist";
export const OBJ_TYPE_LST_SEARCH = "lst_search";        // traditional search
export const OBJ_TYPE_LST_SEARCH_R = "lst_search_r";    // relative to time search
export const OBJ_TYPE_LST_SEARCH2 = "lst_search2";      // table search
const OBJ_TYPE_PROS_PARAM = "pros_param";
const USER_SETTINGS_PROJECT_ORDER = "project_order";
export const OBJ_TYPE_ITM_REF    = "itm_ref";
export const OBJ_TYPE_USER_ROLE = "itm_user_role";

export const OBJ_TYPE_PRJ_PG = "prj_pg";
export const OBJ_TYPE_PG_ROLE = "itm_pg_role";
export const OBJ_TYPE_PG_USER = "itm_pg_user";

const OBJ_TYPE_OLD_REPORT = "itm_old_report"                 // static snapshot
const OBJ_TYPE_REFRESH_REP= "itm_refresh_report"             // updated
const OBJ_TYPE_UI_ENABLED_REPORT = "itm_ui_enabled_report"   // active
const OBJ_TYPE_SHARED_SEARCH = "itm_shared_search"           // search v1
//const OBJ_TYPE_SHARED_SEARCH2 = "itm_shared_search2"         // Search v2 WYSIWYG set from table
const OBJ_TYPE_PDF_REPORT = "itm_pdf_report"                 // PDF

export const OBJ_TYPE_METER_STATUS = 'meter_status'
export const OBJ_TYPE_METER_CUMULATIVE = 'meter_cumulative'
export const OBJ_TYPE_METER_READINESS = 'meter_readiness'
export const OBJ_TYPE_METER_GANTT = 'meter_gantt'

export const OBJ_TYPE_PDF_FRONTPAGE = "pdf_front_page"

export const METER_TEMPLATES = [
    {
        text: 'Tilanne',
        obj_type: OBJ_TYPE_METER_STATUS,
        selectedTag: STR_NO_VALUE,
        showTagOptions: [],
        showNewStatus: STR_NO,
    },
    {
        text: 'Kertymä',
        viewBy: 'expiration',
        obj_type: OBJ_TYPE_METER_CUMULATIVE,
    },
    {
        text: 'Valmiusaste',
        obj_type: OBJ_TYPE_METER_READINESS,
    },
    {
        text: 'Edistymä',
        obj_type: OBJ_TYPE_METER_GANTT,
        reportIds: [],
    },
]

export const REPORT_TYPE_FOR_UI = {
    "itm_pdf_report":           'PDF',
    "itm_old_report":           'Web tallennettu tilanne',
    "itm_refresh_report":       'Web päivittyvä',
    "itm_ui_enabled_report":    'Web aktiivinen',
    "itm_shared_search":        'Web hakutulos',
    "itm_shared_search2":       'Web taulukkohaku'
}

// Project report view modes (Home sub views) to show subproject contents:
export const VIEW_MODE_LIST = 'list'
export const VIEW_MODE_TABLE = 'table'
export const VIEW_MODE_CALENDAR = 'matrix'
export const VIEW_MODE_KANBAN = 'kanban'
export const VIEW_MODE_DASHBOARD = 'dashboard'
export const VIEW_MODE_DEFAULT = VIEW_MODE_DASHBOARD

export const ATTR_TABLE_DEF_BOOKMARK = 'table_defaults'
export const OBJ_TYPE_BMARK_TABLE_DEF = 'bmark_table_defaults'
export const OBJ_TYPE_BMARK = 'bookmark'

export const ATTR_OBJ_TYPE   = "obj_type";
export const ATTR_FILE_NAME  = "file_name";
export const ATTR_PDF_NAME  = "pdf_name";
export const ATTR_REPORT_S3_KEY = 'report_s3_key';
export const ATTR_SAVE_PDF_NAME  = "SavePdf";
export const ATTR_USER_NAME = "user_name";
export const ATTR_EMAIL     = "email";
export const ATTR_SORT_ORDER_I = "sort_order";
export const ATTR_OBS_ID = "obs_id";
export const ATTR_REPORT_INDEX = "rep_ind";
const ATTR_REF_ID = "ref_id";

export const ATTR_IS_PICTURES_ALLOWED = "is_pict_allowed"
export const ATTR_IS_REPORTS_ALLOWED = "is_report_allowed"

export const ATTR_PICTURE_ROTATE = "pict_rotate"
const ATTR_PICTURE_OVERLAY = "pict_overlay";
export const ATTR_PICTURE_LOC_H = "pict_loc_h";
export const ATTR_PICTURE_LOC_W = "pict_loc_w";
const ATTR_PICTURE_LOC_H_PREV = "pict_loc_h_prev"
const ATTR_PICTURE_LOC_W_PREV = "pict_loc_w_prev"
export const ATTR_PICT_ZOOM = "pict_zoom"

export const ATTR_HAS_PICTURE_LOC = "has_picture_loc";

export const ATTR_EXPIRATION_FILTER = "expire_flt";
export const ATTR_EXPIRATION = "expires";
export const ATTR_EXPIRATION_REQUIRED = "expires_required";
export const ATTR_EXPIRATION_RESTRIC_OWN = "expires_restr_own"
export const ATTR_EXPIRATION_RESTRIC_SET = "expires_restr_set"
export const ATTR_DATE_AND_TIME = "date_and_time" // date_and_time Already in mobile use. Signifies whether expiration is set with time granularity instead of date only

export const ATTR_IS_PRIVATE = "is_private";
export const ATTR_SHOW_IDENTIFIERS = "show_ids";
export const ATTR_DELAY_TO_UPDATE_IDENTIFIERS = "delay_update_ids"
export const ATTR_FILTER_CREATED_AFTER = "flt_created_after";
export const ATTR_FILTER_CREATED_BEFORE = "flt_created_before";
export const ATTR_FILTER_UPDATED_AFTER = "flt_updated_after";
export const ATTR_FILTER_UPDATED_BEFORE = "flt_updated_before";

const RELATIVE_PREFIX = 'relative_'
export const RELATIVE_PREFIX_BEFORE = 'relative_before_'
export const RELATIVE_PREFIX_AFTER = 'relative_after_'

export const ATTR_MAIN_PROJ_ID = "main_proj_id";
export const ATTR_MAIN_PROJECT_NAME = "main_proj_name";
export const ATTR_INFO_COPY_FROM_PID = "copy_from_pid";
export const ATTR_COPY_FROM_REPORT = "copy_from_report";
export const ATTR_CUSTOMER_ADMIN_EMAILS = "admin_emails";

export const ATTR_OBJ_STATE  = "obj_state";
export const OBJ_STATE_TO_DEL = "TO_DEL";
export const OBJ_STATE_DEL = "DEL";
export const OBJ_STATE_CREATE = "CREATE";
export const OBJ_STATE_ACT = "ACT";
export const OBJ_STATE_PAS = "PAS"
const OBJ_STATE_WAIT = "WAIT";
export const ATTR_PROJECT_STATE = 'project_state'       // project state in project list ACT, PAS, (DEL)

const ATTR_PROJ_REPORTS = 'proj_reports';
const ATTR_PROJ_USERS   = 'proj_users';
const ATTR_PROJ_REP_HIST= 'proj_rep_hist';
const ATTR_PROJ_SEARCHS = 'proj_searchs';
const ATTR_PROJ_LOC_PICTS = 'proj_loc_picts';

export const ATTR_PARENT_OBS = "parent_obs";
export const ATTR_SAVED_OBS_PARENT = "saved_obs_parent";
export const ATTR_CREATED_BY = "created_by";
export const ATTR_USER_ROLE = "user_role";
export const ATTR_PG_ROLE = "pg_role";

export const ATTR_PARENT = "parent"; // For non obs

export const ATTR_EXPORT_JSON = "export_json"
export const ATTR_EXPORT_WEB_REPORT = "export_web"
export const ATTR_EXPORT_WEB_REPORT_ACT = "export_web_act"

const PREFIX_PROJ_USERS = "users-";
//const PREFIX_PROJ_LOC_PICTURES = "loc-pict-";
export const PREFIX_REPORT_HISTORY = "hist-";

export const ATTR_IS_TEMPLATE = "is_template";
export const ATTR_IS_EXAMPLE = "is_example";
export const ATTR_CUSTOMER_NAME = "customer_name";
export const ATTR_CUSTOMER_GROUP = "customer_group";

export const ATTR_PROJECT_LINK = "project_link";
export const ATTR_SELECTED_REPORTS = "selected_reports";
export const ATTR_UI_VIEW_MODE = "ui_view_mode";
export const ATTR_UI_SEARCH = "ui_is_search";
export const ATTR_UI_SETTINGS = "ui_settings";
const MANDATORY_ATTRS_FOR_PROJECT_LINK = [
    ATTR_PROJECT_LINK, ATTR_SELECTED_REPORTS, ATTR_UI_VIEW_MODE, ATTR_UI_SETTINGS]

export const ATTR_BROWSER_HOME = "browser_home";
export const ATTR_LAST_ARCHIVED_MS = "archived_ms";
const ATTR_ARCHIVE_ZIP_IND = 'archive_zip_ind';
const DEFAULT_CUSTOMER_GROUP = "YLEINEN";

export const REPORT_TYPE_NUMBERING = 2;    // report and OBS numbering - no report output
export const REPORT_TYPE_PREVIEW = 3;      // check how it would look
export const REPORT_TYPE_HISTORY = 4;      // saved status
export const REPORT_TYPE_UPDATED = 5;      // Keep updated
export const REPORT_TYPE_ACTIVE  = 6;      // Interactive for repairer etc -- currently no long in use
export const REPORT_TYPE_SEARCH  = 7;      // Updated based an search rules when html doc is loaded or PDF

export const DEFAULT_SORT_ORDER_SPACING = 100;
export const MINIMUM_SORT_ORDER_SPACING = 100;

export const MAX_NUM_OF_UI_OBJS = 10000;

export const CUSTOMER_NAME_MIN_LEN = 3;
export const PROJECT_NAME_MIN_LEN = 3;
export const PROJECT_NAME_MAX_LEN = 80;
export const INPUT_TAG_MAX_LENGTH = 30;
export const MAIN_PROJ_NAME_MAX_LEN = 60;
export const MIN_CUST_GROUP_LEN = 2;
export const MAX_CUST_GROUP_LEN = 24;

export const TAG_LABEL_MAX_LEN = 20;
export const MAX_CH_TAGS = 20;
export const MAX_RB_TAGS = 20;
export const MAX_RB_OPTIONS = 50;
export const MAX_STXT_TAGS = 20;

export const UI_LISTED_ELEMENTS_LIMIT = 10;//Amount of searchable items limit in dropdowns (Todo: change this to some global value)
export const UI_LIST_LIMIT = 50;//used in list view to limit open items

const ATTR_GENERATE_OBS_ID = "generate_obs_id";
const ATTR_GENERATE_HTML =  "generate_html";
const ATTR_GENERATE_PDF =  "generate_pdf";
const ATTR_SAVE_REPORT = "save_report";  //  save report to history

export const ATTR_UI_PICTURE_LARGE = "ui_pict_large";
const ATTR_HLS_VIDEO = "hls_video"

export const ATTR_CB_TAGS = "cb_tags";
export const ATTR_RB_TAGS = "rb_tags";
export const ATTR_TXT_TAGS = "txt_tags";
export const ATTR_STAG    = "stag";
export const ATTR_STAG_CH = "stag_ch";
export const ATTR_STAG_TXT = "stxt";
export const ATTR_DEPENDS = "depends_on";

export const ATTR_REP_OPT_OBS_SUMMARY = "rep_obs_summary"
export const ATTR_REP_OPT_PROJECT_LINK = "rep_in_project_report"

export const TAG_RB_PREFIX = "tag";
export const TAG_CH_PREFIX = "tag_ch";
export const TAG_TXT_PREFIX = "txt";

// Default states "observed", "fixed", "can't fix" for limited access rights
export const DEFAULT_LIMITED_ACCESS_STATE_INDECES = [0, 1, 3];
export const DEFAULT_STATE_CAN_BE_LATE = [0, 3];

export const PROS_REPLACE_BY_LIST_ID = 'pros_list_id';

//const ITEM_TYPES_WITH_TEXT = [OBJ_TYPE_ITM, OBJ_TYPE_ITM_OBS, OBJ_TYPE_ITM_TITLE, OBJ_TYPE_TXT_SOUND];
const ITEM_TYPES_PICT = [OBJ_TYPE_ITM_PICT, OBJ_TYPE_ITM_PICT_LOC];
const ITEM_TYPES_AUDIO = [OBJ_TYPE_SOUND, OBJ_TYPE_TXT_SOUND]
const ITEM_TYPES_VIDEO = [OBJ_TYPE_ITM_VIDEO]

const ATTR_VIDEO_STATE = "video_state"
const VIDEO_STATE_READY = "ready"
const ATTR_STILL_PICTURE = "still_picture"


        // Item types that may be part of OBS
const ITEM_TYPES_SUB = [OBJ_TYPE_ITM, OBJ_TYPE_ITM_VIDEO].concat(ITEM_TYPES_PICT).concat(ITEM_TYPES_AUDIO)

const ITEM_TYPES_NOT_FOR_REPORT_UI = [
    OBJ_TYPE_USER_ROLE,
    OBJ_TYPE_REFRESH_REP,
    OBJ_TYPE_OLD_REPORT,
    OBJ_TYPE_UI_ENABLED_REPORT,
    OBJ_TYPE_SHARED_SEARCH,
    OBJ_TYPE_PDF_REPORT,
];

const SAVED_SETTINGS = "Prodect-settings";
const SAVED_EMAIL = 'Prodect-user-email';
const SAVED_LOCAL_SETTINGS = "Prodect-localSettings";
const SAVED_GLOBAL_TRANSFER = "Prodect-transfer";
const SAVED_UNSELECTED_REPORTS = "UnSelectedReportsByPid"

const SAVED_NAME = 'Prodect-name';

export const SAVED_SELECTED_MAIN_PROJECT = 'Prodect-selectedMainProject'
export const SAVED_SELECTED_PROJECT = 'Prodect-selectedProject';
export const SAVED_MAIN_VIEW = "mainProjectView"
export const SAVED_REPORT_VIEW = "reportViewMode"
export const SAVED_SETTINGS_SUBVIEW = "activeSettingsPage"
export const SAVED_SUPERUSER = 'Prodect-s_user';

const SAVED_FAILED_LINK = 'Prodect-failed-link';
const SAVED_PERM_REQ_LINK = 'Prodect-req-perm-link';
const SAVED_DBG_IND = 'Prodect-saveDbgInd';

const SAVED_SESSION_ERR_TIME = 'Prodect-lastTimeSessionError'
const SAVED_SESSION_ERR_LOG = 'Prodect-sessionErrorLog'
const MIN_TIME_BETWEEN_SESSION_ERRORS_MS = 3600*1000;
const SESSION_ERR_LOG_LINE_COUNT = 64;

export const ATTR_AWS_PROJECT_ID = "project_id";
export const ATTR_OBJ_ID     = "obj_id";
export const ATTR_PERM_GROUP = "perm_group";

export const ATTR_LIST_REF = "list_ref";

export const ATTR_SENT_TO = "sent_to";
export const ATTR_UPDATED_BY = 'updated_by';
export const ATTR_UPDATED_MS_I = "updated_ms";
export const ATTR_CREATED_MS_I = "created_ms";
export const ATTR_CREATED_STR = "created";
export const ATTR_DEVICE_ID = "device_id";
export const ATTR_OBJ_HISTORY = 'obj_history';        // time str when saved older item value to history
export const ATTR_CHANGE_HISTORY = 'attr_changes';
export const ATTR_ARCHIVE_ID = 'archive_id'

export const ATTR_PROJECTS = 'projects'
export const ATTR_RULE_PROJECTS = 'rule_projects'
export const ATTR_NOTIFICATIONS = 'notifications'
export const ATTR_RULE_NOTIFICATIONS = 'rule_notifications'
export const ATTR_RULE_NOTIFICATION_RECURRING = 'rule_notification_recurring'
export const ATTR_RULE_NOTIFICATION_RECURRING_DAY = 'rule_notification_recurring_day'
export const ATTR_NOTIFICATION_DAY = 'notification_day'
export const ATTR_NOTIFICATION_FOR_NEW_SUBPROJECTS = 'notification_for_new_subprojects'

export const ATTR_DESCRIPTION = 'description'

export const PRJ_PERM_GROUPS = "perm_groups";
export const PRJ_SYS_BUILDING_PARAMS = "pros_building";

export const ATTR_AGE = "age";
export const ATTR_TEXT = "text";
export const ATTR_PRJ_DESC = "prj_desc";
const ATTR_OBS_HISTORY = "obs_hist";
const ATTR_ACTION = 'action';

export const ATTR_PROJECT_START = "prj_start";
export const ATTR_PROJECT_END = "prj_end";

export const OBS_LIST = 'obsList';              // OBS in a report
export const OBS_OBJ_LIST = 'obsObjList';       // items in OBS
export const OBS_PICTS = 'ui_Picts';            // pictures in OBS
export const OBS_VIDEOS = 'ui_Videos';          // videos in OBS

export const UI_ATTR_NO_EDIT = 'ui_NoEdit';     // todo ?

const ATTRS_FOR_UI_ONLY = [OBS_OBJ_LIST, OBS_LIST];
export const MIN_EXPIRE_TIME_MS = 1545000000000;   // mid December 2018
export const MAX_EXPIRE_TIME_MS = 3000000000000;   // mid January 2065
export const MILLISECONDS_IN_24H = 86400000;   // milliseconds in a day / 24 h = 24*60*60*1000

export const ATTR_WEB_OPERATION = 'web_operation';
const WEB_OPER_GET_ACCESS_RIGHTS = 'web_oper_get_access_rights';
const WEB_OPER_ARCHIVE = 'web_oper_archive'
export const WEB_OPER_MAKE_PROJ_ASYNCH = 'web_oper_make_new_proj_asynch'
export const WEB_OPER_MAKE_PROJ = 'web_oper_make_new_proj'

const WEB_OPER_UPDATE_OBJ = 'web_oper_update_obj'       // To update complete DB obj
const WEB_OPER_UPDATE_ATTRS = 'web_oper_update_attrs'   // Server checks project and OBS state etc - used to modify OBS etc
const WEB_OPER_UPDATE_ITEM_ATTRS = 'web_oper_update_item_attrs'     // Server does not check state etc - just updates

const WEB_OPER_MAKE_LINK = 'web_oper_make_link'
const WEB_OPER_GET_LINK = 'web_oper_get_link'
const WEB_OPER_REQ_PERM_LINK = 'web_oper_req_perm_link'
const WEB_OPER_GRANT_PERM_LINK = 'web_oper_grant_perm_link'
const WEB_OPER_GRANT_PERM_TEST_LINK = 'web_oper_grant_test_link'
const WEB_OPER_MAKE_BOOKMARK = 'web_oper_make_bookmark'
const WEB_OPER_GET_BOOKMARKS = 'web_oper_get_bookmarks'
const WEB_OPER_UPDATE_BOOKMARK = 'web_oper_update_bookmark'

const WEB_OPER_GET_PROJECT_MAKER = 'web_oper_get_project_maker'
const WEB_OPER_SAVE_PROJECT_MAKER = 'web_oper_save_project_maker'
const WEB_OPER_COST_CALC = 'web_oper_cost_project_maker'
const WEB_OPER_ORDER_CUSTOMER = 'web_oper_order_project_maker'
const WEB_OPER_VALIDATE_CAMPAIGN_CODE = 'web_oper_validate_campaign_code'

const WEB_OPER_USER_ACCEPTED_TERMS = 'web_oper_user_accepted';
const WEB_OPER_PACK_PROJECT = 'web_oper_pack_project';
const WEB_OPER_DEL_MAIN_PROJECT = 'web_oper_del_main_project';
const WEB_OPER_GET_USER_SETTINGS = 'web_oper_get_user_settings'
const WEB_OPER_SAVE_USER_SETTINGS = 'web_oper_save_user_settings'
const WEB_OPER_ONE_TIME_NOTIFICATION_REQUEST = 'web_oper_one_time_notification_request'
const WEB_OPER_SEND_FEEDBACK = 'web_oper_send_feedback'
const WEB_OPER_MOVE_PROJECT = 'web_oper_move_project'

const ATTR_ENUM_ID = 'enum_id'
const WEB_OPER_GET_ENUMS = 'web_oper_get_enums'
const WEB_OPER_SAVE_ENUMS = 'web_oper_save_enums'
const WEB_OPER_ADD_ENUMS = 'web_oper_add_enums'

const WEB_OPER_GET_SYSTEM_PARAMETERS = 'web_oper_get_sys_params'

const WEB_OPER_GET_CUSTOMERS = 'web_oper_get_customers'
const WEB_OPER_GET_CUSTOMER_INFO = 'web_oper_get_customer_info'
const WEB_OPER_SAVE_CUSTOMER_INFO = 'web_oper_save_customer_info'
const WEB_OPER_GET_CUSTOMER_CONFIGS = 'web_oper_get_customer_configs'
const WEB_OPER_SAVE_CUSTOMER_CONFIG = 'web_oper_save_customer_config'
const WEB_OPER_DEL_CUSTOMER_CONFIG = 'web_oper_del_customer_config'
const WEB_OPER_GET_PDASH_SETTING = 'web_oper_get_pdash_setting'
const WEB_OPER_GET_PDASH_PROJECT_SETTINGS = 'web_oper_get_pdash_project_settings'
const WEB_OPER_SAVE_PDASH_SETTING = 'web_oper_save_pdash_setting'
const WEB_OPER_GET_FILTERED_OBS = 'web_oper_get_filtered_obs'
const WEB_OPER_GET_NOTIFICATION_RULES = 'web_oper_get_notification_rules'
const WEB_OPER_SAVE_NOTIFICATION_RULES = 'web_oper_save_notification_rules'
const WEB_OPER_REQUEST_TEST_NOTIF_FOR_CUSTOMER = 'web_oper_request_test_notif_for_customer'
const WEB_OPER_GET_PROJECT_OBJS = 'web_oper_get_project_objs'
const WEB_OPER_GET_CUSTOMER_MAIN_PROJ_HELP = 'web_oper_get_customer_main_proj_help'
const WEB_OPER_SAVE_CUSTOMER_MAIN_PROJ_HELP = 'web_oper_save_customer_main_proj_help'
const WEB_OPER_GET_PROJECT = 'web_oper_get_project'


export const ATTRS_NOT_FOR_HISTORY_LISTING = [ATTR_CREATED_BY, ATTR_CREATED_MS_I, ATTR_AGE,
    ATTR_UPDATED_MS_I, ATTR_SORT_ORDER_I,
    ATTR_AWS_PROJECT_ID,
    ATTR_REPORT_INDEX, ATTR_OBS_ID, ATTR_OBS_HISTORY, ATTR_PARENT_OBS, ATTR_CREATED_STR,
    "hist_next_updated_ms", //"hist_next_updated_by", 
    ATTR_IS_TEMPLATE, ATTR_DEVICE_ID, ATTR_LIST_REF];

export const TEXT_FIELD_TYPE_TXT = "txt"
export const TEXT_FIELD_TYPE_NUMBER = "number"
export const TEXT_FIELD_TYPE_EMAIL = "email"
export const TEXT_FIELD_TYPE_EMAILS = "emails"
export const TEXT_FIELD_TYPES = {
    "txt": 'Teksti',
    "number": 'Numero',
    "email": 'Sähköpostiosoite',
    "emails": 'Sähköpostiosoitteet (useita)',
    "enum": 'Yksi valintalistalta',
    "enums": 'Useita valintalistalta'
}

// Long lasting query types
const WEB_OPER_QUERY = "web_oper_query"
const ATTR_QUERY_TIME_KEY = "time_key"
const ATTR_QUERY_TYPE = "query_type"
const ATTR_CACHE_ID = "cache_id"
const ATTR_QUERY_IS_FRESH = "is_fresh"
const ATTR_QUERY_POLL_PERIOD_MS = "poll_period"
const ATTR_QUERY_DATA = "data"
const ATTR_LAST_UPDATED = 'last_updated'

export const ATTR_ENUM_MAY_ADD = "may_add"
export const ATTR_ENUM_VALUES = "enums"

export const QUERY_CUSTOMER_PERMS = 'query_cust_perms'
export const QUERY_CUSTOMER_FRONTPAGES = 'query_cust_frontpages'
export const QUERY_CHANGE_PERMS = 'query_change_perms'
export const QUERY_DASHBOARD_METERS = 'query_dash'
export const QUERY_NUMBERING_RESET = 'query_numbering_reset'
export const QUERY_NUMBERING_ALL = 'query_numbering_all'
export const QUERY_STATUS_SUBPROJECT = 'query_status_subproj'
export const QUERY_STATUS_MAINPROJECT = 'query_status_mainproj'

export const TABLE_FIXED_COLS_AT_RIGHT = [ATTR_CREATED_BY, ATTR_CREATED_MS_I, UPDATED_BY_TITLE, UPDATED_TIME_TITLE]



/*
    Most important object is activeProject which is an instance of ProsProject() class - contains
        - several methods to access project information ( TAG etc )
        - project data and a hierarchical list of UI items

    Beyond ProsProject ProsConnect is data centric - means that there is no specific class for UI items but
    UI item is just a plain JS object.  When access UI item attributes use ATTR_* as need often to check
    consistency between server and mobile code which are using the same attributes.

    project has two important lists internally:
        objs    - a flat list of all project UI objects
        uiItems - a hierarchical list of UI objects ( == "reports" )
            "obsList"
                root level objs like title, comments and pictures following title, and OBS's
                each OBS   has two lists
                    "obsObjList"    items (pict, comment, ..) under observation
                    "ui_Picts"      pictures in OBS
 */

// ProsConnect main state
let activeProject;
let projectsLastUpdatedMs = 0;

let projects;
let userProjectList = undefined     // todo - check if would use "projects"
let savedUserSettingsProjectOrder = undefined

let uiListSizeLimited = false;

let userAccessRights = undefined;  // normal|extended|super
let isSuperUserInUse = false;
let testingCustomerEmail = '';
let recentlyRemovedProjects = [];
let userAdminCustomers = []

/*
  Cache user projects locally - refresh manually or when more than x minutes been elapsed since last time loaded
 */
const USER_PROJECT_LIST_CASHE_AGING_MINUTES = 30
let userProjectListLastUpdatedMs = 0

function isVarTypeString(testVar) {
    return typeof testVar === 'string' || testVar instanceof String
}

// List keys that are to be saved into localStorage
// Those that are commented out or missing from list are saved into sessionStorage
const CONFIG_IN_LOCAL_STORAGE = [
    SAVED_EMAIL,
    SAVED_NAME,
    SAVED_SETTINGS,
    SAVED_LOCAL_SETTINGS,
    SAVED_MAIN_VIEW,
    SAVED_REPORT_VIEW,
    SAVED_GLOBAL_TRANSFER,
    SAVED_SESSION_ERR_TIME,
    SAVED_SESSION_ERR_LOG,
    SAVED_SELECTED_MAIN_PROJECT,
    // SAVED_SELECTED_PROJECT,
    // SAVED_SETTINGS_SUBVIEW,
    // SAVED_UNSELECTED_REPORTS,
    // SAVED_FAILED_LINK,
    // SAVED_PERM_REQ_LINK
]

// Restore info either from session or local storage
export function restoreConfigStr(key, defaultValue) {
    let storage = CONFIG_IN_LOCAL_STORAGE.includes(key) ? localStorage : sessionStorage
    return storage.getItem(key) ?? defaultValue
}

// Save info either to session or local storage
export function saveConfigStr(key, value) {
    let storage = CONFIG_IN_LOCAL_STORAGE.includes(key) ? localStorage : sessionStorage
    if (restoreConfigStr(key) !== value) {
        storage.setItem(key, value)
    }
}

// Remove saved key from both local and session storage to clean up
// when storage type have changed between releases
export function deleteConfigStr(key) {
    sessionStorage.removeItem(key)
    localStorage.removeItem(key)
}

export function isSettingsView(){
    return gloGetMainView() === MAIN_VIEW_SUB_PROJECT_SETTINGS
}
export function isMainProjectView(currentProjectView ){
    return currentProjectView === MAIN_VIEW_PROJECT_DASHBOARD
        || currentProjectView === MAIN_VIEW_MAIN_PRJ_SETTINGS
}


let gloShowingIdentifiers = true;
export function updateShowingIdentifiers() {
    let project = getActiveProject()
    if (project) {
        gloShowingIdentifiers = project.getAttr(ATTR_SHOW_IDENTIFIERS) !== STR_NO
    }
}

export function showingIdentifiers() {
    let project = getActiveProject()
    return project && project.getAttr(ATTR_SHOW_IDENTIFIERS) !== STR_NO
}

export function dumpObjToJsonFile(obj, subject) {
    let dbgInd = 1;
    let str = localStorage.getItem(SAVED_DBG_IND);
    if (str) {
        dbgInd = parseInt(str) + 1
    }
    let dbgFilExportName = 'pros-dbg-' + subject + '-' + dbgInd + '.json';
    let dumpStr = JSON.stringify(obj, null, 4);
    fileDownload(dumpStr, dbgFilExportName);
    // alert('Pros DBG - saved ' + dumpStr.length + ' bytes to ' + dbgFilExportName);
    localStorage.setItem(SAVED_DBG_IND, dbgInd.toString());
}

function isInteger(x) {
    return parseInt(x, 10) === x;
}

function consoleAndLog(...a) {
    console.log(...a)
    addToLogBuffer(...a)
}

function dumpObj(o, title) {
    let objIndex = activeProject.objs.findIndex(x => x.obj_id === o.obj_id)
    consoleAndLog('============== index:', objIndex, '==============')
    if (title) {
        consoleAndLog(title);
    } else {
        consoleAndLog(o[ATTR_OBJ_TYPE]);
    }
    let keys = Object.keys(o);
    keys.sort((a, b) => { return a.localeCompare(b)})
        .forEach(key => {
            consoleAndLog('\t', key,':', dbgDecode(o, key));
        });
}

export function dumpProsObj(obj) {
    function dumpSortOrder(obj, objList) {
        let refSo = obj[ATTR_SORT_ORDER_I];
        function logSortOrder(item) {
            let indexInProjectList = activeProject.findObjIndex(item[ATTR_OBJ_ID])
            console.log(indexInProjectList, "ds:", item[ATTR_SORT_ORDER_I] - refSo,
                item[ATTR_OBJ_TYPE], item[ATTR_OBJ_ID], item[ATTR_TEXT]);
            refSo = item[ATTR_SORT_ORDER_I];
        }
        console.log("ref sort order:", obj[ATTR_SORT_ORDER_I]);
        if (objList) {
            for (let item of objList) {
                logSortOrder(item);
            }
        } else {
            // find obj and log sort order until no itm type
            if (activeProject) {
                let found = false;
                for (let report of activeProject.uiItems) {
                    if (obj[ATTR_OBJ_ID].indexOf(report[ATTR_OBJ_ID]) !== 0) {
                        continue;
                    }
                    for (let itemx of report.obsList) {
                        if (itemx[ATTR_OBJ_ID] === obj[ATTR_OBJ_ID]) {
                            found = true;
                            continue
                        }
                        if (found) {
                            logSortOrder(itemx);
                            if (itemx[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS ||
                                itemx[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE) {
                                break
                            }
                        }
                    }
                }
            }
        }
    }
    if ( ! obj) {
        console.log("obj dump failed. obj not found.")
        return
    }

    console.log("obj dump PID:", activeProject.getPid());
    let origObj = getOriginal(obj);
    switch (origObj[ATTR_OBJ_TYPE]) {
        case OBJ_TYPE_ITM_OBS: {
            prosLogX("DUMP OBS, number of items", obj.obsObjList?.length);
            if (origObj !== obj) {
                dumpObj(obj,'OBS ref');
                dumpObj(origObj, 'OBS original');
            } else {
                dumpObj(obj,'OBS');
            }
            for (let i in obj.obsObjList) {
                prosLogX("OBS item", i);
                let origItm = getOriginal(obj.obsObjList[i]);
                if (origItm !== obj.obsObjList[i]) {
                    dumpObj(obj.obsObjList[i],'ITM ref');
                    dumpObj(origItm, 'ITM original');
                } else {
                    dumpObj(obj.obsObjList[i],'ITM');
                }
            }
            dumpSortOrder(obj, obj.obsObjList);
            break
        }
        case OBJ_TYPE_ITM_TITLE: {
            dumpObj(obj, "Title");
            dumpSortOrder(obj);
            break
        }
        case OBJ_TYPE_LST: {
            dumpObj(obj, "Report");
            dumpSortOrder(obj, obj.obsList);
            break
        }
        default: {
            prosLogX("DUMP OBJ");
            dumpObj(obj);
        }
    }
}

/*
// Dump reports to debug report selection etc.
export function dumpReports(title, details=true) {
    const project = getActiveProject()
    if (!project) { return }
    let allReports = project.objs.filter(item => item[ATTR_OBJ_TYPE] === OBJ_TYPE_LST)
    let activeReports = allReports.filter(item => item[ATTR_OBJ_STATE] === OBJ_STATE_ACT)
    console.log("REPORTS", title,
        "all:", allReports.length,
        "active:", activeReports.length,
        "selected:", project.selectedReports.length)
    if (details) {
        allReports.forEach((report, i) =>
        {
            let isSelected = project.selectedReports.find(id => id === report.obj_id) !== undefined
            console.log("   ", i, report.obj_id, report.text,
                "state:", report[ATTR_OBJ_STATE],
                "selected:", isSelected,
                "isOpen:", report.isOpen)
        })
    }
}
*/

function getTimestampString() {
    let d = new Date();
    return d.toISOString()
        .split('T')[1]
        .replace('Z', '')
}

const LOG_BUFFER_LINE_MAX_LENGTH = 2000
const LOG_BUFFER_LINE_AVG_LENGTH = 250
const LOG_BUFFER_LEN_MAX = 190000
const LOG_BUFFER_MAX_LINES = LOG_BUFFER_LEN_MAX / LOG_BUFFER_LINE_AVG_LENGTH
let logBuffer = []

export function addToLogBuffer(...args) {
    let logText = getTimestampString() + ' ' +
        args
            .map(a => JSON.stringify(a))
            .join(' ')
    if (logText.length > LOG_BUFFER_LINE_MAX_LENGTH) {
        if (userHasDebugMenu() && ! USE_PRODUCTION_SERVER) {
            console.log('Log line too long!', logText)
            const stackTrace = new Error().stack;
            console.log('stackTrace:', stackTrace);
        }
        logText = logText.substring(0, LOG_BUFFER_LINE_MAX_LENGTH) + ' TRUNC:' + logText.length
    }
    logBuffer.push(logText)
    while (logBuffer.length > LOG_BUFFER_MAX_LINES) {
        logBuffer.shift();
    }
}

function getLogBufferLines(reqNumberOfLines) {
    let numOfLines = reqNumberOfLines < logBuffer.length ? reqNumberOfLines : logBuffer.length
    let lines = []
    for (let i = logBuffer.length-numOfLines; i < logBuffer.length; i++) {
        lines.push(logBuffer[i])
    }
    return lines
}

function sessionExceptionDetected(where, what) {
    setLatestSigoutError(where + ": " + what)
    prosLogErr("Session exception:", getLatestSignoutError())
    // Save exception but not too often
    const lastTimeSessionErrorStr = restoreConfigStr(SAVED_SESSION_ERR_TIME)
    if (!lastTimeSessionErrorStr ||
        currentTimeMs() - parseInt(lastTimeSessionErrorStr) > MIN_TIME_BETWEEN_SESSION_ERRORS_MS) {
        const logLinesStr = JSON.stringify(getLogBufferLines(SESSION_ERR_LOG_LINE_COUNT))
        saveConfigStr(SAVED_SESSION_ERR_LOG, logLinesStr);
        saveConfigStr(SAVED_SESSION_ERR_TIME, currentTimeMs().toString());
    }
    handleSessionException()
}

export async function reportSessionErrorToServer() {
    const errorLog = restoreConfigStr(SAVED_SESSION_ERR_LOG)
    if (errorLog) {
        await sendFeedback({
            user_text: "Session error",
            fb_type: 's1',
            request_contact: false,
            send_logs: false,
        }, errorLog)
        console.log("Reported session error to server")
    }
    deleteConfigStr(SAVED_SESSION_ERR_LOG)
    deleteConfigStr(SAVED_SESSION_ERR_TIME)
}

/**
 * Used to log important events for "user feedback" and error log that is sent to server
 * when user requests feedback to some dilemma - or later may consider reporting automatically error cases.
 * For testing developer may enable temporally logging to  console using DEBUG_LOG - flag.
 * @param args      Variable number of arguments are logged.
 */
export function prosLog(...args) {
    addToLogBuffer(...args)
    if (DEBUG_LOG) {
        prosLogX(...args);
    }
}

/**
 * Used for testing to log to coneole with timestamp - not saved to log buffer.
 * @param args
 */
export function prosLogX(...args) {
    let d = new Date();
    console.log(d.toISOString()
        .split('T')[1]
        .replace('Z', ''),
        ...args);
}

/**
 * Error logging - included into customer feedback.  Also logged to console (visible in browser inspect page)
 * Later may add call stack to see which line in code triggered this error.
 * @param args
 */
export function prosLogErr(...args) {
    addToLogBuffer('ERR: ', ...args)
    let d = new Date();
    console.log(d.toISOString()
            .split('T')[1]
            .replace('Z', ''), "ERR: ",
        ...args);
}

/**
 * Warning logging - uses prosLog with WRN: prefix.
 * @param args
 */
export function prosLogWrn(...args) {
    prosLog("WRN: ", ...args);
}

// =======================================================================================================
// When reserve wait for ongoing AWS operation to be completed. Needed as AWS API does not handle queuing.
// Todo promise queue and resolve waiting promise by completion of previous operation - polling until then.

const sleep = (delayMs) => new Promise((resolve) => setTimeout(resolve, delayMs))
let concurrentCalls = 0
let busyTask = ''
let longQueryOngoing = false

export const SERVER_IF_NOT_BUSY = 0
export const SERVER_IF_BUSY = 1
export const SERVER_IF_BG_TASK = 2
let prevAwsInterfaceBusyState = SERVER_IF_NOT_BUSY
let waitUntilNotBusy = undefined

function refreshBusyNotifAfterIdle() {
    waitUntilNotBusy = undefined
    updateNotifHtmlElement()
}

export function getServerIfState() {
    if (concurrentCalls < 1) {
        return SERVER_IF_NOT_BUSY
    }
    if (concurrentCalls > 1) {
        return SERVER_IF_BUSY
    }
    return longQueryOngoing ? SERVER_IF_BG_TASK : SERVER_IF_BUSY
}

let awsApiUser = ''
export async function reserveAwsApi(start, what) {
    let startedToWait = currentTimeMs()
    let wasWaiting = false
    if (start && concurrentCalls) {
        prosLogClearDt('---> AWS API start', what, "WAITING..")
        wasWaiting = 1
    } else if (!concurrentCalls){
        prosLogClearDt('---> AWS API start', what)
    }
    let waitingTime = currentTimeMs()
    while (start && concurrentCalls) {
        await sleep(100)
        wasWaiting += 1
        if (currentTimeMs() - waitingTime > 5000) {
            waitingTime = currentTimeMs()
            prosLogX(what, 'waiting', (currentTimeMs() - startedToWait) / 1000,
                'for busytask:', busyTask, ', tasks in queue:', concurrentCalls)
        }
    }
    if (wasWaiting) {
        prosLogDt('---> AWS API CONTINUE', what, wasWaiting)
    }
    awsApiUser = what
    if (start) {
        busyTask = what
        concurrentCalls++
        if (concurrentCalls > 1) {
            prosLogErr('AWS concurrent calls', concurrentCalls)
        }
    } else {
        if (concurrentCalls > 0) {
            concurrentCalls--
            if (concurrentCalls > 0) {
                // Log only when have multiple operations queuing
                prosLogDt('<-- AWS API end', what)
            } else {
                // Check long query to poll server
                longQueryPoller()
            }
        } else {
            // end of transaction / release was called twice
        }
    }
    let busyState = getServerIfState()
    if (prevAwsInterfaceBusyState !== busyState) {
        prevAwsInterfaceBusyState = busyState
        if (waitUntilNotBusy) {
            clearTimeout(waitUntilNotBusy)
        }
        waitUntilNotBusy = setTimeout(refreshBusyNotifAfterIdle, 5)
    }
}

export function isAwsInterfaceBusy() {
    return concurrentCalls > 0
}

export function checkAwsApiException(e) {
    if (e && 'response' in e && e.response?.status === 401) {
        prosLogErr('Server responds unauthorized in', awsApiUser, "e:", e)
        appProdectLogout('Unauthorized')
    }
    prosLogErr(e);
}


// ============================================================================================================


// example call - just comma delimeted arguments
//          prosConnect.prosLogDt('abc', 123, item);
var prevDebugTimMs = 0;
export function prosLogClearDt(...args) {
    prevDebugTimMs = currentTimeMs();
    if (!DEBUG_LOG || !args) return;
    prosLogX(...args);
}

export function prosLogDtX(...args) {
    let ts = currentTimeMs();
    let d = new Date(ts);
    let timeStr = d.toISOString()
        .split('T')[1]
        .replace('Z', '');
    console.log(timeStr, 'dt:', ts-prevDebugTimMs, 'ms', ...args);
    prevDebugTimMs = ts;
}

export function prosLogDt(...args) {
    addToLogBuffer(...args)
    if (!DEBUG_LOG) return;
    prosLogDtX(...args);
}

export function dumpActiveProjectAttrs(title) {
    console.log('dumpActiveProjectAttrs: ' + title);
    if (!activeProject) { return }
    dumpObj(activeProject.attrs);
}

/**
 * Save browser initial query string
 */
var savedQueryString = ""
export function saveProsQueryString(queryString) {
    // prosLog("paramsString:", queryString)
    savedQueryString = queryString;
}

/**
 * For logging purposes
 * @returns {string}
 */
export function getSavedProsQueryString() {
    return savedQueryString
}

/**
 * Return parameter from saved browser url
 * @param paramName
 * @returns {string}
 */
function getSavedQueryParam(paramName) {
    let searchParams = new URLSearchParams(savedQueryString);
    return searchParams.get(paramName);
}

/**
 * App can be startwed with additional URL query parameters:
 *      ?link:<customerID>;<linkID>;<obsId>||<viewName>
 *          <customerID> identifies customer account - attr name in objects customer_group
 *          <linkID>     Link ID ( link obj_id in DB)
 *          <obsId>     optional OBS obj_id or OBS visual id like 23.45 (report 23, 45th obs)
 *          <viewName>  "dash_board" to show a dashboard using any project link object
 *      ?reqPerm:email=<email>
 *          <email>     Email of the person who requested access permission for a project
 * @returns {string|undefined}
 */
function getProjectWebLink() {
    let link = getSavedQueryParam('link')
    if (!link) link = getSavedQueryParam('reqPerm')
    if (!link) {
        clearProjectLinkAsInvalid()
        return undefined
    }
    let prevFailedLink = restoreConfigStr(SAVED_FAILED_LINK)
    return link !== prevFailedLink ? link : undefined
}

/**
 * Return true when opening link for dashbooard view
 */
export function isProjectDashboardLink() {
    let link = getSavedQueryParam('link')
    if (!link) {return false}
    const linkParams = link.split(";")
    return linkParams.length > 2 && linkParams[2] === "dash_board"
}

/**
 * Try to find obs from web link or when opened by float add
 * @param obsId     Either OBS obj_id or OBS identification number
 */
export function findObsById(obsId){
    if (!activeProject && activeProject.objs) {
        return undefined
    }
    prosLogClearDt()
    let obs = activeProject.objs.find(item => item[ATTR_OBS_ID] === obsId ||
                                              item[ATTR_OBJ_ID] === obsId)
    prosLogDt("Found OBS by ID", obsId, obs !== undefined)
    return obs
}

async function procedtAwsApiPost(data, who) {
    await reserveAwsApi(true, who)
    let result
    try {
        result = await API.post("prodect", '/webstore', {body: data})
    } catch (e) {
        checkAwsApiException(e)
        sessionExceptionDetected(who, 'Yhteysvirhe')
        prosLogErr(who, e)
    }
    await reserveAwsApi(false, who)
    return result
}

let lastRequestedPermission = undefined
export function userHasAnsweredToGrantRequest() {
    lastRequestedPermission = getSavedQueryParam('reqPerm')
    prosLog("userHasAnsweredToGrantRequest req:", lastRequestedPermission)
}

export async function linkGrantPermission(approved, role) {
    let permReqLink = getSavedQueryParam('reqPerm')
    if (!permReqLink) { return undefined }

    // User has already been prompted for this link request ?
    if (permReqLink === lastRequestedPermission) {
        return undefined
    }

    let requesterEmail = getSavedQueryParam('email')
    if (!requesterEmail) {
        return {errorCause: 'No email in req link'}
    }

    prosLog("linkToGrantPermission req:", permReqLink)
    let req = makeAwsReqParams(true)
    req.link = permReqLink
    req.for_user = requesterEmail
    req[ATTR_USER_ROLE] = role
    req[ATTR_WEB_OPERATION] = approved ?
        WEB_OPER_GRANT_PERM_LINK :
        WEB_OPER_GRANT_PERM_TEST_LINK

    let result = await procedtAwsApiPost([req], 'test perm link')

    prosLog('linkToGrantPermission result:', result)
    result.for_user = requesterEmail
    return result
}

function setProjectLinkAsInvalid() {
    // to avoid continuous error w/o browser refresh
    saveConfigStr(SAVED_FAILED_LINK, getSavedQueryParam('link'))
}

function clearProjectLinkAsInvalid() {
    // to avoid continuous error w/o browser refresh
    deleteConfigStr(SAVED_FAILED_LINK)
}

export function permissionToLinkAlreadyRequested() {
    let link = getSavedQueryParam('link')
    return link === restoreConfigStr(SAVED_PERM_REQ_LINK)
}

let savedPermissionLinkUsed = undefined
export function cancelRequestPermissionToFailedLink() {
    savedPermissionLinkUsed = getSavedQueryParam('link')
}

export function requestPermissionToFailedLinkUsed() {
    return savedPermissionLinkUsed === getSavedQueryParam('link')
}

export async function requestPermissionToFailedLink() {
    let link = getSavedQueryParam('link')
    if (!link) { return }

    let req = makeAwsReqParams(true)
    req.link = link
    req[ATTR_WEB_OPERATION] = WEB_OPER_REQ_PERM_LINK

    let response = await procedtAwsApiPost([req], 'req perm link')

    prosLog('requestPermissionToFailedLink result:', response)
    if (response.result === 'OK') {
        // to avoid continuous error w/o browser refresh
        cancelRequestPermissionToFailedLink()
        saveConfigStr(SAVED_PERM_REQ_LINK, link)
        return undefined
    }
    return response.errorCause ? response.errorCause : 'Unknown error'
}

export function getCustomerTestEmail() {
    return testingCustomerEmail;
}

export function setSuperUserMode(newMode, email) {
    isSuperUserInUse = newMode && isSuperUserModePossible();
    if (isSuperUserInUse) {
        saveConfigStr(SAVED_SUPERUSER, isSuperUserInUse)
    } else {
        deleteConfigStr(SAVED_SUPERUSER)
    }
    testingCustomerEmail = email;
    if (isSuperUserInUse) {
        console.log("Superuser mode activated for customer", email)
    } else {
        deactivateActiveProject()
        console.log("Superuser mode disabled")
    }
    return isSuperUserInUse;
}

let superUserOverridePermissions = false;
export function setSuperUserOverridePermissions(newMode) {
    superUserOverridePermissions = newMode;
}

export function isSuperUserOverridePermissionsInUse() {
    return isSuperUserModeInUse() && superUserOverridePermissions
}

var warnedAboutDebug = false;
function isDeveloperSpecialModeEnabled() {
    if (!warnedAboutDebug) {
        // warn to remind when deploying release not to forget dbg options
        if (DEBUG_LOG)                  console.warn("DEBUG_LOG enabled");
        if (DEBUG_LOG_SENDING_TO_AWS)   console.warn("DEBUG_LOG_SENDING_TO_AWS enabled");
        if (DEBUG_TO_SAVE_UI_LIST)      console.warn("DEBUG_TO_SAVE_UI_LIST enabled");
        if (DEBUG_MODE_TO_SAVE_SERVER_MSG) console.warn("DEBUG_MODE_TO_SAVE_SERVER_MSG enabled");
        if (DEBUG_EXTENDED_PERMISSIONS) console.warn("DEBUG_EXTENDED_PERMISSIONS enabled");
        warnedAboutDebug = true;
    }
    return DEBUG_EXTENDED_PERMISSIONS;
}

export function isSuperUserModePossible() {
    return userAccessRights === 'super';
}

export function isSuperUserModeInUse() {
    return (isSuperUserInUse && isSuperUserModePossible())
}

// export function hasExtendedAdminRights() {
//     if (isDeveloperSpecialModeEnabled()) return true;
//     return userAccessRights &&
//          ( userAccessRights === 'extended' ||
//            userAccessRights === 'super' )
// }

var isUserDeveloper = false
export function userHasDebugMenu() {
    return DEBUG_MENU ||
        isSuperUserModePossible() ||
        isUserDeveloper
}

export function getUserAdminCustomers() {
    return userAdminCustomers
}

export function isCustomerHeadAdmin() {
    let customerMainAdminEmails = activeProject ? activeProject.getAttr(ATTR_CUSTOMER_ADMIN_EMAILS) : ""
    return customerMainAdminEmails.indexOf(getUserEmail(true)) >= 0 ||
        isSuperUserModeInUse()
}

export function filterSpecialChars(txt) {
    if (txt === "?#?") return "";
    return txt.replace(/[#;]/g, ' ');
}

export function replaceAll(target, search, replacement) {
    if (target) {
        return target.replace(new RegExp(search, 'g'), replacement);
    } else {
        return undefined
    }
}

export function fixNewLineForUi(txt) {
    return replaceAll(txt, '<br>', '\n');
}



// Licensed features
export const FEAT_PROMPT_REPORT_REC = "feat_promptReportReceiver"
export const FEAT_WEB_UPDATED = "feat_webUpdatedReport"
export const FEAT_WEB_ACTIVE = "feat_webActiveReport"
//const FEAT_SHOW_SEARCH_LIST = "feat_showSearchList"
export const FEAT_SHOW_OBS_INFO = "feat_showObsInfo"
export const FEAT_CHANGE_ITEM_TYPE = "feat_mayChangeItemType"
export const FEAT_EXCEL_IMPORT = "feat_excelImport"
export const FEAT_EXCEL_EXPORT = "feat_excelImport"
export const FEAT_SHOW_SENT_REPORTS = "feat_showSentReports"
export const FEAT_SET_PROJECT_LOGO = "feat_editProjectLogo"
export const FEAT_SET_RESTRICTED_ACCESS = "feat_editRestrictedAcecssRights"
export const FEAT_MAX_MV_OPTIONS = "feat_numMultivalueOptions"
export const FEAT_MAX_ON_OFF = "feat_numOnOff"
export const FEAT_MAX_MV = "feat_numMultivalue"
export const FEAT_MAX_TEXT_FIELDS = "feat_numTextFields"
export const FEAT_SET_MANDATORY = "feat_editMandatorySettings"
export const FEAT_MAX_USERS = "feat_numUsers"
const FEAT_MAX_TEMPLATES = "feat_maxTemplates"
export const FEAT_MAX_ITEMS = "feat_maxItems"
export const MAX_ITEMS_DEFAULT = 200000
export const FEAT_SHOW_TABLE = "feat_showTable"
export const FEAT_SHOW_TIME_MATRIX = "feat_showTimeMatrix"
export const FEAT_MAX_SEARCH_COUNT = "feat_maxSearchCount"
export const FEAT_JSON_EXPORT = "feat_jsonExport"
export const FEAT_SHARE_TABLE_LINK = "feat_sendTableReport"
export const OBJ_TYPE_LICENSE_LEVEL = 'lic_level'
export const ATTR_LICENSE_LEVEL = OBJ_TYPE_LICENSE_LEVEL

/*
export const OBJ_TYPE_LICENSE_FEATURE = 'lic_feature'
export const ATTR_DEF_VAL = 'def_value'
export const ATTR_INHERITED_LEVEL = 'inherited_level'
export const ATTR_FEAT_PREFIX = 'feat_'
export const ATTR_MY_PRODECT_OWNER = 'my_prodect_owner'
*/

// 1.10.2021 - FEAT_WEB_ACTIVE is considered to be removed - anyway set by default as not enabled
const FEAT_DEFAULT_DISABLED = [FEAT_WEB_ACTIVE]

export function featureEnabled(featureId) {
    if (!activeProject) {
        return false
    }
    let defaultEnabled = !FEAT_DEFAULT_DISABLED.includes(featureId)
    if (defaultEnabled) {
        if (activeProject.getAttr(featureId) === STR_NO) {
            return false
        }
        return true
    } else {
        return activeProject.getAttr(featureId) === STR_YES
    }
}

export function featureLimit(featureId,  defaultValue) {
    if (!activeProject) {
        return defaultValue;
    }
    let attrValue = activeProject.getAttr(featureId)
    if (attrValue !== STR_NO_VALUE) {
        return parseInt(attrValue)
    }
    return defaultValue
}


export function objClass(obj) {
    return obj[ATTR_OBJ_TYPE].substr(0,3);
}

function attrForUiOnly(attr) {
    // filter out attributes created by rendering ui
    if (ATTRS_FOR_UI_ONLY.indexOf(attr) >= 0) {
        return true;
    }
    return attr.indexOf("ui_") === 0;
}

export function isProsItemEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) {
        return false
    }
    for (let key of keys1) {
        if (getValidAttr(object1, key, STR_NO_VALUE) !==
            getValidAttr(object2, key, STR_NO_VALUE)) {
            return false
        }
    }
    return true
}

/**
 * Simple safe deep copy (until/considering to include underscrore lib)
 * @param obj
 * @returns {any}
 */
export function deepCopyObj(obj) {
    if (!obj) {return undefined}
    let jsonStr = JSON.stringify(obj);
    return JSON.parse(jsonStr);
}

/**
 * Copy DB data object
 * @param attrs     Attributes to be copied for new object
 * @param removeId  True to remove unique attributes, False to make an "complete copy" for sending to AWS
 * @returns {*}     Object with copied attributes
 */
export function makeObjCopyForAws(attrs, removeId) {
    const REMOVE_ATTRS_WHEN_NO_ID = [ATTR_OBJ_ID, ATTR_AGE,
        ATTR_CREATED_MS_I, ATTR_CREATED_BY, ATTR_CREATED_STR, ATTR_UPDATED_MS_I, ATTR_UPDATED_BY,
        ATTR_OBS_ID, ATTR_OBS_HISTORY, ATTR_PARENT_OBS, ATTR_REPORT_INDEX,
        ATTR_ARCHIVE_ID, ATTR_LAST_ARCHIVED_MS, ATTR_ARCHIVE_ZIP_IND,
        ATTR_INFO_COPY_FROM_PID, ATTR_COPY_FROM_REPORT]
    let copyObj = {};
    for (let key in attrs) {
        if (removeId && REMOVE_ATTRS_WHEN_NO_ID.includes(key)) {
            // filter out id as it will be created for new objs by ProsConnect for new items when sending
            // filter also those attributes that are not not to be copied when making an "object copy"
            continue;
        }
        if (attrForUiOnly(key)) {
            // Attributes for UI will not be copied "uiIsOpen", list of children etc
            continue;
        }
        if (key === ATTR_REPORT_INDEX &&
            !(isReportType(attrs) || attrs[ATTR_OBJ_TYPE] === OBJ_TYPE_PRJ)) {
            // filter out report index from other than project and report
            continue;
        }
        if (key === ATTR_TEXT && !attrs[key]) {
            copyObj[key] = STR_NO_VALUE
        } else {
            copyObj[key] = attrs[key];
        }
    }
    return deepCopyObj(copyObj)
}

function copyProsObjs(srcObjs) {
    // Make a new shallow copy obj copying attributes to avoid sharing mutable "runtime DB"
    return srcObjs.map(srcObj => Object.assign({}, srcObj))
}

export function copyJsObj(srcObj) {
    // Make a new shallow copy obj
    return Object.assign({}, srcObj)
}

function updateExistingObjAttrs(dstAttrs, srcAttrs) {
    let cnt = 0;
    for (let attr in srcAttrs) {
        if (dstAttrs.hasOwnProperty(attr)) {
            if (dstAttrs[attr] !== srcAttrs[attr] && !dstAttrs.is_example) {
                cnt++;
                prosLog('updateExistingObjAttrs()',
                    attr, dstAttrs[attr], '->', srcAttrs[attr], 'count:', cnt);
                dstAttrs[attr] = srcAttrs[attr];
            }
        }
    }
    return cnt;
}

export function currentTimeMs() {
    return Date.now()
}
export function datePickerReturnValueToMillisec(dateText) {
    if (!dateText) return 0
    let date = new Date(dateText)
    return date.getTime()
}

// datepicker requires date in format yyyy-mm-dd
export function millisecToDatePicker(ms) {
    function twoDigit(num) {
        let str = String(num)
        return str.length < 2 ? '0' + str : str
    }
    function fourDigit(num) {
        let str = String(num)
        return str.length < 2 ? '000' + str :
            str.length < 3 ? '00' + str :
                str.length < 4 ? '0' + str :
                    str
    }
    if (!ms || ms === NO_DATE_STR) {
        return ''
    }
    let date = new Date(ms)
    return fourDigit(date.getFullYear()) + '-' + twoDigit(date.getMonth() + 1) + '-' + twoDigit(date.getDate())
}
let prevMonotonicTime = 0
/**
 * Get a monotonic timestamp for this device - used for unique sort order
 * @returns {number}
 */
export function getMonotonicTimeMs() {
    let monotonicTime = currentTimeMs()
    if (monotonicTime < prevMonotonicTime + MINIMUM_SORT_ORDER_SPACING) {
        monotonicTime = prevMonotonicTime + MINIMUM_SORT_ORDER_SPACING
    }
    prevMonotonicTime = monotonicTime
    return monotonicTime
}

// Ensure unique ID when creating multiple object at same time
var makeIdUnique = 0;
export function makeNewObjId(objId) {
    let listId = getObjListIdFromItemId(objId);
    makeIdUnique++;
    return listId + '_' + getDevId() + '_' + (currentTimeMs() + '_' + makeIdUnique);
}

export function getProjectUsersListId(pid) {
    return PREFIX_PROJ_USERS + pid;
}

// export function currentTimeToUtcString(showSec) {
//     let today = new Date();
//     let dateStr = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
//     let timeStr = today.getHours() + ":" + today.getMinutes();
//     if (showSec) {
//         timeStr +=  ":" + today.getSeconds()
//     }
//     return dateStr + ' ' + timeStr;
// }

function getLocalToUtcTimeOffsetMs() {
    let d = new Date();
    let tzOffsetSec = -d.getTimezoneOffset() * 60;
    return tzOffsetSec * 1000;
}

function isActive(obj) {
    return obj[ATTR_OBJ_STATE] === OBJ_STATE_ACT ||
           obj[ATTR_OBJ_STATE] === OBJ_STATE_WAIT;
}

export function isWaitingThumpNail(obj) {
    return obj[ATTR_OBJ_STATE] === OBJ_STATE_WAIT
}

export function getObjListIdFromItemId(itemId) {
    if (itemId) {
        if (itemId.indexOf('_') > 0) {
            // list/report item
            return itemId.split('_')[0];
        }
        // list/report
        return itemId;
    }
    prosLogErr("getObjListIdFromItemId() itemId missing");
}

export function getObjListId(obj) {
    return getObjListIdFromItemId(obj[ATTR_OBJ_ID]);
}

function saveProsSettings(settings) {
    prosSettings = settings;
    let str = JSON.stringify(settings);
    saveConfigStr(SAVED_SETTINGS, str);
}

var prosSettings = null;
function restoreProsSettings() {
    if (prosSettings) {
        return;
    }
    let str = restoreConfigStr(SAVED_SETTINGS);
    if (str) {
        prosSettings = JSON.parse(str);
    }
}

var localSettings = null;
function restoreLocalSettings() {
    if (!localSettings) {
        let str = restoreConfigStr(SAVED_LOCAL_SETTINGS);
        if (str) {
            localSettings = JSON.parse(str);
        }
    }
}

/*
function getLocalSetting(paramId, defVal) {
    restoreLocalSettings();
    if (localSettings && localSettings.hasOwnProperty(paramId)) {
        prosLog('getLocalSetting()', paramId, defVal, '->', localSettings[paramId]);
        return localSettings[paramId];
    }
    prosLog('getLocalSetting()', paramId, defVal, '-> defVal:', defVal);
    return defVal;
}
*/

function saveLocalSetting(paramId, value) {
    restoreLocalSettings();
    if (!localSettings) {
        localSettings = {};
    }
    localSettings[paramId] = value;
    let str = JSON.stringify(localSettings);
    prosLog('saveLocalSettings()', paramId, value, '=>',str);
    saveConfigStr(SAVED_LOCAL_SETTINGS, str);
}

var lastTimeCheckedGloRefMs = 0;
var lastTimeCheckedGloRef = undefined;
export function getGlobalRef(remove) {
    if (!remove && currentTimeMs() - lastTimeCheckedGloRefMs < 1000) {
        // local cache not to poll local storage for rendering each ui element
        return lastTimeCheckedGloRef;
    }
    lastTimeCheckedGloRefMs = currentTimeMs();
    let refStr = restoreConfigStr(SAVED_GLOBAL_TRANSFER);
    if (refStr) {
        lastTimeCheckedGloRef = JSON.parse(refStr);
        if (remove) {
            lastTimeCheckedGloRefMs = 0;
            delete lastTimeCheckedGloRef.ui_globalCopy;
            markGlobalRef(null, false)
        }
    } else {
        lastTimeCheckedGloRef = undefined;
    }
    return lastTimeCheckedGloRef;
}

export function getGlobalRefMode(isCopy) {
    let refObj = getGlobalRef();
    return refObj && isCopy === refObj.ui_globalCopy;
}

export function markGlobalRef(obj, isCopy) {
    if (!obj) {
        prosLog('REMOVE global transfer');
        deleteConfigStr(SAVED_GLOBAL_TRANSFER);
    } else if (isObservation(obj)) {
        obj.ui_globalCopy = isCopy;
        obj[ATTR_AWS_PROJECT_ID] = activeProject.getPid();
        let str = JSON.stringify(obj);
        prosLog('SAVE global transfer', str.substr(0, 100));
        saveConfigStr(SAVED_GLOBAL_TRANSFER, str);
    } else {
        // only local copy and move for other than OBS
    }
    projectLoader.refreshUi("markGlobalRef")
}

export function getDevId() {
    restoreProsSettings();
    if (prosSettings && prosSettings.hasOwnProperty(ATTR_DEVICE_ID)) {
        return prosSettings[ATTR_DEVICE_ID];
    }
    return 'no_id';
}

export function sortAndCacheProjects(projects) {
    if (Array.isArray(projects) && (projects.length > 0)) {
        if (projects[0][ATTR_OBJ_TYPE] === OBJ_TYPE_PROS_PARAM) {
            // First time connected - got settings i.e. device id
            saveProsSettings(projects[0]);
            prosLog("Pros settings from server", prosSettings);
            projects.splice(0, 1);
        }
        if (projects[0][ATTR_OBJ_TYPE] === USER_SETTINGS_PROJECT_ORDER) {
            // When user have saved project order that is in the beginning of project list
            savedUserSettingsProjectOrder = projects[0][USER_SETTINGS_PROJECT_ORDER]
            projects.splice(0, 1);
        }
        projects.sort((a, b) => a[ATTR_SORT_ORDER_I] - b[ATTR_SORT_ORDER_I]);
        // takes some time until server has removed users project obj
        // locally avoid showing those "removal ongoing" until then
        return projects.filter(project => recentlyRemovedProjects.indexOf(project[ATTR_AWS_PROJECT_ID]) < 0);
    } else {
        prosLog('No projects - response', projects);
        return []
    }
}

export function resetViewToDefault(){
    deactivateActiveProject()
    userProjectList = undefined
    projects = undefined
    deleteConfigStr(SAVED_SELECTED_PROJECT)
    deleteConfigStr(SAVED_MAIN_VIEW)
    deleteConfigStr(SAVED_REPORT_VIEW)
}

export function clearByLogout(clearAllSettings) {
    userHasAcceptedTerms = false
    userAccessRights = undefined
    userAdminCustomers = []
    isUserDeveloper = false
    deleteConfigStr(SAVED_LOCAL_SETTINGS)
    deleteConfigStr(SAVED_UNSELECTED_REPORTS)
    projects = undefined
    deactivateActiveProject()
    userProjectList = undefined
    if (clearAllSettings) {
        deleteConfigStr(SAVED_EMAIL)
        deleteConfigStr(SAVED_SELECTED_PROJECT)
    }
    prosLog('clearByLogout() clearAllSettings:', clearAllSettings)
}

/**
 * Returns email of the user or <testAccount>;<superuserEmail> when test account in use
 * @param forceOwn  - real user email - not another user's test account
 * @returns {string|undefined} email or undefined when user is not logged in
 */
export function getUserEmail(forceOwn) {
    let ownEmail = restoreConfigStr(SAVED_EMAIL)
    ownEmail = ownEmail ? ownEmail.toLowerCase(): undefined
    if (!forceOwn && isSuperUserModePossible() && testingCustomerEmail !== '') {
        return testingCustomerEmail  + ';' + ownEmail
    }
    if (!ownEmail) {
        return undefined
    }
    return ownEmail
}

export function setUserEmail(email) {
    return saveConfigStr(SAVED_EMAIL, email.toLowerCase())
}

export function getUserName() {
    let name = restoreConfigStr(SAVED_NAME)
    if (name) {
        return name
    }
    let email = getUserEmail(true)
    if (email) {
        return email.split('@')[0].replace('.', ' ')
    }
    return undefined
}

export function setUserName(name) {
    return saveConfigStr(SAVED_NAME, name)
}

function getNavigatorVersion() {
    try {
        var ua = navigator.userAgent, tem,
            M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []
        if (/trident/i.test(M[1])) {
            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE ' + (tem[1] || '')
        }
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
            if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera')
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
        return M.join(' ')
    } catch (e) {
        return '?'
    }
}

export function makeAwsReqParams(forceOwn=true, operation=undefined) {
    let req = {
        if_vers: AWS_WEB_IF_VERSION,
        report_vers: AWS_WEB_REPORT_VERSION, // TODO Is this used
        webui_vers: PRODECT_SW_FULL_VERSION,
        device_id: getDevId(),
        tz_offset_ms: getLocalToUtcTimeOffsetMs(),
        user_name: getUserName(),
        email: getUserEmail(forceOwn),
        browser_version: getNavigatorVersion(),
        originator: "web-ui",
    }
    if (operation) {
        req[ATTR_WEB_OPERATION] = operation
    }
    return req
}


var cachedProjectForName = {};

function cacheProjectName(project) {
    cachedProjectForName[ATTR_AWS_PROJECT_ID]   = project[ATTR_AWS_PROJECT_ID];
    cachedProjectForName[ATTR_TEXT]     = project[ATTR_TEXT];
    cachedProjectForName[ATTR_MAIN_PROJECT_NAME] = project[ATTR_MAIN_PROJECT_NAME];
}

// Used to set main and subproject name from just loaded project as server may have not update user prokject objs
// when project name have just been changed.  Don't do this for "Example projects" aka "library projects"
function updateCachedProjectName(projects) {
    for (let project of projects) {
        if (cachedProjectForName[ATTR_AWS_PROJECT_ID]  === project[ATTR_AWS_PROJECT_ID] &&
            !project.is_example) {
            project[ATTR_TEXT]              = cachedProjectForName[ATTR_TEXT];
            project[ATTR_MAIN_PROJECT_NAME] = cachedProjectForName[ATTR_MAIN_PROJECT_NAME];
        }
    }
}


//var simulateSignoutByErrorCounter = 1
async function awaitLoadProjectsFromServer() {
    isDeveloperSpecialModeEnabled();
    projectLoader.refreshUserIsActive();
    if (!getUserEmail()) {
        prosLogErr('awaitLoadProjects() try to load before email');
        return undefined
    }
    prosLogClearDt('awaitLoadProjects() projects loading..');
    if (!userAccessRights) {
        if (!USE_PRODUCTION_SERVER) {
            console.log("NOTE - using test server", config.apiGateway.REGION, " - NOT production!")
        }
        if (isSuperUserModePossible()) {
            console.log("You are superuser")
        }
        let response =  await getProsAccessRights();
        prosLog("getProsAccessRights()", response);
        if (response && response.hasOwnProperty('result') && response.result === 'OK') {
            prosLog("User Terms OK")
            userAccessRights = response.access
            isUserDeveloper = response.is_developer
            userAdminCustomers = response.user_admin_customers ?? undefined
            userHasAcceptedTerms = response.hasOwnProperty('user_accepted') &&  response.user_accepted > 0
        } else {
            prosLogWrn("User terms not accepted. Response: ", response)
            userAccessRights = undefined
            userHasAcceptedTerms = false
            userAdminCustomers = []
        }
    } else {
        prosLog("UserAccessRights: ", userAccessRights, " userHasAcceptedTerms: ", userHasAcceptedTerms)
    }
    try {
        await reserveAwsApi(true, 'GET projects')
        projects = await API.get("prodect",
            '/websynch?email=' + getUserEmail()
            +'&id=' + getDevId()
            //+'&project=list_user_projects3'   // use this to test in production before have a newer server Lambda
            +'&project=list_user_projects3'
            +'&report=none');
        // this can be used to simulate handling signout due to network error w/o breaking network connection
        // if (Array.isArray(projects) && simulateSignoutByErrorCounter++ % 4 !== 0) {
        if (Array.isArray(projects)) {
            await reserveAwsApi(false, 'GET projects')
            projectsLastUpdatedMs = currentTimeMs();
            prosLogDt('awaitLoadProjects() projects loaded - sorting, count:', projects.length);
            updateCachedProjectName(projects);
            projects = sortAndCacheProjects(projects);
            if (DEBUG_MODE_TO_SAVE_SERVER_MSG) {
                dumpObjToJsonFile(projects, 'esim-kaikki-projektit');
            }
            saveLocalSetting('lastTimeLastUpdatedProjectsMs', currentTimeMs());
            return projects;
        }
    } catch (e) {
        prosLogErr(e);
    }
    await reserveAwsApi(false, 'GET projects-failed')
    sessionExceptionDetected('Proj-1', 'Projektiluettelon haku epäonnistui')
    return []
}


export function getCurrentProjectList() {
    return userProjectList
}

export function flushProjectList() {
    userProjectListLastUpdatedMs = 0
}

var uiWantProjectListNotif = [];
export function subscribe_notifyProjectListUpdated(ui, name) {
    let subscriber = uiWantProjectListNotif.find(subs =>  subs.ui === ui);
    if (!subscriber) {
        uiWantProjectListNotif.push({
            ui: ui,
            name: name
        });
    }
}

export function unsubscribe_notifyProjectListUpdated(ui, name) {
    let uiIndex = uiWantProjectListNotif.findIndex(subs => subs.ui === ui);
    if (uiIndex >= 0) {
        uiWantProjectListNotif.splice(uiIndex,1);
    } else {
        prosLogWrn("UI not subscribed project refresh", name);
    }
}

function notifyProjectListSubscribers() {
    for (let subscriber of uiWantProjectListNotif) {
        subscriber.ui.notifyProjectListUpdated()
    }
}

export async function awaitGetProjects(forceFetch) {
    if (forceFetch) {
        recentlyRemovedProjects.length = 0
    }
    if (forceFetch || !userProjectList
        || currentTimeMs() - userProjectListLastUpdatedMs > USER_PROJECT_LIST_CASHE_AGING_MINUTES * 60000) {
        userProjectListLastUpdatedMs = currentTimeMs()
        prosLogDt('awaitGetProjects()- loading')
        userProjectList = await awaitLoadProjectsFromServer()
        if (userProjectList) {
            prosLogDt('awaitGetProjects()- count', userProjectList.length)
            notifyProjectListSubscribers()
        }
    }
    return userProjectList
}

async function getSystemParameters() {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_SYSTEM_PARAMETERS
    let response = await procedtAwsApiPost([req], WEB_OPER_GET_SYSTEM_PARAMETERS)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK' &&
        response.hasOwnProperty('sys_params')) {
        return response.sys_params
    }
    sessionExceptionDetected("sys-params", 'Järjestelmäparametrien haku epäonnistui')
}

export async function getProjectTemplates() {
    let sysParams = await getSystemParameters()
    if (!sysParams) {
        prosLogErr('Failed to get system parameters from server')
        return []
    }
    let templatesStrs = sysParams["templates"].split(';;')
    let templates = []
    let limitNumOfTemplates = featureLimit(FEAT_MAX_TEMPLATES, 999)
    for (let i in templatesStrs) {
        if (i >= limitNumOfTemplates) {
            break
        }
        let strs = templatesStrs[i].split(';')
        templates.push({
            name: strs[0],
            id: strs[1]
        })
    }
    return templates
}

export async function getCustomerSettings(customerGroup) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_CUSTOMER_INFO
    req[ATTR_CUSTOMER_GROUP] = customerGroup
    let response = await procedtAwsApiPost([req], WEB_OPER_GET_CUSTOMER_INFO)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK' &&
        response.hasOwnProperty('customer_info')) {
        return response.customer_info
    }
    prosLogErr("Failed to get customer settings", response)
    sessionExceptionDetected("customer-1", 'Asiakastietojen haku epäonnistui')
}

export async function saveCustomerSettings(customerGroup, customer_info) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_SAVE_CUSTOMER_INFO
    req[ATTR_CUSTOMER_GROUP] = customerGroup
    let response = await procedtAwsApiPost([req, customer_info], WEB_OPER_SAVE_CUSTOMER_INFO)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK') {
        return
    }
    sessionExceptionDetected("customer-2", 'Asiakastietojen tallennus epäonnistui')
    prosLogErr("Failed to save customer settings", response)
}

export async function getCustomerMainPrjHelp(main_prj_id, for_help_desk = true) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_CUSTOMER_MAIN_PROJ_HELP
    req[ATTR_MAIN_PROJ_ID] = main_prj_id
    req['for_help_desk'] = for_help_desk ? STR_YES : STR_NO
    let response = await procedtAwsApiPost([req], WEB_OPER_GET_CUSTOMER_MAIN_PROJ_HELP)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK' &&
        response.hasOwnProperty('project_help')) {
        return response.project_help
    }
    prosLogErr("Failed to get project help", response)
    sessionExceptionDetected("project-help-1", 'Projektin ohjeiden haku epäonnistui')
}

export async function saveCustomerMainPrjHelp(main_prj_id, customerHelp) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_SAVE_CUSTOMER_MAIN_PROJ_HELP
    req[ATTR_MAIN_PROJ_ID] = main_prj_id
    let response = await procedtAwsApiPost([req, customerHelp], WEB_OPER_SAVE_CUSTOMER_MAIN_PROJ_HELP)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK') {
        return
    }
    sessionExceptionDetected("project-help-2", 'Projektin ohjeiden tallennus epäonnistui')
    prosLogErr("Failed to save project help", response)
}

let activeMainProject
export async function getMainProject(main_prj_id, force_new= false) {
    if ( ! force_new &&
        activeMainProject &&
        activeMainProject.hasOwnProperty(ATTR_OBJ_ID) &&
        activeMainProject.obj_id === main_prj_id) {
        return activeMainProject
    }
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_PROJECT
    req[ATTR_MAIN_PROJ_ID] = main_prj_id
    let response = await procedtAwsApiPost([req], WEB_OPER_GET_PROJECT)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK') {
        if (response.hasOwnProperty('project')) {
            return response.project
        }
        return false
    }
    sessionExceptionDetected("main-project-get-1", 'Projektin haku epäonnistui')
    prosLogErr("Failed to get main project", response)
}

// Get customer configs by objType. Type is e.g. OBJ_TYPE_PDF_FRONTPAGE
export async function getCustomerConfigs(customerGroup, objType) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_CUSTOMER_CONFIGS
    req[ATTR_CUSTOMER_GROUP] = customerGroup
    req[ATTR_OBJ_TYPE] = objType
    let response = await procedtAwsApiPost([req], WEB_OPER_GET_CUSTOMER_CONFIGS)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK' &&
        response.hasOwnProperty('customer_configs')) {
        return response.customer_configs
    }
    prosLogErr(`Failed to get customer config '${objType}'`, response)
    sessionExceptionDetected("customer-config-1", `Asiakaskonfiguraation '${objType}' haku epäonnistui`)
}

// Save customer config data by name and objType. Type is e.g. OBJ_TYPE_PDF_FRONTPAGE,
// When saving new one, existingPdfObj is null but when editing existing it's having IDs
export async function saveCustomerConfig(customerGroup, objType, existingObj, name, customerConfigData) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_SAVE_CUSTOMER_CONFIG
    req[ATTR_CUSTOMER_GROUP] = customerGroup
    req[ATTR_OBJ_TYPE] = objType
    if (existingObj) {
        req[ATTR_AWS_PROJECT_ID] = existingObj[ATTR_AWS_PROJECT_ID]
        req[ATTR_OBJ_ID] = existingObj[ATTR_OBJ_ID]
    }
    req[ATTR_TEXT] = name
    let response = await procedtAwsApiPost([req, customerConfigData], WEB_OPER_SAVE_CUSTOMER_CONFIG)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK') {
        return
    }
    sessionExceptionDetected("customer-config-2", `Asiakaskonfiguraation '${objType}' tallennus epäonnistui`)
    prosLogErr(`Failed to save customer config '${objType}'`, response)
}

export async function deleteCustomerConfig(customerGroup, objType, obj) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_DEL_CUSTOMER_CONFIG
    req[ATTR_CUSTOMER_GROUP] = customerGroup
    req[ATTR_OBJ_TYPE] = objType
    req[ATTR_AWS_PROJECT_ID] = obj[ATTR_AWS_PROJECT_ID]
    req[ATTR_OBJ_ID] = obj[ATTR_OBJ_ID]
    let response = await procedtAwsApiPost([req], WEB_OPER_DEL_CUSTOMER_CONFIG)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK') {
        return
    }
    sessionExceptionDetected("customer-config-2", `Asiakaskonfiguraation '${objType}' tallennus epäonnistui`)
    prosLogErr(`Failed to save customer config '${objType}'`, response)
}

export async function validateCampaignCode(campaignCode) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_VALIDATE_CAMPAIGN_CODE
    req['campaign_code'] = campaignCode
    let response = await procedtAwsApiPost([req], WEB_OPER_VALIDATE_CAMPAIGN_CODE)
    if (response &&
        response.hasOwnProperty('result')) {
        return response
    }
    prosLogErr(WEB_OPER_VALIDATE_CAMPAIGN_CODE, "failed, response:", response)
}

/***********************************************************************************
 * When app is started after authentication the following steps will be
 * done been sequentially:
 * 1- load project list loaded - if user has no projects startup is cancelled
 *    estimated time to load active projects ~200 ms (archived projects loaded by ui)
 *    Before loading projects get from server user status about accepted terms
 *    and possible special role
 * 2a - "cold start" / no project been selected or local storage cleared -> exit
 * 2b - when started by an url query link load project, report selections and
 *          ui settings from server (~50 ms)
 * 2c - or when started w/o link use last selected project
 * 2d - user have not accepted service terms load that project
 * 3- select and activate project by id - not yet loading project data
 * 4- load project items 1st set - that is enough for UI to show data
 *      - remaining items will be loaded in background asynchronously and incrementally
 *      and thus such UI components that are showing reports or observations
 *      should subscribe to notified by a uiRefresh() when more data has been fetched
 *      Project loader informs loading steps - ref projectLoader.subscribe_notifyProjectLoad(cb)
 ***********************************************************************************/

let savedProjectLink;
let linkSettings;
let firstTimeAfterLogin = true;
let prodectStarted = false;
let userHasAcceptedTerms = false;

export function hasProdectStarted() {
    return prodectStarted
}

export function hasUserAcceptedTerms() {
    return userHasAcceptedTerms
}

export async function awaitUserAcceptedTerms() {
    prosLog("User accepted terms")
    userHasAcceptedTerms = true
    // deactivate user conditions project
    deactivateActiveProject()

    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_USER_ACCEPTED_TERMS

    await procedtAwsApiPost([req], 'accept terms')
}

// Returns true when Prodect startup steps been executed
// export function hasProdectStarted() {
//     return prodectStarted
// }

export async function awaitStartProdect() {
    // Clear possible global transfer in localstorage when started
    // used for data exchange between two browser instances
    deleteConfigStr(SAVED_GLOBAL_TRANSFER)

    prodectStarted = await awaitStartProdectSteps()
    projectLoader.refreshUi("awaitStartProdect")
    prosLogDt('START-4 - project loaded')
    return prodectStarted
}

export async function awaitStartProdectSteps() {
    // Return true when succeeded - false when user do not have access to projects
    // Load projects - before loading projects also checks
    //      - user's special access mode super|extended|normal set to userAccessRights
    //      - user has accepted service usage terms
    if (firstTimeAfterLogin || !haveProjects()) {
        prosLogDt('START-0')
        await awaitGetProjects(false);
        if (!haveProjects()) {
            return false
        }
        firstTimeAfterLogin = false
    }
    prosLogDt('START-1 - have projects')
    if (userHasAcceptedTerms) {
        getSuperUserModeFromSession()
        return loadDefaultProject()
    }
    prosLogDt('START-2d load terms project')
    return await projectLoader.awaitLoadProjectObjects('TERMS', 'start', true)
}

async function loadDefaultProject() {
    let hasValidUrlLink = await awaitCheckIfStartByProjectLinkUrl()
    let projectId = hasValidUrlLink ? linkSettings[ATTR_PROJECT_LINK] : getSelectedProject()
    if (!projectId) {
        prosLogDt('START-2a - project not selected')
        return true
    }
    if (!selectProjectById(projectId)) {
        prosLogDt('START-2a - prev selected pid not in project list')
        return true
    }
    return await projectLoader.awaitLoadProjectObjects(projectId, 'start')
}

export function getProjectLinkSettings() {
    return linkSettings
}

// To validate that an object has required attributes
function hasRequiredAttributes(obj, attrs) {
    return !attrs.find( attr => !obj.hasOwnProperty(attr))
}

export function isBookMarkValid(bookMark) {
    return hasRequiredAttributes(bookMark, MANDATORY_ATTRS_FOR_PROJECT_LINK)
}

// Need just one bookmark listener
let bookMarksListener = undefined
export function subscribeToBookmarksChanged(handleBookmarksUpdated, viewMode) {
    // prosLogX('book mark subscribed by', viewMode)
    bookMarksListener = {viewMode: viewMode, callBack:handleBookmarksUpdated}
    deferredLoadBookMarks(false)
}

export function unSubscribeToBookmarksChanged(viewMode) {
    // prosLogX('unSubscribe Bookmarks by', viewMode)
    bookMarksListener = undefined
}

/**
 * Get unique composite ID for long query containing email, device id and resource id
 * @param resourceId    Query specific resource id
 * @returns {string}    An unique user and device specific resource id
 */
export function getUniqueCacheIdWithUserAndDeviceId(resourceId) {
    return getUserEmail(true) + ';' + getDevId() + ';' + resourceId
}

/**
 * Server keeps track of ongoing queries and polls server to get result or updated data for long lasting queries.
 * Long query clients shall prove an unique id
 */
const LONG_QUERY_TIMER_INTERVALL_MS = 1000
const DEFAULT_LONGQ_PERIOD = 300*1000
let longQueries = []
let longPollTimer = undefined
let lastPolledInd = 1000

// Make a single long query - returns a promise
async function longPollQuery(query, continuePolling) {
    function saveLongQueryResponseParam(query, serverParam, localParam) {
        if (response.hasOwnProperty(serverParam)) {
            query[localParam] = response[serverParam]
        } else {
            prosLogErr("Missing long query param", serverParam, "query:", query)
        }
    }
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_QUERY
    req[ATTR_CACHE_ID] = query.cacheId
    req[ATTR_QUERY_TYPE] = query.queryType
    req[ATTR_QUERY_TIME_KEY] = query.timeKey
    // Query message is a list in which first item has operation parameters and 0..N
    // following items are optional parameters related to query.
    let itemsForServer = query.queryParams ? [req].concat(query.queryParams) : [req]
    longQueryOngoing = true
    let response = await procedtAwsApiPost(itemsForServer, WEB_OPER_QUERY)
    let existingQuery = longQueries.find(q => q.id === query.id)
    if (!existingQuery) {
        // Ignore response as UI query has been stopped and thus is no longer active
        return
    }
    longQueryOngoing = false
    query.lastPolled = currentTimeMs()
    if (response && response.hasOwnProperty('result') && response.result === 'OK') {
        saveLongQueryResponseParam(query, ATTR_QUERY_POLL_PERIOD_MS, 'pollPeriodMs')
        saveLongQueryResponseParam(query, ATTR_QUERY_IS_FRESH, 'isFresh')
        saveLongQueryResponseParam(query, ATTR_QUERY_TIME_KEY, 'timeKey')
        if (response[ATTR_QUERY_DATA]) {
            // Call client
            query.callBack(response[ATTR_QUERY_DATA], query.isFresh, response[ATTR_LAST_UPDATED])
        }
        if (continuePolling) {
            longQueryPoller()
        }
    } else {
        prosLogErr("Long query failed with response", response)
        stopLongQuery(query.id)
    }
}

/**
 * Timing controller for long query polling
 * When AWS RES-API is not in use poll one pending query which polling time has expired
 */
function longQueryPoller() {
    let checkCount = 0
    if (isAwsInterfaceBusy()) {
        // no polling when AWS i/f is in use
        return
    }
    if (longQueries.length < 0) {
        checkNeedQueryTimer()
        return
    }
    while (checkCount < longQueries.length) {
        checkCount += 1
        lastPolledInd += 1
        if (lastPolledInd >= longQueries.length) {
            lastPolledInd = 0
        }
        let query = longQueries[lastPolledInd]
        if (query) {
            if (currentTimeMs() - query.lastPolled > query.pollPeriodMs) {
                query.lastPolled = currentTimeMs()
                longPollQuery(query, checkCount < longQueries.length - 1)
                return
            }
        } else {
            prosLogErr("No query at index", lastPolledInd)
        }
    }
}

function checkNeedQueryTimer() {
    if (longQueries.length > 0 && !longPollTimer) {
        longPollTimer = setInterval(()=> longQueryPoller(), LONG_QUERY_TIMER_INTERVALL_MS);
    } else if (longQueries.length <= 0 && longPollTimer) {
        clearInterval(longPollTimer)
        longPollTimer = undefined
    }
}

export function resetLongQueryPollPeriod(id) {
    const query = longQueries.find(query => query.id === id)
    if (query) {
        query.pollPeriodMs = 1000
    }
}

/**
 * Start polling server for "long query" results
 * Server may answer with a) "somewhat old data" b) empty (wait) and c) up-to-date data
 * @param uiClientId    Identify client if would have multiple UI components registering for same query type
 * @param queryType     Query type for server to use proper query
 * @param cacheId       ID used by server to share same cached data for multiple web clients
 * @param callBack      ProsConnect takes care of polling server and notifies UI client
 * @param queryParams   List of additional query specific parameters for server (optional)
 * @returns none
 */
export function startLongQuery(uiClientId, queryType, cacheId, callBack, queryParams) {
    prosLog("startLongQuery() id:", uiClientId, "queryType:", queryType, "cacheId:", cacheId)
    let existingQuery = longQueries.find(q => q.id === uiClientId)
    if (!existingQuery) {
        longQueries.push( {
            id: uiClientId, queryType: queryType, cacheId: cacheId,
            callBack: callBack, queryParams: queryParams,
            lastPolled: 0,                      // prosConnect keeps track when last time polled
            pollPeriodMs: DEFAULT_LONGQ_PERIOD, // Server should provide recommended poll interval
            timeKey: 0,                         // Sent in prev response by a server to check if client has latest data
            isFresh: false                      // if data was fresh when last time got data
        })
    }
    checkNeedQueryTimer()           // Create a timer when this is a first query
    longQueryPoller()               // Poll promptly - next polls by controller
}

/**
 * Unregister to stop polling server
 * @param uiClientId  In UI context should an unique id
 * @returns {Promise<void>}
 */
export function stopLongQuery(uiClientId) {
    let existingQueryIndex = longQueries.findIndex(q => q.id === uiClientId)
    if (existingQueryIndex >= 0) {
        prosLog("stopLongQuery() id:", uiClientId,
            "queryType:", longQueries[existingQueryIndex].queryType,
            "cacheId:", longQueries[existingQueryIndex].cacheId)
        longQueries.splice(existingQueryIndex,1);
    } else {
        prosLogWrn("stopLongQuery() not found ID", uiClientId)
    }
    checkNeedQueryTimer()
}

export async function getCustomers() {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_CUSTOMERS
    let response = await procedtAwsApiPost([req], WEB_OPER_GET_CUSTOMERS)
    if ( ! response || response.result !== "OK") {
        prosLogErr("Failed to get customers", response)
        sessionExceptionDetected("customer-3", 'Asiakastietojen haku epäonnistui')
        return []
    }
    return response.customers
}

export async function getPdash(pid, main_prj= false) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_PDASH_SETTING
    if (main_prj) {
        req[ATTR_MAIN_PROJ_ID] = pid
    } else {
        req[ATTR_AWS_PROJECT_ID] = pid
    }
    return procedtAwsApiPost([req], WEB_OPER_GET_PDASH_SETTING)
}

export async function getPdashProjectSettings(pid) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_PDASH_PROJECT_SETTINGS
    req[ATTR_AWS_PROJECT_ID] = pid
    let response = await procedtAwsApiPost([req], WEB_OPER_GET_PDASH_PROJECT_SETTINGS)
    if (response &&
        response.hasOwnProperty('result') &&
        response.result === 'OK' &&
        response.hasOwnProperty('project_settings')) {
        return response.project_settings
    }
    return {}
}

export async function savePdashMeter(pid, meterSetting) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_SAVE_PDASH_SETTING
    req[ATTR_AWS_PROJECT_ID] = pid
    await procedtAwsApiPost([req, meterSetting], WEB_OPER_SAVE_PDASH_SETTING)
}

export async function getNotificationRules(pid) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_NOTIFICATION_RULES
    req[ATTR_AWS_PROJECT_ID] = pid
    return procedtAwsApiPost([req], WEB_OPER_GET_NOTIFICATION_RULES)
}

export async function saveNotificationRule(pid, notificationRuleSettings) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_SAVE_NOTIFICATION_RULES
    req[ATTR_AWS_PROJECT_ID] = pid
    await procedtAwsApiPost([req, notificationRuleSettings], WEB_OPER_SAVE_NOTIFICATION_RULES)
}

export async function requestNotifForCustomer(customer_group, recurring = false) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_REQUEST_TEST_NOTIF_FOR_CUSTOMER
    req[ATTR_CUSTOMER_GROUP] = customer_group
    if (recurring) {
        req[ATTR_ACTION] = 'recurring'
    }
    await procedtAwsApiPost([req], WEB_OPER_REQUEST_TEST_NOTIF_FOR_CUSTOMER)
}

async function awaitCheckIfStartByProjectLinkUrl() {
    let link = getProjectWebLink()
    if (!link || savedProjectLink === link) {
        return false
    }
    prosLog('Query param "link":', link)
    let newLinkSettings = await awaitGetProjectLink(link)
    if (!newLinkSettings) {
        prosLog('Link not found', link)
        return false
    }
    prosLog('Using linkSettings from link', link)
    if (!hasRequiredAttributes(newLinkSettings, MANDATORY_ATTRS_FOR_PROJECT_LINK)){
        prosLogErr('Missing attrs in project link ref')
        return false
    }
    linkSettings = newLinkSettings
    savedProjectLink = link
    return true
}

export async function getProjectObjs(objs) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_PROJECT_OBJS
    req['objs'] = objs

    const response = await procedtAwsApiPost([req], WEB_OPER_GET_PROJECT_OBJS)
    if (response.result === 'Failed') {
        return []
    }
    return response.project_objs
}

/**
 * When started from project link has an optional OBS id (obj id or number) as 3rd link parameter
 * @returns {*}
 */
export function getObsIdFromLink(){
    if (savedProjectLink) {
        const linkAttrs = savedProjectLink.split(";")
        if (linkAttrs.length > 2) {
            return linkAttrs[2]
        }
    }
}


export async function archiveActivateProjects(pids, newState) {
    if (userProjectList && activeProject && pids.indexOf(activeProject.getPid()) >= 0) {
        // change active project archive state
        activeProject.attrs[ATTR_OBJ_STATE] = newState
    } else {
        prosLog("archiveOrActivateProjects() - no project list or active project")
    }
    let req = makeAwsReqParams(true)
    req.newState = newState
    req.pids = pids
    req[ATTR_WEB_OPERATION] = WEB_OPER_ARCHIVE

    await procedtAwsApiPost([req], 'project archive')

    // Give a bit time for a server to update users project status
    setTimeout(() => awaitGetProjects(true), 3000)
}

export async function updateItemsAttributes(projectAttrChanges) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_UPDATE_ITEM_ATTRS
    await procedtAwsApiPost([req].concat(projectAttrChanges), 'update item attrs')
}


export async function getProsAccessRights() {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_ACCESS_RIGHTS;
    return await procedtAwsApiPost([req], 'access rights')
}

export function lastTimeProjectListUpdated() {
    return currentTimeMs() - projectsLastUpdatedMs;

}

export async function awaitLoadObjectHistory(pid, objId, who) {
    projectLoader.refreshUserIsActive();
    prosLogDt('awaitLoadObjectHistory() projects objects loading', pid, 'objId', objId);
    try {
        await reserveAwsApi(true, 'GET obj history ' + who)
        const historyData = await API.get("prodect",
            '/webhistory?email=' + getUserEmail()
            + '&oper=GET_HISTORY'
            + '&obj_id=' + objId
            + '&id=' + getDevId()
            + '&project=' + pid);
        await reserveAwsApi(false, 'GET obj history ' + who)
        if (Array.isArray(historyData)) {
            if (DEBUG_MODE_TO_SAVE_SERVER_MSG) {
                dumpObjToJsonFile(historyData, 'obs history');
            }
            prosLogDt('awaitLoadObjectHistory() object', objId, 'history loaded', historyData.length);
            return historyData;
        } else {
            sessionExceptionDetected('History-1', 'Historian haku epäonnistui')
            prosLogDt('awaitLoadObjectHistory() rx not an array, projects objects NOT loaded');
        }
    } catch (e) {
        sessionExceptionDetected('History-2', 'Historian haku epäonnistui')
        prosLogErr(e);
    }
    await reserveAwsApi(false, 'GET obj history-failed ' + who);
    return undefined;
}

export async function awaitLoadObjectsDeleted(pid, who) {
    projectLoader.refreshUserIsActive();
    prosLogDt('awaitLoadObjectsDeleted() projects objects loading', pid);
    try {
        await reserveAwsApi(true, 'GET obj history ' + who)
        const deletedData = await API.get("prodect",
            '/webhistory?email=' + getUserEmail()
            + '&oper=GET_DELETED'
            // May optionally define types: + '&obj_type=[]'
            + '&id=' + getDevId()
            + '&project=' + pid);
        await reserveAwsApi(false, 'GET obj history ' + who)
        if (Array.isArray(deletedData)) {
            if (DEBUG_MODE_TO_SAVE_SERVER_MSG) {
                dumpObjToJsonFile(deletedData, 'obs deleted');
            }
            prosLogDt('awaitLoadObjectsDeleted() deleted items loaded', deletedData.length);
            return deletedData;
        } else {
            sessionExceptionDetected('Deleted-1', 'Poistettujen haku epäonnistui')
            prosLogDt('awaitLoadObjectsDeleted() rx not an array, projects objects NOT loaded');
        }
    } catch (e) {
        sessionExceptionDetected('Deleted-2', 'Poistettujen haku epäonnistui')
        prosLogErr(e);
    }
    await reserveAwsApi(false, 'GET obj deleted-failed ' + who);
    return undefined;
}

export async function awaitShowReport(report) {
    let projectId = activeProject.getPid();
    let reportId = report[ATTR_OBJ_ID];
    try {
        await reserveAwsApi(true, 'GET - preview report')
        let response = await API.get("prodect",'/update?projectId=' + projectId +'&reportId=' + reportId);
        await reserveAwsApi(false, 'GET - preview report')
        if (response && response.hasOwnProperty('response') && response.response === 'OK') {
            return response.url;
        } else {
            prosLogErr('Making report failed with response', response);
        }
    } catch(e) {
        prosLogErr(e);
    }
    await reserveAwsApi(false, 'GET - preview report-failed')
    return undefined;
}

// Start uploading base64 picture to ASWS server
// returns file name in AWS
export async function uploadBase64(dataURL) {
    let awsFileName = getDevId() + '_' + currentTimeMs() + '_'+ uuidv4() + '.png';
    const stored = await Storage.put(awsFileName, dataURL,
        {
            contentType: 'text/plain',
            customPrefix: AWS_CUSTOM_PREFIX_BASE64
        });
    return stored.key
}

export function hasFileExtension(fName, ext) {
    let lowerCaseName = fName.toLowerCase()
    let extPos = lowerCaseName.lastIndexOf(ext)
    return extPos === lowerCaseName.length - ext.length
}

function isFileExtensionVideo(fileExt) {
    return IMPORT_VIDEO_FILE_TYPES.indexOf(fileExt.toLowerCase()) >= 0
}

function isVideoFileName(fName) {
    for (let ext of IMPORT_VIDEO_FILE_TYPES) {
        if (hasFileExtension(fName, ext)) {
            return true
        }
    }
    return false
}

export async function startFileUpload(upfile, pdfOnly= false, s3FolderName, fileName) {
    let file = upfile
    //Dumb workaround to get callback to work...
    //Todo: function needs default values so only one attribute can be called, callback in this case
    if(upfile?.file) {
        file = upfile.file
    }
    let fileExtPos = file.name.lastIndexOf('.');
    let fileExt = file.name.substr(fileExtPos);
    let awsFileName = fileName || getDevId() + '_' + currentTimeMs() + '_'+ uuidv4() + fileExt;
    prosLogDt("sending local file", file, "to AWS S3", awsFileName);
    let s3CustomPrefix;
    if (s3FolderName) {
        s3CustomPrefix = {
            public:     s3FolderName,
            protected:  s3FolderName,
            private:    s3FolderName
        }
    }
    else if (pdfOnly) {
        s3CustomPrefix = AWS_CUSTOM_PREFIX_PDF;
    } else {
        s3CustomPrefix = isFileTypePdf(awsFileName) ?
            AWS_CUSTOM_PREFIX_PDF_TO_IMAGE:
            isFileExtensionVideo(fileExt) ? AWS_CUSTOM_PREFIX_VIDEO: AWS_CUSTOM_PREFIX_IMAGES
    }
    //https://docs.amplify.aws/javascript/prev/build-a-backend/storage/upload/
    //NOTE: V5!
    let config = {
        contentType: file.type,
        customPrefix: s3CustomPrefix,
        progressCallback: progress => {
            if(typeof upfile.cb === 'function'){
                upfile.cb({
                    progress: progress.loaded,
                    total: progress.total
                })
            }
        }
    }
    const stored = await Storage.put(awsFileName, file, config)
    prosLogDt("File saved s3key:", stored.key, 'config:', config)
    return stored.key

}

let displaySettingsProvider
export function registerToRetrieveViewSettings(viewMode, cb) {
    displaySettingsProvider = cb
}

export function makeLinkRequest(needProjectId = true) {
    let req = makeAwsReqParams(true)
    if (needProjectId) {
        if (!activeProject) {
            prosLogErr('No active proj')
            return undefined
        }
        req[ATTR_PROJECT_LINK] = activeProject.getPid()
        req[ATTR_CUSTOMER_GROUP] = activeProject.getAttr(ATTR_CUSTOMER_GROUP)
    }
    return req
}

function makeUiLinkRequest() {
    let req = makeLinkRequest()
    if (!req) {
        return undefined
    }
    // Use display settings in call or retrieve from sub-UI
    if (!displaySettingsProvider) {
        prosLogErr('Missing display settings for project link')
        return
    }
    let uiSettings = displaySettingsProvider(activeProject.getPid())
    uiSettings.mainProjectName = getProjectInfo(activeProject.getAttr(ATTR_MAIN_PROJECT_NAME))
    uiSettings.subProjectName = getProjectInfo(activeProject.getAttr(ATTR_TEXT))
    req[ATTR_SELECTED_REPORTS] = activeProject.getSelectedReportIds(uiSettings.isSearchMode)
    req[ATTR_UI_VIEW_MODE] = uiSettings.viewMode
    req[ATTR_UI_SEARCH] = !!uiSettings.isSearchMode
    req[ATTR_UI_SETTINGS] = uiSettings
    return req
}

/**
 * Request server to create a new link
 * @param getLinkId - return either url (getLinkId = false) or link ID (getLinkId = true)
 * @param linkId - link ID to update
 *                      - when missing (undefined) create a new link
 *                      - when view mode (list, table) create a sub-project default link to that view
 *                      - else update an existing link (dashboard and notification rule)
 * @param overrideReq - When provided uses given req instead of makeUiLinkRequest() function
 * @returns {Promise<*|string>} - link URL or ID
 */
export async function awaitMakeProjectLink(getLinkId=false, linkId=undefined, overrideReq = undefined) {
    let req = makeUiLinkRequest()
    if (overrideReq) {
        req = overrideReq
    }
    if (!req) {
        prosLogErr('awaitMakeProjectLink no active proj')
        return
    }
    req[ATTR_BROWSER_HOME] = window.location.href
    req[ATTR_WEB_OPERATION] = WEB_OPER_MAKE_LINK
    if (linkId) {
        req.link_id = linkId
    }
    prosLog('awaitMakeProjectLink() linkId:', linkId)
    let result = await procedtAwsApiPost([req], 'make www-link')
    prosLog('awaitMakeProjectLink - result:', result)
    if (!result || result.result !== 'OK') {
        return undefined
    }
    // Return link id - example TEST;mXW987C4aJtv
    // - or URL example https://prodect.fi/?link=TEST;mXW987C4aJtv
    return getLinkId ? result.link_id : result.link
}


/**
 * Get from server list of OBS [{obj_id: , obs_id}] that match to table selected reports and filters
 * @returns {Promise<undefined|*>}
 */
export async function awaitTableFilteredObs() {
    let req = makeUiLinkRequest()
    if (!req) {
        prosLogErr('no active proj')
        return
    }
    req[ATTR_AWS_PROJECT_ID] = activeProject.getPid()
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_FILTERED_OBS
    let result = await procedtAwsApiPost([req], 'test table flt')
    if (!result || result.result !== 'OK') {
        prosLogErr("awaitTableFilteredObs", result)
        return undefined
    }
    return result.filtered_obs
}


/*
 * @param text      book mark name,
 * @param bmType    OBJ_TYPE_BMARK | OBJ_TYPE_BMARK_TABLE_DEF
 * @param isPrivate true to save as a private bookmark (others do not see)
 */
export async function awaitMakeBookMark(text, bmType=OBJ_TYPE_BMARK, isPrivate=false) {
    let req = makeUiLinkRequest()
    if (!req) {
        prosLogErr('awaitMakeBookMark no active proj')
        return
    }
    req[ATTR_TEXT] = text
    req[ATTR_IS_PRIVATE] = isPrivate ? STR_YES : STR_NO
    req[ATTR_OBJ_TYPE] = bmType
    req[ATTR_WEB_OPERATION] = WEB_OPER_MAKE_BOOKMARK
    let result = await procedtAwsApiPost([req], 'make bookmark')
    deferredLoadBookMarks(true)
    return result.result === 'OK'
}


// Lazy loading bookmarks because
//      if have multiple renderings fetch when UI "settled"
//      speed up user switching rapidly between projects
const LAZY_LOAD_BOOKMARK_MS = 1500
let lazyLoadBookMarkTimer
let bookMarksCache
let bookMarksLoadingBusy
export function deferredLoadBookMarks(clearBookMarkCache) {
    if (clearBookMarkCache) {
        bookMarksCache = undefined
    } else {
        if (bookMarksLoadingBusy) {
            return
        }
    }
    if (lazyLoadBookMarkTimer) {
        clearTimeout(lazyLoadBookMarkTimer)
    }
    lazyLoadBookMarkTimer =  setTimeout(refreshBookMarksToListener,
        (clearBookMarkCache || !bookMarksCache) ?  LAZY_LOAD_BOOKMARK_MS : 200)
}

export async function refreshBookMarksToListener() {
    let bookMarks
    if (!activeProject) {
        return
    }
    if (bookMarksCache && bookMarksCache.projectId === activeProject.getPid()) {
        // prosLogX("Using cashed bookmarks project", bookMarksCache.projectId)
        bookMarks = bookMarksCache.bookMarks
    } else {
        if (isLoadingProject()) {
            deferredLoadBookMarks()
            return
        }
        bookMarks = await awaitGetBookMarks()
        if (!Array.isArray(bookMarks)) {
            // prosLogX("Failed to fetch bookmarks")
            bookMarks = []
        }
    }
    if (!bookMarksListener) {
        // bookmarks no longer needed
        // prosLogX('refreshBookMarksToListener() - unsubscribed before deferred fetch')
        return
    }
    let filteredBookMarks = bookMarks.filter(bookmark =>
        bookmark.ui_view_mode === bookMarksListener.viewMode ||
            bookMarksListener.viewMode === 'any')
    bookMarksListener.callBack(filteredBookMarks)
}

export async function awaitGetBookMarks() {
    if (!activeProject) {
        return
    }
    if (bookMarksLoadingBusy) {
        prosLogErr("Attempt to load book mark when busy")
        return
    }
    let req = makeLinkRequest()
    if (req) {
        const pid = activeProject.getPid()
        bookMarksLoadingBusy = true
        prosLogDt("> loading BOOK-MARKS", pid)
        req[ATTR_WEB_OPERATION] = WEB_OPER_GET_BOOKMARKS
        let bookMarks = await procedtAwsApiPost([req], 'get bookmarks')
        prosLogDt("< loaded BOOK-MARKS", pid)
        bookMarksLoadingBusy = false
        if (Array.isArray(bookMarks)) {
            bookMarksCache = {
                projectId: pid,
                bookMarks: bookMarks
            }
            // Set table default UI settings bookmark name
            let tableDefBookMark = bookMarks.find(bm => bm[ATTR_OBJ_TYPE] === OBJ_TYPE_BMARK_TABLE_DEF)
            if (tableDefBookMark) {
                tableDefBookMark.text = prosLocalize(ATTR_TABLE_DEF_BOOKMARK)
            }
            return bookMarks
        } else {
            prosLogErr("Failed to get bookmarks - response", bookMarks)
            bookMarksCache = {
                projectId: pid,
                bookMarks: []
            }
        }
        return undefined
    }
}

export async function awaitUpdateBookMark(bookMark) {
    let req = makeLinkRequest()
    if (req) {
        req[ATTR_WEB_OPERATION] = WEB_OPER_UPDATE_BOOKMARK
        let result = await procedtAwsApiPost([req, bookMark], 'update bookmark')
        deferredLoadBookMarks(true)
        return result
    }
}

// Get table UI settings stored using bookmark
export function getProjectTableUiSetting(tableSetting) {
    let project = getActiveProject()
    if (!project) {
        return undefined
    }
    let projectTableDefaults = project.attrs[ATTR_TABLE_DEF_BOOKMARK]
    if (projectTableDefaults &&
        projectTableDefaults.ui_settings &&
        projectTableDefaults.ui_settings.hasOwnProperty(tableSetting)) {
            return projectTableDefaults.ui_settings[tableSetting]
    }
}


export async function getCreateProjectSettings(settings, customerIds, customerAndProject) {
    let req = makeLinkRequest(false)
    if (req) {
        req[ATTR_WEB_OPERATION] = WEB_OPER_GET_PROJECT_MAKER
        let items = [req, settings, customerIds]
        if (customerAndProject) {
            // Selected main project -> get main project attrs by customer ID and main project name
            items.push(customerAndProject)
        }
        return await procedtAwsApiPost(items, 'get project maker')
    }
}

export async function saveCreateProjectSettings(settings) {
    let req = makeLinkRequest(false)
    if (req) {
        req[ATTR_WEB_OPERATION] = WEB_OPER_SAVE_PROJECT_MAKER
        return await procedtAwsApiPost([req, settings], 'save project maker')
    }
}

export async function customerRequestCost(settings) {
    let req = makeLinkRequest(false)
    if (req) {
        req[ATTR_WEB_OPERATION] = WEB_OPER_COST_CALC
        return await procedtAwsApiPost([req, settings], 'cost project maker')
    }
}

export async function customerOrderProject(settings) {
    let req = makeLinkRequest(false)
    if (req) {
        req[ATTR_WEB_OPERATION] = WEB_OPER_ORDER_CUSTOMER
        return await procedtAwsApiPost([req, settings], 'order project maker')
    }
}

let lastGetLinkErrorCause
export function getLatestLinkError() {
    if (!getProjectWebLink() || !lastGetLinkErrorCause) {
        clearProjectLinkAsInvalid()
        return undefined
    }
    let failureReason = prosLocalize(lastGetLinkErrorCause)
    lastGetLinkErrorCause = undefined
    setProjectLinkAsInvalid()
    return failureReason
}

let signoutError
export function getLatestSignoutError() {
    return signoutError
}

export function setLatestSigoutError(err) {
    signoutError = err
    getLogBufferLines(7)
}

export function isLatestLinkErrorMissingPermission() {
    return lastGetLinkErrorCause === 'No access'
}

export async function awaitGetProjectLink(linkRef, shouldExist=true) {
    let req = makeAwsReqParams(true)
    req.link = linkRef
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_LINK

    let result = await procedtAwsApiPost([req], 'get www-link')
    if (result.result === 'OK') {
        lastGetLinkErrorCause = undefined
        return result.link
    }
    if (shouldExist) {
        prosLogErr('Error in project link', result)
        lastGetLinkErrorCause = result.errorCause
    }
    return undefined
}

/**
 * To get link object from server for notification rule, might later use for dashboard and bookmark
 * @param linkUuid  Link UUID - need to add customer id in front
 * returns: undefined | linkId
 */
export async function awaitGetNotificationRuleLink(linkUuid) {
    let linkId = activeProject.getAttr(ATTR_CUSTOMER_GROUP) + ";" + linkUuid
    return await awaitGetProjectLink(linkId, false)
}

/**
 * To get link ID from rule - undefined if does not exist. Link object id is rule;<linkId>
 * @param rule  Notification rule
 * returns: undefined | linkId
 */
export function getRuleLinkId(rule) {
    if (rule && rule[ATTR_OBJ_ID]) {
        return rule[ATTR_OBJ_ID].replace("rule;", "")
    }
}

export async function awaitStartPackProject(pid) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_PACK_PROJECT
    req[ATTR_AWS_PROJECT_ID] = pid
    let result = await procedtAwsApiPost([req], 'start pack')
    prosLog('Pack project', pid, ', result:', result)
}

// New is created only by ProjectLoader
export function getActiveProject(createNew=false) {
    if (createNew) {
        activeProject = new ProsProject({}, projectLoader.refreshUi, false)
    }
    return activeProject;
}

export function getActiveProjectID() {
    if (activeProject) {
        return activeProject.getPid()
    }
    return undefined;
}

export function getActiveProjectsCustomerId() {
    if (activeProject) {
        return activeProject.getAttr(ATTR_CUSTOMER_GROUP)
    }
}

/**
 * Check if user has main projects or actually any other projects that Examples
 * @param mainprojects  - optional list of mainProjects
 * @returns {boolean}   - true when have access to some "real" project(s)
 */
export function userHasMainProjects(mainprojects){
    if(mainprojects) {
        return mainprojects.filter(prj => prj.mainProjectId !== 'EXAMPLES').length > 0
    }
    // check cached sub project list if not provided
    if (projects) {
        return projects.filter(prj => prj[ATTR_MAIN_PROJ_ID] !== 'EXAMPLES').length > 0
    }
    return false
}

export function userHasSubProjects(mainprojects, states = [OBJ_STATE_ACT, OBJ_STATE_PAS]) {
    let mainProjs = [], subProjs = []
    if (mainprojects) {
        mainProjs = mainprojects.filter(prj => prj.mainProjectId !== 'EXAMPLES')
        mainProjs.forEach(mprj => {
            if(mprj.projects.length > 0) subProjs = subProjs.concat(mprj.projects)
        })
    } else subProjs = projects.filter(prj => prj[ATTR_MAIN_PROJ_ID] !== 'EXAMPLES')
    return subProjs.filter(prj => {
        return states.includes(prj[ATTR_PROJECT_STATE])
    }).length > 0
}

export function getActiveMainProjectName() {
    return activeProject ? activeProject.getAttr(ATTR_MAIN_PROJECT_NAME) : "?"
}

export function getActiveSubProjectName() {
    return activeProject ? activeProject.getAttr(ATTR_TEXT) : "?"
}

export function isProjectActive(pid) {
    return getActiveProject() && getActiveProject().getPid() === pid
}

export function deactivateActiveProject() {
    // prosLogX("deactivateActiveProject()")
    if (activeProject) {
        activeProject.uiItems.length = 0;
    }
    activeProject = undefined;
    flushProjectList()
}

function haveProjects() {
    return projects && projects.length > 0
}

export function getSelectedProject() {
    return restoreConfigStr(SAVED_SELECTED_PROJECT)
}

function getSuperUserModeFromSession() {
    if (isSuperUserModePossible()) {
        isSuperUserInUse = !!restoreConfigStr(SAVED_SUPERUSER)
        return
    }
    deleteConfigStr(SAVED_SUPERUSER)
}

export function utcToLocalTime(utcMs) {
    return new Date(utcMs)
}

function decodePictZoomInfo(zoomInfoStr) {
    if (!zoomInfoStr || zoomInfoStr === STR_NO_VALUE) return undefined
    let [cx, cy, scale, imgW, imgH, viewW, viewH, devOS, swVers] = (zoomInfoStr ?? "").split(";")
    return {
        cx: cx, cy: cy, scale: scale,
        imgW: imgW, imgH: imgH,
        viewW: viewW, viewH: viewH,
        devOS: devOS, swVers: swVers
    }
}

export function encodePictZoomInfo(zi) {
    return `${zi.cx};${zi.cy};${zi.scale};${zi.imgW};${zi.imgH};${zi.viewW};${zi.viewH};W;${PRODECT_SW_FULL_VERSION}`
}

// for debugging show attr value for human readable format
function dbgDecode(obj, attr) {
    if (attr === ATTR_EXPIRATION || attr === ATTR_SORT_ORDER_I ||
        attr === ATTR_UPDATED_MS_I || attr === ATTR_CREATED_MS_I) {
        let ms = attr === ATTR_EXPIRATION ? getExpiration(obj) : parseInt(obj[attr]);
        if (ms) {
            return obj[attr].toString() + " " + utcToLocalTime(ms);
        }
    }
    if (attr === 'obsList') {
        return obj[attr]
            .map(obs => obs[ATTR_OBJ_ID])
            .join(", ")
    }
    if (attr === ATTR_PICT_ZOOM) {
        return decodePictZoomInfo(obj[attr])
    }
    return obj[attr];
}

// Remember selected reports when toggle between projects
function getUnSelectedReports() {
    let storageReports = restoreConfigStr(SAVED_UNSELECTED_REPORTS)
    if (storageReports) {
        return JSON.parse(storageReports)
    }
    return {}
}

export function saveSelectedReports() {
    if (activeProject) {
        let unselectedReports = getUnSelectedReports()
        unselectedReports[activeProject.getPid()] = activeProject.getNotSelectedReportIds()
        saveConfigStr(SAVED_UNSELECTED_REPORTS, JSON.stringify(unselectedReports))
    }
}

export function restoreSelectedReports() {
    if (activeProject) {
        let unselectedReports = getUnSelectedReports()
        let unselectedReportIds = unselectedReports ? unselectedReports[activeProject.getPid()] : undefined
        if (unselectedReportIds) {
            activeProject.selectedReports = activeProject.objs
                .filter(item => item[ATTR_OBJ_TYPE] === OBJ_TYPE_LST)
                .map(report => report[ATTR_OBJ_ID])
                .filter(reportId => !unselectedReportIds.find(id => id === reportId))
        }
        return activeProject.selectedReports.length
    }
    return 0
}

/**
 * Set selected reports or search and remember that when toggling between projects
 * @param selectedReportIds
 * @param isSearchMode
 */
export function setSelectedReportIds(selectedReportIds, isSearchMode) {
    if (!activeProject) { return }
    if(isSearchMode) {
        if (selectedReportIds.length) {
            activeProject.selectedSearchId = selectedReportIds[0]
        }
    } else{
        activeProject.selectedSearchId = undefined
        activeProject.selectedReports = selectedReportIds
        saveSelectedReports()
    }
}


function activateProject(projectAttrs) {
    prosLog("activateProject()", projectAttrs)
    projectLoader.refreshUserIsActive();
    saveSelectedReports()
    if (!projectAttrs) {
        prosLogWrn('WRN: ProsConnect:activateProject() no project to activate');
        resetViewToDefault()
        return;
    }
    if (activeProject && activeProject.getPid() === projectAttrs[ATTR_AWS_PROJECT_ID]) {
        prosLog('Continue with same project', activeProject.getPid());
    } else {
        activeProject = getProject(projectAttrs);
        saveConfigStr(SAVED_SELECTED_PROJECT, activeProject.getPid());
    }
    if (activeProject && activeProject.attrs) {
        // ok
        prosLog('Activated project', activeProject.getPid());
    } else {
        prosLogErr("activateProject() failed", projectAttrs)
    }
    return activeProject;
}

export function selectProjectById(projectId) {
    if (recentlyRemovedProjects.indexOf(projectId) >= 0) {
        prosLog("selectProjectById() reject selection - project just removed")
        return null
    }
    if (!projectId) {
        prosLogWrn('Project not been selected');
        return null;
    }
    // --- tbd if need caching project as now loading list is fast // if (!projects) { restoreProjects() }
    if (!projects) {
        prosLogWrn('Projects not been loaded');
        return null;
    }
    if (projects.length < 1) {
        prosLogWrn('No projects');
        return null;
    }
    let projectAttrs = projects.find(function(project){ return project[ATTR_AWS_PROJECT_ID] === projectId});
    return activateProject(projectAttrs);
}

export function getProject(projectAttrs) {
    if (projectAttrs) {
        return new ProsProject(projectAttrs, projectLoader.refreshUi, false);
    }
    return null
}

export function getCustomerGroup(projectAttrs) {
    if (projectAttrs.hasOwnProperty(ATTR_CUSTOMER_GROUP) && projectAttrs[ATTR_CUSTOMER_GROUP] !== STR_NO_VALUE) {
        return projectAttrs[ATTR_CUSTOMER_GROUP];
    }
    return DEFAULT_CUSTOMER_GROUP;
}


export function sortReportOrder(a,b) {
    let reportIdA = a.hasOwnProperty(ATTR_REPORT_INDEX) ? a[ATTR_REPORT_INDEX] : '999999';
    let reportIdB = b.hasOwnProperty(ATTR_REPORT_INDEX) ? b[ATTR_REPORT_INDEX] : '999999';
    if (reportIdA < reportIdB) return -1;
    if (reportIdA > reportIdB) return 1;
    return a[ATTR_SORT_ORDER_I] - b[ATTR_SORT_ORDER_I]
}

/**
 * Show text from DB object in UI
 * @param txt   String to be converted
 */
export function textToShow(txt) {
    return txt && txt !== STR_NO_VALUE ? txt : ""
}

/**
 * Return string used in DB for boolean
 * @param str           String to be converted to boolean
 * @param defaultVal    Default if string is not a valid boolean
 * @returns {boolean}   True or false
 */
export function strToBool(str, defaultVal= false) {
    if (!str || str === STR_NO_VALUE || str === '') {
        return defaultVal
    }
    return str.indexOf(STR_YES) >= 0
}

export function getEmptyTags() {
    return {maxInd: 0, tags: []};
}

export async function awaitRemoveMainProject(main_project_id, customer_group) {
    let req = makeAwsReqParams(true)
    req[ATTR_MAIN_PROJ_ID] = main_project_id
    req[ATTR_CUSTOMER_GROUP] = customer_group
    req[ATTR_WEB_OPERATION] = WEB_OPER_DEL_MAIN_PROJECT

    await procedtAwsApiPost([req], WEB_OPER_DEL_MAIN_PROJECT)
}


export async function getUserSettingsProjectOrder() {
    if (savedUserSettingsProjectOrder) {
        // Use project order that received with project list
        return savedUserSettingsProjectOrder
    }
    return {}
}

/**
 * Get user setting for requested settings type
 * @param settingsType      Setting type like notif_settings
 * @returns {Promise<{}>}   Promise result which has settings from server or empty {} when ot found
 */
export async function getUserSettings(settingsType) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_GET_USER_SETTINGS
    req["settings"] = settingsType
    let result = await procedtAwsApiPost([req], WEB_OPER_GET_USER_SETTINGS)
    if ('user_settings' in result && settingsType in result['user_settings']) {
        return result['user_settings'][settingsType]
    }
    // When not found return empty settings
    return {}
}

export async function getUserNotifSettings() {
    return await getUserSettings("notif_settings")
}

/**
 * Save user settings to server by user email
 * @param settingsType  Type of the settings like "notif_settings", "project_order"
 * @param settings      Stetting specific object to be saved
 * @returns {Promise<void>}
 */
export async function saveUserSettings(settingsType, settings) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_SAVE_USER_SETTINGS
    req['settings'] = settingsType
    await procedtAwsApiPost([req, settings], WEB_OPER_SAVE_USER_SETTINGS)
}

export async function saveUserNotifSettings(settings) {
    await saveUserSettings('notif_settings', settings)
}

export async function requestOneTimeNotification(notif_settings) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_ONE_TIME_NOTIFICATION_REQUEST

    await procedtAwsApiPost([req, notif_settings], WEB_OPER_ONE_TIME_NOTIFICATION_REQUEST)
}

/**
 * Send to server user feedback or autonomous error report
 * @param options
 *          user_text           Text from user
 *          fb_type             "v1": user feedback, "s1": session error (type and data / format version)
 *          request_contact     if user requested to be contacted
 *          send_logs           true to send current log buffer
 * @param logLines  Optional log lines - when missing use log Buffer
 * @returns {Promise<void>}
 */
export async function sendFeedback(options, logLines) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_SEND_FEEDBACK

    if (!logLines) {
        // Adjust current log buffer size if necessary
        let logBufferLen = 0
        logBuffer.forEach((text) => {
            logBufferLen += text.length
        })
        while (logBufferLen > LOG_BUFFER_LEN_MAX) {
            let logText = logBuffer.shift()
            logBufferLen -= logText.length
        }
    }
    let feedback = {
        log_lines: [],
        sw_version: VERS_STRING,
        user_text: options.user_text,
        fb_type: options.fb_type,
        request_contact: options.request_contact,
        active_project_attrs: activeProject? activeProject.attrs : {info: "No active project"},
        active_project_objs_len: activeProject? activeProject.objs.length: 0,
    }
    if (logLines) {
        feedback.log_lines = logLines
    } else if (options.send_logs) {
        feedback.log_lines = logBuffer
    }
    prosLog("Sending feedback active project:", getActiveProjectID())
    await procedtAwsApiPost([req, feedback], WEB_OPER_SEND_FEEDBACK)
}

export async function moveProjectToAnotherCustomer(options) {
    let req = makeAwsReqParams(true)
    req[ATTR_WEB_OPERATION] = WEB_OPER_MOVE_PROJECT

    let feedback = {
        ref_pid: options.project_pid, // object of transfer
        new_main_proj_id: options.new_main_proj_id, // target main project
    }

    await procedtAwsApiPost([req, feedback], WEB_OPER_MOVE_PROJECT)
    await awaitGetProjects(true)
}

/**
 * Used to get project (user emails) or customer (other) enums
 * @param enumId            get enum values and info by enum id
 *  Returned data {result: "OK" | "Failed", enums: [string], comment:<string>, may_add:string]
 *  mayAdd: “none” | “mgr” | ”editor”
 * @returns {Promise<{enumInfo}|*>}
 */
export async function getEnumValues(enumId) {
    let req = makeAwsReqParams(true, WEB_OPER_GET_ENUMS)
    let params = {}
    params[ATTR_AWS_PROJECT_ID] = getActiveProjectID()
    params[ATTR_CUSTOMER_GROUP] = getActiveProjectsCustomerId()
    params[ATTR_ENUM_ID] = enumId ? enumId : STR_NO_VALUE
    let response = await procedtAwsApiPost([req, params], WEB_OPER_GET_ENUMS)
    if (response.result !== 'OK') {
        prosLogErr("Invalid enum response", response)
        return undefined
    }
    return response
}

/**
 * Get all enums for a given customer ID or customer of the active project
 *  Returns [{"id":<id>, "description":<name>, "values:[enumValue]}]
 *  Returned data structure is prodect common DB object with extra attributes:
 *      enums:[string],                         // list of enum text values
 *      may_add: “none” | “mgr” | ”editor”]   // permission to add value when editing OBS
 * @returns {Promise<[enums]>}
 */
export async function getAllEnums(customerGroup) {
    let cg = customerGroup || getActiveProjectsCustomerId()
    if (!cg) {
        prosLogErr("Missing customer id for getAllEnums()")
        return []
    }
    let req = makeAwsReqParams(true, WEB_OPER_GET_ENUMS)
    let params = {}
    params[ATTR_CUSTOMER_GROUP] = cg
    let response = await procedtAwsApiPost([req, params], WEB_OPER_GET_ENUMS)
    if ('all_enums' in response) {
        return response['all_enums']
    }
    prosLogErr("Invalid enum response", response)
}

/**
 * Save edited enum list information
 * @param customerId Customer ID
 * @param changes    Changed enum list DB obj attributes
 * @returns {Promise<boolean>}
 */
export async function saveEnum(customerId, changes) {
    let req = makeAwsReqParams(true, WEB_OPER_SAVE_ENUMS)
    req[ATTR_CUSTOMER_GROUP] = customerId
    let response = await procedtAwsApiPost([req, changes], WEB_OPER_SAVE_ENUMS)
    if (!response || response.result !== 'OK') {
        prosLogErr("Failed to save enums")
        return false
    }
    return true
}

/**
 * Add new enum values to en existing enum list
 * @param enumId  String enum id
 * @param enums   String with one or multiple ( ";" separated ) enum values
 * @returns {Promise<int>}  Number of added values
 */
export async function addEnums(enumId, enums) {
    let req = makeAwsReqParams(true, WEB_OPER_ADD_ENUMS)
    req[ATTR_CUSTOMER_GROUP] = getActiveProjectsCustomerId()
    req[ATTR_ENUM_ID] = enumId
    let response = await procedtAwsApiPost([req, enums], WEB_OPER_ADD_ENUMS)
    if (!response || response.result !== 'OK') {
        prosLogErr("Failed to add enums")
        return 0
    }
    return response.added
}

export function getChangeObj(item, attrs) {
    let changeObj = {
        [ATTR_OBJ_ID]: item[ATTR_OBJ_ID],
        [ATTR_OBJ_TYPE]: item[ATTR_OBJ_TYPE],
    }
    Object.assign(changeObj, attrs)
    return changeObj
}

function isFileTypePdf(fileName) {
    let extPos = fileName.toLowerCase().lastIndexOf('.pdf');
    return extPos === fileName.length - 4;
}

export class ProsProject {
    constructor(attrs, refreshUiCallback) {
        this.hasItems = false;
        this.attrs = attrs;
        this.refreshUiCallback = refreshUiCallback
        this.uiItems = [];
        this.objs = [];
        this.observations = [];
        this.loadingProjectData = true;
        this.selectedReports = [];
        this.selectedSearchId = undefined;
        this[ATTR_PROJ_REPORTS] = [];
        this[ATTR_PROJ_SEARCHS] = [];
        this.locPictListId = undefined;
        this.usersListId = undefined;
        this.reportHistoryListId = undefined;
        this.systemParameters = undefined;
        this.customerGroup = DEFAULT_CUSTOMER_GROUP;
        this.itemCountStats = {
            obs: 0,
            itemsTotal: 0,
            itemsCountLimit: 0
        }
        this.clearItemCountStats()
        prosLog("ProsProject created");
    }

    clearItemCountStats() {
        this.itemCountStats.obs = 0
        this.itemCountStats.itemsTotal = 0
    }

    includedToItemsQuota(obj) {
        return obj[ATTR_OBJ_TYPE].includes('itm') &&
            !obj[ATTR_OBJ_TYPE].includes('report') &&
            !obj[ATTR_OBJ_TYPE].includes('role')
    }

    updateObjectStats(obj, countChange) {
        if (this.includedToItemsQuota(obj)) {
            this.itemCountStats.itemsTotal += countChange
            if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
                this.itemCountStats.obs += countChange
            }
        }
    }

    calcItemCountStats(objs) {
        // prosLogDtX("calcItemCountStats() - start", this.getName(), this.getPid())
        this.clearItemCountStats()
        let itemCount = 0
        let obsCount = 0
        objs.forEach(obj => {
            if (this.includedToItemsQuota(obj)) {
                itemCount++
                if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
                    obsCount++
                }
            }
        })
        this.itemCountStats.itemsTotal = itemCount
        this.itemCountStats.obs = obsCount
        this.itemCountStats.itemsCountLimit = featureLimit(FEAT_MAX_ITEMS, MAX_ITEMS_DEFAULT)
        // Estimate for a fast PC 5000 objs / ms
        // prosLogDtX("calcItemCountStats() - end", this.getName(), this.itemCountStats)
    }

    unSelectReports() {
        this.selectedReports.length = 0
        this.selectedSearchId = undefined
    }

    /**
     * Select given reports by ID when they exist in the project
     * @param reportIds - list of report ID's
     */
    selectReportsById(reportIds) {
        this.unSelectReports()
        this.selectedReports = reportIds
            .filter(reportId => this.objs
                .find(item => item[ATTR_OBJ_ID] === reportId &&
                            item[ATTR_OBJ_STATE] === OBJ_STATE_ACT))
    }

    /**
     * Get selected search object using project selectedSearchId
     * @returns search (list) object containing search filters
     */
    getSelectedSearch() {
        let searchObj = getObjById(this.selectedSearchId)
        return searchObj[ATTR_OBJ_STATE] === OBJ_STATE_ACT ? searchObj : undefined
    }

    /**
     * Get selected & opened reports or selected search ID
     * @param searchOnly        true to get selected search, else reports
     * @param openedReports     true to get opened search/report
     * @returns {[]}            selected report ID's
     */
    getSelectedReportIds(searchOnly, openedReports=false) {
        if (searchOnly) {
            // Only one search selected and that is open ( no ui_isOpen attr in search )
            return this.selectedSearchId ? [this.selectedSearchId] : []
        }
        // Check normal reports
        if (!openedReports) {
            return this.selectedReports
        }
        return this.selectedReports
            .filter(reportId => {
                let report =  getObjById(reportId)
                return report && report.ui_isOpen
            })
    }

    getPid() {return this.attrs[ATTR_AWS_PROJECT_ID] };
    getName(){return this.attrs[ATTR_TEXT]};
    getAge() {return this.attrs[ATTR_AGE]};
    getAgeAndUpdatedMs() {return this.attrs[ATTR_AGE].toString() + ';' + this.attrs[ATTR_UPDATED_MS_I].toString()};
    isProjectLoaded() {return this.objs && this.objs.length > 0;}
    isProjectActive() {return this.attrs[ATTR_OBJ_STATE] === OBJ_STATE_ACT}
    projectObjectsLoaded(projectData, loadedCompleteProject, waitMs) {
        this.objs = projectData.objs
        this.hasItems = this.objs.length > 1
        this.attrs = projectData.attrs;
        this.locPictListId =        projectData[ATTR_PROJ_LOC_PICTS];
        this.usersListId =          projectData[ATTR_PROJ_USERS];
        this.reportHistoryListId =  projectData[ATTR_PROJ_REP_HIST];
        if (projectData.hasOwnProperty('role_objs')) {
            this.role_objs = projectData.role_objs
        }
        this.systemParameters = projectData[PRJ_SYS_BUILDING_PARAMS];
        this.customerGroup = getCustomerGroup(projectData.attrs);
        this.loadingProjectData = false;
        prosLog("Project:projectObjectsLoaded() project load pid:", this.getPid(),
            "loadedCompleteProject:", loadedCompleteProject, "waitServer:", waitMs)
        this.calcItemCountStats(this.objs)

        this.updateProjectAge(this.attrs)
        this.setProjectTags(projectData)

        // Table default UI settings
        this[ATTR_TABLE_DEF_BOOKMARK] = projectData[ATTR_TABLE_DEF_BOOKMARK]

        // prosLogX('Project special tags state', this.getStateRbTag(), 'urgent', this.getUrgentChTag());
        this.refreshUiCallback("project set")
    };

    getAttr(attr, defaultVal = STR_NO_VALUE) {
        if (this.attrs.hasOwnProperty(attr)) {
            return this.attrs[attr]
        }
        return defaultVal;
    }

    putAttr(attr, value) {
        this.attrs[attr] = value;
        // prosLog('putAttr()', attr, this.attrs[attr], '->', value);
    }

    isAllowed(attr) {
        return this.attrs[attr] !== STR_NO
    }

    isMyProdectProject() {
        return this.getAttr(ATTR_LICENSE_LEVEL).indexOf('MyProdect') > -1
    }

    hasNonEmptyArray(arrName) {
        return this.hasOwnProperty(arrName) &&
            Array.isArray(this[arrName]) &&
            this[arrName].length > 0;
    }

    clearUiToLoadNewProject() {
        this.objs.length = 0;
        this.uiItems.length = 0;
        // prosLogX("LOAD started ---- clearUiToLoadNewProject()")
        this.loadingProjectData = true;
        // Update subscribed UI component's state to update UI "no data"
        this.refreshUiCallback("clearUiToLoadNewProject");
    }

    isLoading() {
        return this.loadingProjectData;
    }

    getLocationPictureListId() {
        return this.locPictListId
    }

    updateProjectAge(projectAttrs) {
        if (!projectAttrs.hasOwnProperty(ATTR_AWS_PROJECT_ID)) {
            throw new Error('No PID in project');
        }
        if (activeProject !== this) {
            // update cache TAG and project list only for an active project
            return
        }
        if (!projectAttrs.hasOwnProperty(ATTR_AGE)) {
            throw new Error('No age in project');
        }
        if (!projects) {
            return
        }
        let project = projects.find((proj) => proj[ATTR_AWS_PROJECT_ID] === projectAttrs[ATTR_AWS_PROJECT_ID]);
        if (project === undefined) {
            prosLogErr('no project in cached projects');
            return;
        }
        updateExistingObjAttrs(project, projectAttrs)
    }

    isStateSTag(stag) {
       return stag === 's' + this.getStateRbTag();
    }

    stateDefaultAttrName() {
        return ATTR_PREFIX_OBS_DEFAULT + this.getStateRbTag()
    }

    getDefaultState() {
        let stateDefaultValue = this.getAttr(this.stateDefaultAttrName())
        return stateDefaultValue === STR_NO_VALUE ? OBS_DEFAULT_STATE : stateDefaultValue
    }

    setProjectTags(projectData) {
        if (projectData.hasOwnProperty(ATTR_CB_TAGS))  this[ATTR_CB_TAGS] = projectData[ATTR_CB_TAGS]
        if (projectData.hasOwnProperty(ATTR_RB_TAGS))  this[ATTR_RB_TAGS] = projectData[ATTR_RB_TAGS]
        if (projectData.hasOwnProperty(ATTR_TXT_TAGS))  this[ATTR_TXT_TAGS] = projectData[ATTR_TXT_TAGS]

        this.setTagBgColorMapping()
        this.stateTag = undefined
        this.urgentChTag = undefined
        for (let ind = 1; ind < MAX_RB_TAGS; ind++) {
            let tag = TAG_RB_PREFIX + ind
            let tagValue = this.getAttr('s' + tag)
            if (tagValue !== STR_NO_VALUE) {
                let stateStrs = tagValue.split(';')
                let stateInUse = stateStrs.length > 1 && stateStrs[1] === STR_YES
                this.stateTag = stateInUse ? tag : undefined
                break
            }
        }
        for (let ind = 1; ind < MAX_CH_TAGS; ind++) {
            let tag = TAG_CH_PREFIX + ind
            let tagValue = this.getAttr('s' + tag)
            if (tagValue !== STR_NO_VALUE) {
                this.urgentChTag = tag
                break;
            }
        }
    }

    /**
     * BG color for table and calendar cell (for multivalue option so far) is taken from project settings.
     * When BG color is not been configured get color from predefined color sets.
     * A color mapping table is updated when receiving project object from server.
     * Lookup table is used to speed up getting color in runtime.
     * Map table key is stag + option index - ref getBgHexNumberByTagValue()
     */
    setTagBgColorMapping() {
        this.tagColorMap = {}
        this.tagColorMapAuto = {}
        this[ATTR_RB_TAGS].forEach((mvTag, rgInd) => {
            if (mvTag.length && mvTag[0].length > 1) {
                let stag =  mvTag[0][1]
                let splitStr = this.attrs[stag].split(';;')
                mvTag.forEach((option, rbInd) => {
                    if (rbInd > 0) {
                        // index 1..N are MV options
                        let tagOptionStr = splitStr[rbInd]
                        let hexNumber
                        if (tagOptionStr) {
                            let options = tagOptionStr.split(';');
                            if (options.length > 3) {
                                //  0     ;1      ;2          ;3
                                // <label>;<inUse>;<mandatory>;<bgColor>
                                hexNumber = options[3]
                                if (isFalse(hexNumber)) {
                                    // No color been configured - select default BG color use from color sets
                                    // To disable automatic color mapping comment out next line
                                    hexNumber = getDefaultColor(rgInd, rbInd-1)
                                    this.tagColorMapAuto[stag+ "-" + (rbInd-1)] = hexNumber
                                } else {
                                    // hexNumber from project settings is treated as a valid color
                                    this.tagColorMap[stag+ "-" + (rbInd-1)] = hexNumber
                                }
                            }
                        }
                    }
                })
            }
        })
    }

    getStateRbTag() {
        return this.stateTag
    }

    getUrgentChTag() {
        return this.urgentChTag
    }

    // example [ 'tag_ch1', 'tag_ch2' ]
    getChTags() {
        if (this.hasNonEmptyArray(ATTR_CB_TAGS))
            return this[ATTR_CB_TAGS]
                .filter(tag => tag[2])
                .map(tag => tag[0].substr(1));
        return []
    }

    // example [ 'stag_ch1', 'stag_ch2' ] in use
    getChTagsS() {
        if (this.hasNonEmptyArray(ATTR_CB_TAGS))
            return this[ATTR_CB_TAGS]
                .filter(tag => tag[2])
                .map(tag => tag[0]);
        return []
    }

    // example [ 'Kiireellinen', 'Turvallisuus' ]
    getChTagLabels() {
        if (this.hasNonEmptyArray(ATTR_CB_TAGS)) {
            return this[ATTR_CB_TAGS]
                .filter(tag => tag[2])
                .map(tag => tag[1])
        }
        return []
    }

    chTagIdToIndex(tag) {
        return this.getChTags().indexOf(tag)
    }

    // tag is tag_ch<num>, returns name of the tag or "?" if due to sw bug has an unknown id
    getChTagLabelById(tag) {
        let tagInd = this.chTagIdToIndex(tag)
        return tagInd >= 0 ? this.getChTagLabels()[tagInd] : '?'
    }

    // textField example [ 'txt1', 'txt2' ]
    getTxtTags() {
        if (this.hasNonEmptyArray(ATTR_TXT_TAGS))
            return this[ATTR_TXT_TAGS].map(tag => tag[0].substr(1));
        return []
    }

    // example [ 'stxt1', 'stxt2' ] in use
    getTxtTagsS() {
        if (this.hasNonEmptyArray(ATTR_TXT_TAGS))
            return this[ATTR_TXT_TAGS].map(tag => tag[0]);
        return []
    }

    // textField example [ 'Hinta-arvio', 'Huonenumero' ]
    getTxtLabels() {
        if (this.hasNonEmptyArray(ATTR_TXT_TAGS))
            return this[ATTR_TXT_TAGS].map(tag => tag[1]);
        return []
    }

    getTxtLabel(tagInd) {
        let labels = this.getTxtLabels()
        if (tagInd < 0 || tagInd >= labels.length) {
            return "?"
        }
        return labels[tagInd]
    }

    // example [ 'tag2', 'tag3', 'tag4' ]
    getRbTags() {
        if (this.hasNonEmptyArray(ATTR_RB_TAGS))
            return this[ATTR_RB_TAGS].map(tag => tag[0][1].substr(1));
        return []
    }

    // example [ 'stag2', 'stag3', 'stag4' ] in use
    getRbTagsS() {
        if (this.hasNonEmptyArray(ATTR_RB_TAGS))
            return this[ATTR_RB_TAGS].map(tag => tag[0][1]);
        return []
    }

    // example [ 'Tila', 'Toimenpide', 'Otsikko' ]
    getRbTagTitles() {
        if (this.hasNonEmptyArray(ATTR_RB_TAGS)) {
            return this[ATTR_RB_TAGS].map(tag => tag[0][0]);
        }
        return []
    }

    // example input: 2, output "tag8" - undefined if out or range
    tagIndexToId(rgIindex) {
        if (rgIindex < 0 || rgIindex > this.getRbTags().length-1) {
            return undefined;
        }
        return this.getRbTags()[rgIindex];
    }

    // example input: "tag8", output 2 - undefined if not found
    tagIdToIndex(tagId) {
        let index = this.getRbTags().indexOf(tagId);
        return index >= 0 ? index : undefined;
    }

    // example 0 [ 'Havaittu', 'Korjattu', 'Tarkastettu', 'Ei voi korjata', 'Tiedoksi', 'Muu tila 1', 'Muu tila 2' ]
    // example 1 [ 'Korjattava', 'Seurataan', 'Lisätyö' ]
    // example 2 [ 'Maatyöt', 'Runko', 'Pinnat', 'Kalusteet' ]
    getRbTagLabels(tagInd) {
        if (!this.hasNonEmptyArray(ATTR_RB_TAGS)) {
            return [];
        }
        if (this[ATTR_RB_TAGS].length <= tagInd) {
            return [];
        }
        if (!isInteger(tagInd)) {
            prosLogErr('getRbTagLabels() tagInd', tagInd, 'is not integer');
            return[];
        }
        return this[ATTR_RB_TAGS][tagInd].slice(1).map(rtag => rtag[0]);
    }

    /**
     * Get multivalue option labels sorted as user selected in project settings #2.45
     * @param tagInd    Multivalue tag index 0..n-1
     */
    // example 0 [ 'Havaittu', 'Korjattu', 'Tarkastettu', 'Ei voi korjata', 'Tiedoksi', 'Muu tila 1', 'Muu tila 2' ]
    // example 1 [ 'Korjattava', 'Seurataan', 'Lisätyö' ]
    // example 2 [ 'Maatyöt', 'Runko', 'Pinnat', 'Kalusteet' ]
    getRbTagLabelsSorted(rgInd, incudeNotUsed=false) {
        let mvTag = this.getMvTagSettings(rgInd)
        if (!mvTag) {
            return []
        }
        return mvTag.options
            .filter(option => option.inUse || incudeNotUsed)
            .map(option => option.label)
    }

    // Get state TAG text
    getStateText(tagVal) {
        let tagInd = this.tagIdToIndex(this.getStateRbTag())
        if (tagInd === undefined) {
            return "?"
        }
        let stateTexts = this.getRbTagLabels(tagInd)
        if (tagVal < stateTexts.length) {
            return stateTexts[tagVal]
        }
        return "??"
    }

    isRbOptionInUse(tagInd, optionInd) {
        if (tagInd === undefined) {
            return false;
        }
        if (!this.hasOwnProperty(ATTR_RB_TAGS) || this[ATTR_RB_TAGS].length <= tagInd) {
            return false;
        }
        let rbTag = this[ATTR_RB_TAGS][tagInd];
        if (rbTag.length <= optionInd+1) {
            return false;
        }
        return rbTag[optionInd+1][2];
    }

    /**
     * Get multiselect option colour
     * @param obs                   Observation object
     * @param tag                   TAG id - for example 'tag3'
     * @param useAutoColor          Optionally enable getting autocolor
     * @returns string |undefined   Color hex value when available (else undefined)
     */
    getBgHexNumber(obs, tag, useAutoColor=false) {
        if (!obs || !tag) {
            return undefined;
        }
        let tagValue = obs[tag];
        return this.getBgHexNumberByTagValue(tag, tagValue, useAutoColor)
    }

    /**
     * Get color from project color lookup-table, loopup table is updated when project is loaded and project data changed
     * @param tag                   Tag id - for example 'tag3'
     * @param tagValue              Option value 0..N-1
     * @param useAutoColor          Optionally enable getting autocolor
     * @returns string |undefined   Color hex value when available (else undefined)
     */
    getBgHexNumberByTagValue(tag, tagValue, useAutoColor=false) {
        let hexValue = this.tagColorMap["s" + tag + "-" + tagValue]
        if (hexValue) {
            return hexValue
        } else if (useAutoColor) {
            return this.tagColorMapAuto["s" + tag + "-" + tagValue]
        } else {
            return undefined
        }
    }

    isRbTagMandatory(tag) {
        let stag = 's' + tag;
        if (!this.attrs.hasOwnProperty(stag)) {
            return false;
        }
        // <label>;<inUse>;<mandatory>
        const RG_STR_MANDATORY_INDEX = 2;
        let splitStr = this.attrs[stag].split(';');
        if (splitStr.length < RG_STR_MANDATORY_INDEX) {
            return false;
        }
        return splitStr[RG_STR_MANDATORY_INDEX] === STR_YES;
    }

    // FieldIndex - more info in ProDect-specs.xlsx
    // 0       1       2           3           4          5
    // <label>;<inUse>;<mandatory>;<isLimited>;<textType>;<allowMultiple>
    getTextTagField(txtTag, fieldIndex) {
        let stag = 's' + txtTag;
        if (!this.attrs.hasOwnProperty(stag)) {
            return false;
        }
        let splitStr = this.attrs[stag].split(';');
        if (splitStr.length < fieldIndex) {
            return undefined
        }
        return splitStr[fieldIndex]
    }

    isTxtMandatory(txtTag) {
        return this.getTextTagField(txtTag, 2) === STR_YES
    }

    // Field type is by default (when missing or invalid) 'text' new extensions ref TEXT_FIELD_TYPES
    getTextFieldType(txtTag) {
        let fieldType = this.getTextTagField(txtTag, 4)
        if (!isVarTypeString(fieldType)) {
            return TEXT_FIELD_TYPE_TXT
        }
        let typeBase = fieldType.indexOf("-") > 0 ? fieldType.split('-')[0] : fieldType
        return TEXT_FIELD_TYPES[typeBase] ? fieldType : TEXT_FIELD_TYPE_TXT
    }

    // return {stags: [stag, value], maxInd: <> }
    getTagsByPrefix(attrs, prefix, maxTags) {
        let maxInd = 0;
        let stags = [];
        for (let i = 1; i < maxTags + 1; i++) {
            let stag = prefix + i;
            let found = Object.keys(attrs).find(attr => attr === stag);
            if (found) {
                let value = attrs[found];
                if (value !== undefined && value !== STR_NO_VALUE && value !== '') {
                    maxInd = i;
                    stags.push({
                        stag: stag,
                        value: value
                    });
                }
            }
        }
        return {stags: stags, maxInd: maxInd};
    }

    getFreeTextContent(attrs) {
        if (!attrs) {
            attrs = this.attrs;
        }
        const {stags, maxInd} = this.getTagsByPrefix(attrs, ATTR_STAG_TXT, MAX_STXT_TAGS);
        let tags = [];
        stags.forEach(stag => {
            const [label, inUseStr, mandatoryStr, limitedEditStr, textType] = stag.value.split(";");
            tags.push({
                stag: stag.stag,
                label: label,
                inUse: strToBool(inUseStr),
                isMandatory: strToBool(mandatoryStr),
                limitedEdit: strToBool(limitedEditStr), // restricted access
                textType: textType ? textType : '',     // email, emails, enum-x, enums-x ...
                removed: false
            })
        });
        return {
            maxInd: maxInd,
            tags: tags
        }
    }

    getOnOffContent(attrs) {
        if (!attrs) {
            attrs = this.attrs;
        }
        const {stags, maxInd} = this.getTagsByPrefix(attrs, ATTR_STAG_CH, MAX_CH_TAGS);
        let tags = [];
        stags.forEach(stag => {
            const [label, inUseStr, opt2Str, limitedEditStr] = stag.value.split(";");
            tags.push({
                stag: stag.stag,
                label: label,
                inUse: strToBool(inUseStr),
                opt2: strToBool(opt2Str),
                limitedEdit: strToBool(limitedEditStr),
                removed: false
            })
        });
        return {
            maxInd: maxInd,
            tags: tags
        }
    }

    defaultMultiValueRb(rgInd, rbInd) {
        // Default limited access right for 1st RG - radio group / State
        if (rgInd) {
            return false;
        }
        return DEFAULT_LIMITED_ACCESS_STATE_INDECES.indexOf(rbInd) >= 0;
    }

    defaultIsLate(rgInd, rbInd) {
        if (rgInd) {
            return false;
        }
        return DEFAULT_STATE_CAN_BE_LATE.indexOf(rbInd) >= 0;
    }

    /**
     *
     * @param rgInd - multivalue tag index, index 0 == State
     * @param attrs - when not defined use project - can also be used to get search obj settings
     * @returns {{}|undefined}  - ref result of getMvTagSettingsByStagAndVal()
     */
    getMvTagSettings(rgInd, attrs) {
        attrs = attrs || this.attrs;
        let tag = this.tagIndexToId(rgInd);
        if (!tag) {
            return undefined;
        }
        let stag = 's' + tag;
        if (!attrs.hasOwnProperty(stag) ||
            attrs[stag] === STR_NO_VALUE ||
            attrs[stag] === '') {
            return undefined;
        }
        return this.getMvTagSettingsByStagAndVal(attrs, rgInd, stag, attrs[stag]);
    }

    getMvTagSettingsByStagAndVal(attrs, rgInd, stag, tagValue) {
        let tagStrs = tagValue.split(";;")
        let mvTag = {}
        let mvOptions = []
        tagStrs.forEach((tagStr, rbInd) => {
            const [label, inUseStr, isMandatory, color, limitedEditStr, isLate, uiOrder] = tagStr.split(";");
            if (rbInd === 0) {
                let parseduiOrder = getValidInteger(uiOrder, rgInd, 0, MAX_RB_TAGS - 1)
                // index 0 is Radio Group setting
                mvTag.stag = stag;
                mvTag.label = label;
                mvTag.inUse = strToBool(inUseStr);
                mvTag.isMandatory = strToBool(isMandatory);
                mvTag.color = color;
                mvTag.limitedEdit = strToBool(limitedEditStr, rgInd === 0);
                mvTag.uiOrder = parseduiOrder;  // Prepared for #2.233
                mvTag.removed = false;
                mvTag.options = [];
            } else {
                // index 1..N is multivalue / Radio Button setting
                let parseduiOrder = getValidInteger(uiOrder, rbInd-1, 0, MAX_RB_OPTIONS - 1)
                mvOptions.push({
                    label: label,
                    inUse: strToBool(inUseStr),
                    isMandatory: strToBool(isMandatory),
                    color: color,
                    limitedEdit: strToBool(limitedEditStr, this.defaultMultiValueRb(rgInd, rbInd-1)),
                    isLate: strToBool(isLate, this.defaultIsLate(rgInd, rbInd-1)),  // Does option trigger late signal. Only for "Tila"
                    uiOrder: parseduiOrder,     // #2.45
                    optionIndex: rbInd-1,   // options indexed 0, 1, 2, ..., N-1
                    removed: false
                })
            }
        });
        mvTag.options = mvOptions.sort((a,b) => a.uiOrder-b.uiOrder)
        return mvTag;
    }

    getMultiValueContent(attrs) {
        if (!attrs) {
            attrs = this.attrs;
        }
        const {stags, maxInd} = this.getTagsByPrefix(attrs, ATTR_STAG, MAX_RB_TAGS); // 'stag1', 'stag2'
        let tags = [];
        stags.forEach((tagVal, rgInd) => {
            let tagSettings = this.getMvTagSettingsByStagAndVal(attrs, rgInd, tagVal.stag, tagVal.value);
            if (tagSettings) {
                tags.push(tagSettings);
            }
        });
        return {
            maxInd: maxInd,
            tags: tags
        }
    }

    isExpirationDateMissing(obs) {
        return this.attrs.hasOwnProperty(ATTR_EXPIRATION_REQUIRED)
            && this.attrs[ATTR_EXPIRATION_REQUIRED] === STR_YES
            && getExpiration(obs) <= 0;
    }

    isRbTagMissing(obs, tag) {
        if(!this.isRbTagMandatory(tag)) {
            return false;
        }
        let origObs = getOriginal(obs);
        if (!origObs.hasOwnProperty(tag)) {
            return true;
        }
        return origObs[tag] === STR_NO_VALUE;
    }

    isTxtTagMissing(obs, tag) {
        if(!this.isTxtMandatory(tag)) {
            return false;
        }
        let origObs = getOriginal(obs);
        if (!origObs.hasOwnProperty(tag)) {
            return true;
        }
        return origObs[tag] === STR_NO_VALUE;
    }

    // returns number of OBS missing a mandatory attributes
    countMissingMandatoryAttribute(obs) {
        let missingRgTags = this.getRbTags()
            .filter(tag => this.isRbTagMissing(obs, tag))
        let missingTxtTags = this.getTxtTags()
            .filter(tag => this.isTxtTagMissing(obs, tag))
        let missingMandatoryCount =
            missingRgTags.length +
            missingTxtTags.length
        if (this.isExpirationDateMissing(obs)) {
            missingMandatoryCount++
        }
        return missingMandatoryCount
    }

    // input
    //      rgInd - multivalue tag index, 0 == State
    //      rbInd - multivalue option index, -1 when no multivalue option been selected
    // returns true if may edit with current user permission
    mayEditRgTag(rgInd, rbInd) {
        let mvTag = this.getMvTagSettings(rgInd);
        if (!mvTag || !mvTag.inUse) {
            return false;
        }
        if (hasPermissionTo("editAllMarker", undefined, undefined, false)) {
            return true;
        }
        if ( ! mvTag.limitedEdit) {
            return false
        }
        let option = mvTag.options.find(option => option.optionIndex === rbInd)
        if (option && !option.inUse) {
            return false
        }
        if (hasPermissionTo("editMarker", undefined, undefined, false)) {
            return (option && option.limitedEdit) || rbInd < 0
        }
        return false;
    }

    // returns
    //      list of RG TAG indexes that user may select
    //          full access: 0, 1, ..N-1
    //          repair/restricted access: those options that user is allowed to edit
    //          reader: empty []
    getMayEditRbTagIndeces(obs, rgInd) {
        let isPrjActive = activeProject && isActive(activeProject.attrs)
        if (!isPrjActive) {
            return []
        }
        let mvTag = this.getMvTagSettings(rgInd)
        if (!mvTag) {
            return []
        }
        if ([ROLE_ADMIN, ROLE_INSPECT].indexOf(getUserRole()) >= 0) {
            // Admin and wide access return all options sorted by project settings
            return mvTag.options.map(option => option.optionIndex)
        }
        if (getUserRole() !== ROLE_REPAIR) {
            return []
        }
        // make list of options that can be edited by ROLE_REPAIR
        let restrictedOptions = mvTag.options
            .filter(option => option.limitedEdit)
            .map(option => option.uiOrder)
        let tag = this.tagIndexToId(rgInd)
        let tagVal = parseInt(obs[tag])
        if (tagVal >= 0 && restrictedOptions.indexOf(tagVal) < 0) {
            // Current multivalue is one of the "restricted for limited access rights"
            // no change is permitted with limited returning an empty list
            return []
        }
        return restrictedOptions
    }

    isProjectStateOngoing(tagValStr) {
        if (tagValStr === undefined) {
            return true;
        }
        let tagVal = parseInt(tagValStr);
        let stag = 's' + this.getStateRbTag();
        if (!this.attrs.hasOwnProperty(stag)) {
            return true;
        }
        // 0        1       2               3       4           5
        // <label>;<inUse>;<isMandatory>;<color>;<limitedEdit>;<isLate>;<uiOrder>
        const TXT_STR_IS_LATE = 5;
        let stateStrs = this.attrs[stag].split(';;');
        if (tagVal >= stateStrs.length-1 || tagVal < 0) {
            return true;
        }
        let splitStr = stateStrs[tagVal+1]
        if (!splitStr) {
            return true
        }
        let splitStrs = splitStr.split(';');
        if (splitStrs.length < TXT_STR_IS_LATE) {
            return DEFAULT_STATE_CAN_BE_LATE.indexOf(tagVal) >= 0;
        }
        return splitStrs[TXT_STR_IS_LATE] === STR_YES;
    }

    getMayEditCheckBoxOrText(tag) {
        let stag = 's' + tag;
        if (!this.attrs.hasOwnProperty(stag)) {
            return false;
        }
        if (hasPermissionTo("editObj", undefined, undefined, false)) {
            return true;
        }
        if (getUserRole() !== ROLE_REPAIR) {
            return false;
        }
        // <label>;<inUse>;<opt2/isMandatory>;<limitedEdit>
        const TXT_STR_LIMITED_EDIT = 3;
        let splitStr = this.attrs[stag].split(';');
        if (splitStr.length < TXT_STR_LIMITED_EDIT) {
            return false;
        }
        return splitStr[TXT_STR_LIMITED_EDIT] === STR_YES;
    }

    getNotSelectedReportIds() {
        return this.objs
            .filter(item => item[ATTR_OBJ_TYPE] === OBJ_TYPE_LST)
            .map(report => report[ATTR_OBJ_ID])
            .filter(reportId => !this.selectedReports.find(id => id === reportId))
    }

    /**
     * Get report previous title or OBS or undefined if none
     */
    getPreviousReportRootItem(item) {
        let listId = getObjListIdFromItemId(item[ATTR_OBJ_ID])
        let previousItems = this.objs
            .filter(o => o[ATTR_OBJ_ID].indexOf(listId) === 0 &&
                            o[ATTR_SORT_ORDER_I] < item[ATTR_SORT_ORDER_I] &&
                            ( o[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS ||
                              o[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE )
            )
        return previousItems.length ? previousItems[previousItems.length-1] : undefined
    }

    /**
     * Checke object type betweeb title --- OBS -- comment
     * @param item
     * @param newType
     * @returns {Promise<void>}
     */
    async saveObjectTypeChange(item, newType) {
        if (!newType) {
            // WA for user pressing save w/o selecting type
            return
        }
        let prevType = item[ATTR_OBJ_TYPE]
        let itemsToUpdate = []
        item[ATTR_OBJ_TYPE] = newType
        if (item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
            // Set default state if "obs state" missing
            let stateTag = this.getStateRbTag();
            if (!item.hasOwnProperty(stateTag)) {
                item[stateTag] = this.getDefaultState()
            }
        }

        let newRootObj = this.getPreviousReportRootItem(item)
        let sortOrder = item[ATTR_SORT_ORDER_I]

        if (prevType === OBJ_TYPE_ITM_OBS) {
            // Save previous parent and void parent obs info
            item[ATTR_SAVED_OBS_PARENT] = item[ATTR_PARENT_OBS]
            item[ATTR_PARENT_OBS] = STR_NO_VALUE
        }
        if (newType === OBJ_TYPE_ITM_OBS) {
            item[ATTR_PARENT_OBS] = STR_NO_VALUE
        } else {
            // -> comment or title
            let newParentObsId = STR_NO_VALUE
            if (newRootObj && newRootObj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
                // OBS Move OBS child items to previous OBS if that exists
                newParentObsId = newRootObj[ATTR_OBJ_ID]
                let newParentObsChildren = undefined
                if (newRootObj[OBS_OBJ_LIST] && newRootObj[OBS_OBJ_LIST].length > 0) {
                    newParentObsChildren = newRootObj[OBS_OBJ_LIST]
                    let lastChild = newParentObsChildren[newRootObj[OBS_OBJ_LIST].length-1]
                    sortOrder = lastChild[ATTR_SORT_ORDER_I] + DEFAULT_SORT_ORDER_SPACING
                } else {
                    sortOrder = newRootObj[ATTR_SORT_ORDER_I] + DEFAULT_SORT_ORDER_SPACING
                }
            }
            item[ATTR_PARENT_OBS] = newType === OBJ_TYPE_ITM_TITLE ? STR_NO_VALUE : newParentObsId
            if (item[OBS_OBJ_LIST] && item[OBS_OBJ_LIST].length > 0) {
                // Move OBS child items to previous obs or after a title
                for (let childItem of item[OBS_OBJ_LIST]) {
                    childItem[ATTR_PARENT_OBS] = newParentObsId
                    childItem[ATTR_SORT_ORDER_I] = sortOrder
                    sortOrder += DEFAULT_SORT_ORDER_SPACING
                    itemsToUpdate.push(childItem)
                }
            }
        }
        itemsToUpdate.push(item)
        await this.awaitUpdateMultipleItems(itemsToUpdate, true)
    }


    async awaitAddReport(name, afterReport) {
        let obj = {};
        obj[ATTR_OBJ_TYPE]= OBJ_TYPE_LST;
        obj[ATTR_TEXT] = name;
        return await this.awaitAddObject(obj, undefined, afterReport);
    }

    async awaitAddObs(name, listId, afterObj) {
        let obj = {}
        obj[ATTR_OBJ_TYPE] = OBJ_TYPE_ITM_OBS
        obj[ATTR_TEXT] = name
        // OBS default state is added by server
        return await this.awaitAddObject(obj, listId, afterObj)
    }

    async awaitAddObsWithAttrs(obs, listId, afterObj) {
        obs[ATTR_OBJ_TYPE] = OBJ_TYPE_ITM_OBS;
        let newObjId = await this.awaitAddObject(obs, listId, afterObj)
        projectLoader.refreshUi("awaitAddObsWithAttrs", {newObsId: newObjId})
    }

    async awaitAddTextItem(name, listId, afterObj) {
        let obj = {};
        obj[ATTR_OBJ_TYPE] = OBJ_TYPE_ITM
        obj[ATTR_TEXT] = name
        return await this.awaitAddObject(obj, listId, afterObj)
    }

    async awaitAddTitle(name, listId, afterObj) {
        let obj = {};
        obj[ATTR_OBJ_TYPE]= OBJ_TYPE_ITM_TITLE
        obj[ATTR_TEXT] = name
        return await this.awaitAddObject(obj, listId, afterObj)
    }

    // async awaitAddPdfToObs(fileName, listId, afterObjId) {
    //     let obj = {};
    //     obj[ATTR_OBJ_TYPE]= OBJ_TYPE_ITM_PDF;
    //     obj[ATTR_PDF_NAME] = fileName;
    //     return await this.awaitAddObject(obj, listId, afterObjId);
    // }

    async awaitAddPictOrVideoToObs(fileName, obs) {
        let afterObj = obs
        if (obs[OBS_OBJ_LIST].length > 0) {
            afterObj = obs[OBS_OBJ_LIST][obs.obsObjList.length-1];
        }
        let obj = isVideoFileName(fileName) ?
            this.makeVideoObject(fileName) :
            this.makePictObject(fileName)
        obj[ATTR_PARENT_OBS] = obs[ATTR_OBJ_ID];
        let listId = getObjListId(afterObj);
        return await this.awaitAddObject(obj, listId, afterObj[ATTR_OBJ_ID]);
    }

    makePictObject(fileName) {
        let obj = {};
        obj[ATTR_OBJ_STATE]= OBJ_STATE_WAIT;
        obj[ATTR_OBJ_TYPE]= OBJ_TYPE_ITM_PICT;
        if (isFileTypePdf(fileName)) {
            obj[ATTR_PDF_NAME] = fileName;
        } else {
            obj[ATTR_FILE_NAME] = fileName;
        }
        updateUiPollingActivity(true);
        return obj;
    }

    makeVideoObject(fileName) {
        let obj = {};
        obj[ATTR_OBJ_STATE]= OBJ_STATE_ACT
        obj[ATTR_OBJ_TYPE]= OBJ_TYPE_ITM_VIDEO
        obj[ATTR_FILE_NAME] = fileName;
        // current mobile app default type is text
        obj[ATTR_TEXT] = 'video'
        return obj
    }

    async awaitAddPictAfterItem(fileName, listId, afterObjId) {
        let obj = this.makePictObject(fileName);
        return await this.awaitAddObject(obj, listId, afterObjId);
    }

    async awaitAddPictLocItem(fileName, listId, afterObjId, marker, zoomInfo) {
        let obj = this.makePictObject(fileName);
        obj[ATTR_OBJ_TYPE]= OBJ_TYPE_ITM_PICT_LOC;
        if (zoomInfo) {
            obj[ATTR_PICT_ZOOM] = zoomInfo
        }
        if (marker) {
            setPictureMarkerLocation(obj, marker)
        }
        return await this.awaitAddObject(obj, listId, afterObjId);
    }

    async awaitCommentObs(comment, obs) {
        let listId = getObjListId(obs);
        let afterItem = obs;
        if (obs[OBS_OBJ_LIST].length > 0) {
            afterItem = obs[OBS_OBJ_LIST][obs.obsObjList.length-1];
        }
        let obj = {};
        obj[ATTR_OBJ_TYPE]= OBJ_TYPE_ITM;
        obj[ATTR_TEXT] = comment;
        obj[ATTR_PARENT_OBS] = obs[ATTR_OBJ_ID];
        return await this.awaitAddObject(obj, listId, afterItem[ATTR_OBJ_ID]);
    }

    findObjIndex(objId) {
        let index = activeProject.objs.findIndex(x=> x[ATTR_OBJ_ID]=== objId);
        if (index < 0 || index >= activeProject.objs.length) {
            return -1
        }
        return index;
    }

    // findItemsObs(objId) {
    //     for (let i in activeProject.uiItems) {
    //         let item = activeProject.uiItems[i];
    //         if (item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
    //             for (let j in item[OBS_OBJ_LIST]) {
    //                 let obsItem = item[OBS_OBJ_LIST][j];
    //                 if (obsItem[ATTR_OBJ_ID] === objId) {
    //                     prosLog('findItemsObs()', objId, ' -> ', i);
    //                     return activeProject.uiItems[i];
    //                 }
    //             }
    //         }
    //     }
    //     prosLog('findItemsObs()', objId, 'not found');
    //     return undefined;
    // }

    /**
     * Item is a child item of an OBS when it has a parent obs attribute
     */
    isObsChildItem(item) {
        return ITEM_TYPES_SUB.indexOf(item[ATTR_OBJ_TYPE] >= 0) &&
            getValidAttr(item, ATTR_PARENT_OBS, STR_NO_VALUE) !== STR_NO_VALUE
    }

    /**
     * Used to determine sort order for obs or item to be added.
     * Get index of item - either a root obj (title, obs, comment, picture) or
     *                  - obs child item with same parent obs id
     * @param prevInd - index in project objects after  which new item will be added
     *                  - either as as target for ... menu or drag & drop
     * @param forObj - object for which to give sort order
     */
    getNextReportObject(prevInd, forObj) {
        if (prevInd >= this.objs.length) {
            // after item is the last one
            return undefined
        }
        let afterObj = this.objs[prevInd]
        let reportId = getObjListId(afterObj)
        let reportItemsAfter = this.objs
            .slice(prevInd+1)
            .filter(item => item[ATTR_OBJ_ID].indexOf(reportId) === 0)
        let isObsChild = this.isObsChildItem(forObj)
        let followingItems = isObsChild ?
            reportItemsAfter.filter(item => item[ATTR_PARENT_OBS] === forObj[ATTR_PARENT_OBS]):
            reportItemsAfter.filter(item => !this.isObsChildItem(item))
        if (followingItems.length < 1) {
            // no items after
            return undefined
        }
        return followingItems[0]
    }

    /**
     * Calculate a new sort order for project object (report, OBS, item). Options
     *   adding a report after a report
     *   adding OBS, title or root object picture / comment on report root object list (obsList)
     *   adding a OBS item (picture, comment) into OBS items list
     * @param forObj        Object that is to be moved or added
     * @param afterObjId    Object ID after which to add to compute sortOrder
     * @returns sort order
     */
    getSortOrderAfter(forObj, afterObjId) {
        // By default returns current time when adding new report/OBS/comment at the end of parent list
        let newSortOrder = currentTimeMs()
        let afterObj = getObjById(afterObjId)
        if (!afterObj) {
            prosLogErr("No object to move after", afterObjId)
            return newSortOrder;
        }
        if (isReportType(afterObj)) {
            // moving to top of report
            if (afterObj[OBS_LIST].length < 1) {
                // report root obj list is empty - give report sort order + 1
                newSortOrder = parseInt(afterObj[ATTR_CREATED_MS_I]) + 1
            } else {
                let firstObjInReport = afterObj[OBS_LIST][0]
                newSortOrder = parseInt(firstObjInReport[ATTR_SORT_ORDER_I]) - DEFAULT_SORT_ORDER_SPACING
            }
            return newSortOrder
        }
        // OBS or item within OBS
        let prevInd = this.findObjIndex(afterObjId)
        if (!prevInd || prevInd < 0 || prevInd >= this.objs.length) {
            prosLogErr('Prev obj not found after', afterObjId, 'prevInd', prevInd)
        } else {
            let sortValPrev = parseInt(this.objs[prevInd][ATTR_SORT_ORDER_I])
            let nextItem = this.getNextReportObject(prevInd, forObj)
            if (nextItem) {
                // place item(s) into report between prev and next with equal spacing
                let sortValNext = parseInt(nextItem[ATTR_SORT_ORDER_I])
                let spacing = Math.floor((sortValNext - sortValPrev) / 2)
                newSortOrder = sortValPrev + spacing
                prosLog('sortValPrev', sortValPrev, 'sortValNext', sortValNext, '->', newSortOrder)
            } else {
                // place item after last using current time as sort order #13.53
                newSortOrder = currentTimeMs()
            }
        }
        return newSortOrder
    }

    getPrevObjId(obj) {
        let index = this.findObjIndex(obj.obj_id);
        if (index > 0) {
            return activeProject.objs[index-1].obj_id;
        }
        return undefined
    }

    makeNewReportId() {
        return uuidv4() + '-' + getDevId()
    }

    addParentObsWhenNeeded(obj, afterObjId) {
        if (ITEM_TYPES_SUB.indexOf(obj[ATTR_OBJ_TYPE]) < 0) {
            // this obj type can not belong to an OBS
            return
        }
        if (obj.hasOwnProperty(ATTR_PARENT_OBS)) {
            // parent OBS already been set
            return
        }
        let afterObj = getObjById(afterObjId)
        if (afterObj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
            // "after" is an OBS
            obj[ATTR_PARENT_OBS] = afterObj[ATTR_OBJ_ID]
        } else if (afterObj.hasOwnProperty(ATTR_PARENT_OBS)) {
            // "after" OBS child item - copy parent OBS from it
            obj[ATTR_PARENT_OBS] = afterObj[ATTR_PARENT_OBS]
        }
    }

    async awaitAddObject(obj, listId, afterObjId) {
        prosLog('awaitAddObject() obj:', obj, 'listId:', listId, 'afterObjId:' , afterObjId);
        if (!activeProject) { throw new Error('Need active project'); }
        let newOid;
        let sortOrder = currentTimeMs; // Default sort order is current time #13.53
        if (listId && afterObjId) {
            newOid = makeNewObjId(listId);
            this.addParentObsWhenNeeded(obj, afterObjId)
            if (afterObjId) {
                // add in between
                sortOrder = this.getSortOrderAfter(obj, afterObjId);
            } else {
                sortOrder = currentTimeMs();
            }
        } else if (listId) {
            // new obj into an existing list get ts as an unique prefix
            newOid = makeNewObjId(listId);
        } else {
            // new list - generate a new uuid
            sortOrder = currentTimeMs();
            newOid = this.makeNewReportId();
        }
        obj[ATTR_OBJ_ID] = newOid;
        obj[ATTR_OBJ_STATE] = OBJ_STATE_ACT;
        let copyObj = makeObjCopyForAws(obj);
        copyObj[ATTR_SORT_ORDER_I] = sortOrder;
        // this.updateItemFromAws(copyObj);
        if (copyObj[ATTR_OBJ_STATE] !== OBJ_STATE_WAIT) {
            copyObj[ATTR_OBJ_STATE] = OBJ_STATE_CREATE;
        }
        await this.awaitUpdateItem(copyObj, true);
        return newOid;
    }

    async awaitRemoveItem(item, triggerAwsRefresh = true) {
        prosLog("Removing ", item.obj_id, item.text );
        if (!activeProject) { throw new Error('Need active project'); }
        if (item[ATTR_OBJ_TYPE] === OBJ_TYPE_PRJ) {
            recentlyRemovedProjects.push(item[ATTR_AWS_PROJECT_ID]);
            // prosLogX("Project removed", item[ATTR_AWS_PROJECT_ID], "count", recentlyRemovedProjects.length)
        }
        item[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL;
        removeFromHelp(item[ATTR_OBJ_ID]);
        let removeObjs = [item];
        if (getOriginal(item)[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS && item.obsObjList.length > 0) {
            // remove OBS sub-items
            for (let i in item.obsObjList) {
                let subItem = item.obsObjList[i];
                subItem[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL;
                removeFromHelp(subItem[ATTR_OBJ_ID]);
                removeObjs.push(subItem);
                prosLog("Removing sub-item",  subItem.obj_id, subItem.text );
            }
        }
        await this.awaitUpdateMultipleItems(removeObjs, triggerAwsRefresh);
        if (item[ATTR_OBJ_TYPE] === OBJ_TYPE_PRJ) {
            // void project list cache to refresh project list
            saveLocalSetting('lastTimeLastUpdatedProjectsMs', 0);
        }
    }

    async awaitUpdateItem(item, triggerAwsRefresh=true) {
        if (item.obj_type === OBJ_TYPE_PRJ) {
            cacheProjectName(item)
        }
        await this.awaitUpdateMultipleItems([item], triggerAwsRefresh)
    }

    async awaitUpdateMultipleItemsChunks(items, chunkSize, triggerAwsRefresh=true) {
        while (items.length) {
            const chunkList = items.splice(0, chunkSize)
            await this.awaitUpdateMultipleItems(chunkList, triggerAwsRefresh)
        }
    }

    /**
     * @param items - to be added or updated
     * @param triggerAwsRefresh - refresh after update
     * @returns {Promise<void>} - promise - continue after completed
     *
     * Object id will be automatically created when have a 'pros_list_id' to indicate that make new object.
     * All standard attributes like state, created, updated, user email etc will be added.
     */
    async awaitUpdateMultipleItems(items, triggerAwsRefresh) {
        if (!activeProject) { throw new Error('Need active project'); }
        let req = makeAwsReqParams(true);
        req[ATTR_AWS_PROJECT_ID] = this.getPid();
        req[ATTR_WEB_OPERATION] = WEB_OPER_UPDATE_OBJ;
        let copyObjs = [];
        for (let item of items) {
            if (!item.hasOwnProperty(ATTR_OBJ_TYPE)) {
                throw new Error('Type for a new obj required');
            }
            item[ATTR_UPDATED_MS_I] = currentTimeMs();
            if (!item.hasOwnProperty(ATTR_CREATED_MS_I)) {
                item[ATTR_CREATED_MS_I] = item[ATTR_UPDATED_MS_I];
            }
            if (item.hasOwnProperty(ATTR_AWS_PROJECT_ID) && !item.hasOwnProperty(ATTR_OBJ_ID)) {
                item[PROS_REPLACE_BY_LIST_ID] = getProjectUsersListId(item[ATTR_AWS_PROJECT_ID]);
            }
            let copyObj = makeObjCopyForAws(item);
            if (copyObj.hasOwnProperty(PROS_REPLACE_BY_LIST_ID)) {
                // add new object to requested list
                copyObj[ATTR_OBJ_STATE] = OBJ_STATE_CREATE;
                copyObj[ATTR_OBJ_ID] = makeNewObjId(copyObj[PROS_REPLACE_BY_LIST_ID]);
                delete copyObj[PROS_REPLACE_BY_LIST_ID];
            } else if (!copyObj.hasOwnProperty(ATTR_OBJ_ID)) {
                // default assume adding a new user to project user's list
                copyObj[ATTR_OBJ_STATE] = OBJ_STATE_CREATE;
                copyObj[ATTR_OBJ_ID] = makeNewObjId(this.usersListId);
            }
            copyObjs.push(copyObj);
        }

        // 2023-3-8 removed as very seldom has such and new sw versions should prevent such
        // this.addSortOrderConsolidationRequestIfNeeded(copyObjs)

        let reqList = [req].concat(copyObjs);
        let result = await this.changeItemInAws(reqList);
        this.handleItemUpdateResponse(result);
        if (triggerAwsRefresh) {
            await this.awaitRefreshProjectObjectsFromAws();
        }
    }

    /**
     * @param items - list of items with attributes to be changed
     *              - ATTR_OBJ_ID and ATTR_OBJ_TYPE is required
     *              - server assumes project ID (ATTR_AWS_PROJECT_ID) to be current active project when missing
     * @param triggerAwsRefresh - refresh after update
     * @returns {Promise<void>} - promise - continue after completed
     * To add a new item or change all item attributes use awaitUpdateMultipleItems()
     */
    async awaitUpdateMultipleItemsAttributes(items, triggerAwsRefresh=true) {
        if (!activeProject) { throw new Error('Need active project'); }
        let req = makeAwsReqParams();
        req[ATTR_AWS_PROJECT_ID] = this.getPid();
        req[ATTR_WEB_OPERATION] = WEB_OPER_UPDATE_ATTRS;
        for (let item of items) {
            for (let key in item) {
                if (attrForUiOnly(key)) {
                    throw new Error('Trying to save UI attribute');
                }
            }
        }
        let reqList = [req].concat(items);
        let result = await this.changeItemInAws(reqList);
        this.handleItemUpdateResponse(result);
        if (triggerAwsRefresh) {
            await this.awaitRefreshProjectObjectsFromAws();
        }
    }

    async awaitUpdateItemAttrs(item, attrs, triggerAwsRefresh=true) {
        let changeObj = getChangeObj(item, attrs)
        await this.awaitUpdateMultipleItemsAttributes([changeObj], true);
    }

    /**
     * Create picture item by adding it to eof list (report) or after a comment or obs
     * todo 2022 check set parent OBS
     * @param fileNameInAws
     * @param addAfterItem
     * @returns {Promise<string>} returns obj id of the added item
     * item state is set as WAIT until server has a thumb nail picture ready
     */
    async createPictureItem(fileNameInAws, addAfterItem) {
        if (isReportType(addAfterItem)) {
            let prevObjId = addAfterItem.obj_id
            return await this.awaitAddPictAfterItem(fileNameInAws, prevObjId)
        }
        return await this.awaitAddPictOrVideoToObs(fileNameInAws, addAfterItem)
    }


    /**
     * Set a request for server to align report sort_orders if are not ascending
     * @param objsToServer  List of change objects to server
     */
    /* Not in use 2023-3-8 but keep in src for a while
    addSortOrderConsolidationRequestIfNeeded(objsToServer) {
        const MINIMUM_SORT_ORDER_SPACING_TO_ADJUST = 4
        let startedMs = currentTimeMs()
        let firstObj = objsToServer[0]
        let reportId = getObjListId(firstObj)   // get report ID from 1st item to change

        let prev_root_order = 0
        let needFixCount = 0

        function check_same_sort(item, is_root, objs) {
            // Align sort order spacing between report root and OBS child items ref server "check_same_sort"
            let items_so = item[ATTR_SORT_ORDER_I]
            let prev_sort
            let obs
            if (is_root) {
                prev_sort = prev_root_order
            } else {
                obs = objs.find(itm => itm[ATTR_OBJ_ID] === item[ATTR_PARENT_OBS])
                if (!obs) {
                    // do not check orphan child item - would not have such after project all items loaded
                    return
                }
                prev_sort = obs.ui_prev_child_so
            }
            if (items_so - prev_sort < MINIMUM_SORT_ORDER_SPACING_TO_ADJUST) {
                needFixCount += 1
            }
            prev_sort = items_so
            if (is_root) {
                prev_root_order = prev_sort
            } else {
                obs.ui_prev_child_so = prev_sort
            }
        }
        this.objs
            .filter(item => item[ATTR_OBJ_ID].indexOf(reportId) === 0 && item[ATTR_OBJ_ID] !== reportId) // report's item
            .forEach(item => {
                if (item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
                    check_same_sort(item, true)
                    item.ui_prev_child_so = prev_root_order
                } else {
                    let parentObs = item[ATTR_PARENT_OBS]
                    let is_root = (parentObs === undefined || parentObs === STR_NO_VALUE) ||
                        item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE
                    check_same_sort(item, is_root, this.objs)
                }
            })
        if (needFixCount > 0) {
            prosLog("SO adjust pid:", getActiveProjectID(), "report:", reportId, "needFixCount:", needFixCount)
            objsToServer.push({
                [ATTR_OBJ_TYPE]: "req_align_sort_orders",
                [ATTR_OBJ_ID]: reportId
            })
        }
        console.log("Time spent", currentTimeMs() - startedMs, "ms")
    }
     */

    /**
     * Request from server new data based on project age
     * @param refreshProject     Forced update request to update project json export
     * @returns {Promise<void>}  Number of items updated
     */
    async awaitRefreshProjectObjectsFromAws(refreshProject) {
        if (isLoadingProject()) {
            prosLog("ProsConnect: awaitRefreshProjectObjectsFromAws() SKIP AS BUSY, refreshProject:", refreshProject)
            return 0
        }
        prosLog("ProsConnect: awaitRefreshProjectObjectsFromAws(), refreshProject:", refreshProject)
        let response = await getActiveProject().refreshObjectsFromAws(refreshProject);
        let changeCount = 0
        if (activeProject && response) {
            changeCount = activeProject.handleRefresh(response)
            refreshHelpProject(activeProject.getPid(), response)
        }
        return changeCount
    }

    updateProjectAttributes(fromObj) {
        this.setProjectTags(fromObj)
        const REMOVE_TAG_ATTRS = [ATTR_CB_TAGS, ATTR_RB_TAGS, ATTR_TXT_TAGS]
        for (let attr of REMOVE_TAG_ATTRS) {
            delete (fromObj[attr])
        }
        for (let key in fromObj) {
            this.attrs[key] = fromObj[key]
        }
        this.updateProjectAge(fromObj)
    }

    unselectRemovedList(list_id) {
        this.selectedReports = this.selectedReports
            .filter(reportId => reportId !== list_id)
        if (this.selectedSearchId === list_id) {
            this.selectedSearchId = undefined
        }
    }

    updateListFromAws(obj, listType) {
        let found = false;
        if (!this.hasOwnProperty(listType)) {
            // fix 28.5.2019 search and reports in project - not in attrs
            throw new Error('Project missing list type ' + listType);
        }
        let lists = this[listType];
        let isListActive = isActive(obj)
        if (!isListActive) {
            this.unselectRemovedList(obj[ATTR_OBJ_ID])
        }
        for (let i in lists) {
            if (lists[i] === obj[ATTR_OBJ_ID]) {
                found = true;
                if (isListActive) {
                    prosLog("*** found list - has already ", obj.obj_id);
                } else {
                    let cnt1 = lists.length;
                    lists.splice(i, 1);
                    prosLog("*** found list to delete", cnt1, '->', lists.length);
                }
                break;
            }
        }
        if (!found) {
            if (isListActive) {
                lists.push(obj[ATTR_OBJ_ID]);
                prosLog("*** not found list -> add", obj[ATTR_OBJ_ID]);
                // If is a new report add automatically to selected reports
                if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST) {
                    let reportId = obj[ATTR_OBJ_ID]
                    if (!activeProject.selectedReports.includes(reportId)) {
                        activeProject.selectedReports.push(reportId)
                    }
                }
            } else {
                prosLog("*** not found list ignore as deleted", obj[ATTR_OBJ_ID]);
            }
        }
        // update object list
        if (this.objs.length > 0) {
            this.updateItemFromAws(obj)
        }
    }

    updateProjectFromAws(obj) {
        // prosLogX('updateProjectFromAws()', obj)
        if (obj[ATTR_AWS_PROJECT_ID] !== this.getPid()) {
            prosLogErr('Project data for non active project', obj[ATTR_OBJ_ID], 'active:', this.getPid());
            return;
        }
        let prevAge = this.getAge();
        this.updateProjectAttributes(obj);
        prosLog("updated project, age:", prevAge, '->', this.getAge());
        // update object list
        if (this.objs.length > 0) {
            this.updateItemFromAws(obj)
        }
    }

    isReportSelected(objReportId) {
        return this.selectedReports.indexOf(objReportId) >= 0;
    }

    selectProjectAllReports() {
        this.unSelectReports()
        this.getReports(true).forEach(report => {
                this.selectedReports.push(report[ATTR_OBJ_ID])
            }
        )
    }

    // Feature #8.14
    selectAllReportsIfNoneSelected() {
        if (this.selectedReports.length < 1) {
            this.selectProjectAllReports(true)
        }
    }

    /**
     * Get list of report or search report id's
     * @param isSearchMode
     * @returns {*[]}
     */
    getReportsOrSearches(isSearchMode){
        return isSearchMode ?
            this.getSearches() :
            this.getReports(true)
    }

    isDeletedOrActUiObject(obj, listId) {   // todo-tero
        if (obj[ATTR_OBJ_STATE] === OBJ_STATE_ACT ||
            obj[ATTR_OBJ_STATE] === OBJ_STATE_WAIT ||
            obj[ATTR_OBJ_STATE] === OBJ_STATE_DEL ||
            obj[ATTR_OBJ_STATE] === OBJ_STATE_TO_DEL) {
            const objReportId = getObjListId(obj)
            if (listId !== objReportId) {
                return false
            }
            if (objClass(obj) === OBJ_TYPE_ITM) {
                return ITEM_TYPES_NOT_FOR_REPORT_UI.indexOf(obj[ATTR_OBJ_TYPE]) < 0;
            }
        }
        return false;
    }

    isUiObject(obj, specificListId, listId, takeAll) {
        if (obj[ATTR_OBJ_STATE] === OBJ_STATE_ACT ||
            obj[ATTR_OBJ_STATE] === OBJ_STATE_WAIT) {
            if (obj[ATTR_OBJ_ID] === specificListId) {
                return false
            }
            if (specificListId) {
                return specificListId === getObjListId(obj)
            }
            if (listId !== getObjListId(obj)) {
                return false
            }
            if (objClass(obj) === OBJ_TYPE_ITM) {
                let objReportId = getObjListId(obj);
                if (takeAll) {
                    return ITEM_TYPES_NOT_FOR_REPORT_UI.indexOf(obj[ATTR_OBJ_TYPE]) < 0;
                }
                return (this.selectedReports.indexOf(objReportId) >= 0);
            }
        }
        return false;
    }

    async awaitFixLocationPictureListSpacing() {
        let locationPictureList = this.getLocationPictureUiList();
        let MIN_LOC_SPACING = 1000;
        let updateObjsForSpacing = [];
        locationPictureList.forEach(report => {
            let prevOrder = 0;
            report.obsList.forEach( item => {
                if (prevOrder <= 0) {
                    prevOrder = item[ATTR_SORT_ORDER_I];
                } else {
                    if (item[ATTR_SORT_ORDER_I] < prevOrder + MIN_LOC_SPACING) {
                        item[ATTR_SORT_ORDER_I] = prevOrder + MIN_LOC_SPACING;
                        updateObjsForSpacing.push(item);
                    }
                    prevOrder = item[ATTR_SORT_ORDER_I];
                }
            })
        });
        if (updateObjsForSpacing.length > 0) {
            prosLog("Loc picture list items sort order to be updated", updateObjsForSpacing.length);
            await this.awaitUpdateMultipleItems(updateObjsForSpacing, true);
        }
        return locationPictureList;
    }

    getLocationPictureUiList() {
        return this.getUiList(this.getLocationPictureListId())
    }

    hasPendingItems() {
        for (let i in this.objs) {
            if (this.objs[i][ATTR_OBJ_STATE] === OBJ_STATE_WAIT)
                return true;
        }
        return false;
    }


    isUiListLimitedBySize() {
        return uiListSizeLimited;
    }

    getNextReportAfter(afterListId) {
        if (!this.uiItems || this.uiItems.length <= 0) {
            return undefined;
        }
        let foundAfter = false;
        for (let i in this.uiItems) {
            let obj = this.uiItems[i];
            if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST) {
                if (foundAfter) {
                    return obj;
                }
                if (obj[ATTR_OBJ_ID] === afterListId) {
                    foundAfter = true;
                }
            }
        }
        return undefined;
    }

    getReportItems(report) {
        let reportId = report[ATTR_OBJ_ID];
        let items = this.objs
            .filter(obj =>
                    obj[ATTR_OBJ_ID].indexOf(reportId) === 0 &&
                    obj[ATTR_OBJ_TYPE] !== OBJ_TYPE_LST
            );
        // replace REF objects by originals
        for (let i in items) {
            if (items[i][ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_REF) {
                let sortOrdr = getObjAttr(items[i], ATTR_SORT_ORDER_I);
                let parentId = getObjAttr(items[i], ATTR_PARENT_OBS);
                items[i] = makeObjCopyForAws(getOriginal(items[i]));
                items[i][ATTR_SORT_ORDER_I] = sortOrdr;
                if (parentId !== STR_NO_VALUE) {
                    items[i][ATTR_PARENT_OBS] = parentId;
                }
            }
        }
        return items;
    }

    hasLocationPictures() {
        return activeProject && activeProject.locPictListId;
    }

    getLocationPictures(giveOriginal) {
        if (!this.hasLocationPictures()) {
            return []
        }
        let locPictures = []
        let prevPicture
        this.objs
            .filter(itm => itm[ATTR_OBJ_ID].indexOf(activeProject.locPictListId) === 0)
            .forEach(item => {
                if (isPictureItem(item)) {
                    locPictures.push(item)
                    prevPicture = item
                    delete item[ATTR_HAS_PICTURE_LOC]
                    delete item[ATTR_PICTURE_LOC_W]
                    delete item[ATTR_PICTURE_LOC_H]
                    delete item[ATTR_PICTURE_LOC_W_PREV]
                    delete item[ATTR_PICTURE_LOC_H_PREV]
                    delete item[ATTR_PICTURE_OVERLAY]
                    delete item[ATTR_PICTURE_ROTATE]
                } else if (item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM && prevPicture) {
                    prevPicture.ui_caption = item[ATTR_TEXT]
                    prevPicture = undefined;
                }
            });
        return giveOriginal ? locPictures : copyProsObjs(locPictures)
    }

    getItemCountStats() {
        return this.itemCountStats
    }

    hasCapacityToAddItems(hardLimit) {
        let limit = hardLimit ? this.itemCountStats.itemsCountLimit : this.itemCountStats.itemsCountLimit + 10
        return this.itemCountStats.itemsTotal < limit
    }

    getUserObjects() {
        return this.role_objs ? this.role_objs : []
    }

    getObservations() {
        if (this.observations.length === 0) {
            this.observations = this.objs
                .filter(obj =>
                    obj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS &&
                    obj[ATTR_OBJ_STATE] === OBJ_STATE_ACT
                );
        }
        return this.observations
    }

    getReportItemsByReportId(reportId) {
        let report = this.uiItems.find(rep => rep[ATTR_OBJ_ID] === reportId)
        return report ? report.obsList : undefined
    }

    getObsChildren(parentObsId) {
        return this.objs.filter(obj => obj[ATTR_PARENT_OBS] === parentObsId)
    }

    getProjectObjectsByType(objType) {
        return this.objs.filter(obj => 
            obj[ATTR_OBJ_TYPE] === objType &&
            obj[ATTR_OBJ_STATE] === OBJ_STATE_ACT)
    }

    getObjectTypeCount(objType) {
        return this.getProjectObjectsByType(objType).length
    }

    getReports(takeAll) {
        let reports = this.getProjectObjectsByType(OBJ_TYPE_LST)
        if (!takeAll) {
            reports = reports.filter(report => this.isReportSelected(report[ATTR_OBJ_ID]))
        }
        return reports.sort(sortReportOrder)
    }

    getSearches() {
        return this.getProjectObjectsByType(OBJ_TYPE_LST_SEARCH)
            .concat(this.getProjectObjectsByType(OBJ_TYPE_LST_SEARCH_R))
            .sort(sortReportOrder)
            .filter((obj) => (
                !(ATTR_IS_PRIVATE in obj)
                || obj[ATTR_IS_PRIVATE] !== STR_YES
                || obj[ATTR_CREATED_BY] === getUserEmail()
            ))
    }

    getDeletedUiList(deletedItems) {
        const filterTxt = null;
        const specificListId = null;
        const takeAllReportItems=true

        if (!deletedItems || deletedItems.length === 0) {
            return [];
        }
        // Get deleted items w/o parent object deleted

        // start with grouping by type
        const itemsByObjType = deletedItems.reduce((acc, value) => {
            // Group initialization
            if (!acc[value.obj_type]) {
                acc[value.obj_type] = [];
            }
            // Grouping
            acc[value.obj_type].push(value);
            return acc;
        }, {});

        const activeReports = this.getReports(true);

        const activeObs = this.objs.filter((obj) => {
            return obj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS
        });

        const deletedReports = OBJ_TYPE_LST in itemsByObjType ? itemsByObjType[OBJ_TYPE_LST] : [];
        const deletedObs = OBJ_TYPE_ITM_OBS in itemsByObjType ? itemsByObjType[OBJ_TYPE_ITM_OBS] : [];

        // Hierarchy:
        // "lst" (report)
        //    \ "itm_obs" (obs)
        //         \  "itm" or "itm_*" (e.g. comment)

        // Validate which parents are missing for the deleted item, i.e. "lst" or "itm_obs" obj_type can be a parent
        // if itm_* has parent_obs, it's under corresponding "itm_obs"
        // if itm_* has no parent_obs, it's under "lst"
        // We collect missing parents (still active items) so that we can compose full tree
        const activeLstParents = [];
        const activeObsParents = [];
        const findMissingParents = (item) => {
            const parentLstId = getObjListIdFromItemId(item[ATTR_OBJ_ID])
            // 1. Find lst  - if not found, get item from non-deleted/active list of reports
            let lstItem = deletedReports.find(it => parentLstId === it[ATTR_OBJ_ID]);
            if (!lstItem) {
                if (!activeLstParents.find(it => parentLstId === it[ATTR_OBJ_ID])) {
                    let activeLstItem = activeReports.find(it => parentLstId === it[ATTR_OBJ_ID]);
                    if (activeLstItem) {
                        activeLstItem.ui_isOpen = true;
                        activeLstItem.ui_isHistoryItem = true;
                        activeLstItem.ui_removed = true;
                        activeLstParents.push(activeLstItem);
                    } else {
                        prosLogWrn(`Could not find ${OBJ_TYPE_LST} type item when searching parents of deleted item ${item}`);
                    }
                }
            }

            // 2. Find deleted itm_obs by parent_obs when type is sub-item
            // - if not found, get item from active(non-deleted) list of objects
            if (item[ATTR_OBJ_TYPE] !== OBJ_TYPE_ITM_OBS && objClass(item) === OBJ_TYPE_ITM) {
                const parentObsId = item[ATTR_PARENT_OBS];
                if (parentObsId) {
                    const obsItem = deletedObs.find(it => it[ATTR_OBJ_ID] === parentObsId);
                    if (!obsItem) {
                        // Find Obs item by parentObsId  as it's not deleted
                        if (!activeObsParents.find(it => parentObsId === it[ATTR_OBJ_ID])) {
                            let activeItem = activeObs.find(it => parentObsId === it[ATTR_OBJ_ID]);
                            if (activeItem) {
                                activeItem.ui_isOpen = true;
                                activeItem.ui_isHistoryItem = true;
                                activeItem.ui_removed = true;
                                activeObsParents.push(activeItem);
                            } else {
                                prosLogWrn(`Could not find ${OBJ_TYPE_ITM_OBS} type item when searching parents of deleted item ${item}`);
                            }
                        }
                    }
                }
            }
        }
        Object.keys(itemsByObjType)
            .filter(objType => objType !== OBJ_TYPE_LST)
            .forEach(objType => itemsByObjType[objType].forEach(findMissingParents));

        const allDeletedOrRelatedParentItems = deletedItems
            .concat(activeLstParents)
            .concat(activeObsParents)
            .sort(sortReportOrder)

        // 1. Get deleted report object(s)
        let deletedReportList = deletedReports.concat(activeLstParents)
            .sort(sortReportOrder);

        let listForUi = this.composeTreeHierarchy(deletedReportList, allDeletedOrRelatedParentItems,
            specificListId, filterTxt, takeAllReportItems, true)

        if (DEBUG_TO_SAVE_UI_LIST) {
            dumpObjToJsonFile(listForUi, 'dbg-del-ui-list')
        }
        return listForUi
    }

    composeTreeHierarchy(reportList, sourceAllObjects, specificListId, filterTxt, takeAllReportItems, composeDeletedTree){
        let top = true;     // Report top level
        let lastObs;        // Latest OBS - used to speed up sorting items for prev OBS
        let reportId;        // to clear lastObs when continue to nect report
        let fixSortOrderds = [];
        let items = [];

        function sortBySortOrder(a, b) {
            return a[ATTR_SORT_ORDER_I] - b[ATTR_SORT_ORDER_I]
        }

        reportList.forEach( (report) =>  {
            // 2. Add an empty obs list for report(s)
            report[OBS_LIST] = [];
            // 3. Find obs and title for each report one at a time
            let reportObjs = sourceAllObjects
                .filter((obj)=> {
                    return composeDeletedTree 
                        ? this.isDeletedOrActUiObject(obj, report.obj_id)
                        : this.isUiObject(obj, specificListId, report.obj_id, takeAllReportItems)
                })
                .sort(sortBySortOrder);
            Array.prototype.push.apply(items, reportObjs);
        });

        let numOfReportDirectObjs = 0;
        function addItemToReport(uiItems, item) {
            let itemReportId = getObjListId(item);
            const report = uiItems.find((r) => { return r[ATTR_OBJ_ID] === itemReportId});
            if (!report) {
                return false
            }
            numOfReportDirectObjs++;
            item.ui_text = getItemText(item);
            report[OBS_LIST].push(item);
            if (item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
                item.ui_lastUpdatedBy = item[ATTR_UPDATED_BY]
                item.ui_lastUpdatedMs = item[ATTR_UPDATED_MS_I]
            }
            return true;
        }

        function addItemToObs(obs, item, fixOrder) { //todo tero fixOrder käyttö
            let itemReportId = getObjListId(item);
            let obsReportId = getObjListId(obs);
            if (itemReportId !== obsReportId) {
                // do not add into OBS item that is not in any list .. location pict
                return
            }
            if (isPictureItem(item)) {
                if (!obs.hasOwnProperty(OBS_PICTS)) {
                    obs[OBS_PICTS] = []
                }
                obs[OBS_PICTS].push(item);
            }
            if (isVideoItem(item)) {
                if (!obs.hasOwnProperty(OBS_VIDEOS)) {
                    obs[OBS_VIDEOS] = []
                }
                obs[OBS_VIDEOS].push(item)
            }
            if (!obs.hasOwnProperty(OBS_OBJ_LIST)) {
                obs[OBS_OBJ_LIST] = []
            }
            obs[OBS_OBJ_LIST].push(item);
            item[ATTR_PARENT_OBS] = obs[ATTR_OBJ_ID];
            // Last updated time and email
            if (item[ATTR_UPDATED_MS_I] > obs.ui_lastUpdatedMs) {
                obs.ui_lastUpdatedMs = item[ATTR_UPDATED_MS_I]
                obs.ui_lastUpdatedBy = item[ATTR_UPDATED_BY]
            }
            if (fixOrder) {
                obs[OBS_OBJ_LIST].sort((a,b) => {return a.sort_order - b.sort_order})
            }
        }

        for (let item of items) {
            if (!reportId || item[ATTR_OBJ_ID].indexOf(reportId) !== 0) {
                // Continue to next report
                lastObs = undefined
                top = true
                reportId = getObjListId(item)
            }
            let origType = getOriginal(item)[ATTR_OBJ_TYPE];
            if (origType === OBJ_TYPE_ITM_OBS) {
                if (item.hasOwnProperty(OBS_PICTS)) {
                    item[OBS_PICTS].length = 0;
                } else {
                    item[OBS_PICTS] = [];
                }
                if (item.hasOwnProperty(OBS_VIDEOS)) {
                    item[OBS_VIDEOS].length = 0
                } else {
                    item[OBS_VIDEOS] = []
                }
                if (item.hasOwnProperty(OBS_OBJ_LIST)) {
                    item[OBS_OBJ_LIST].length = 0;
                } else {
                    item[OBS_OBJ_LIST] = [];
                }
                if (!addItemToReport(reportList, item)) {
                    continue;
                }
                lastObs = item;
                top = false;
            } else if (origType === OBJ_TYPE_ITM_TITLE) {
                addItemToReport(reportList, item)
                top = true;
                continue
            } else {
                let itemsParentObs = getValidAttr(item, ATTR_PARENT_OBS, STR_NO_VALUE)
                // Comment, picture etc mat belong to OBS or to report top level
                if (lastObs && itemsParentObs === lastObs[ATTR_OBJ_ID]) {
                    // normally after basic sorting items are following OBS to speed up
                    addItemToObs(lastObs, item);
                }
                else if (itemsParentObs === STR_NO_VALUE) {
                    if (top || !lastObs) {
                        addItemToReport(reportList, item)
                    } else {
                        // Old SW did not save OBS parent but used sort order to associate comment for OBS
                        // item[ATTR_PARENT_OBS] = lastObs[ATTR_OBJ_ID]
                        addItemToObs(lastObs, item)
                    }
                } else {
                    // comment or picture for specific OBS with parent id but not for a latest OBS
                    fixSortOrderds.push(item)
                }
            }
            if (!filterTxt && numOfReportDirectObjs > MAX_NUM_OF_UI_OBJS) {
                uiListSizeLimited = true;
                break
            }
        }

        // 4. add obs items that did not have obs parent
        // prosLog("Item sort order fix count " + fixSortOrderds.length)
        for (let toFixItem of fixSortOrderds) {
            let found = false;
            for (let report of reportList) {
                for (let obs of report[OBS_LIST]) {
                    if (toFixItem[ATTR_PARENT_OBS] === obs[ATTR_OBJ_ID]) {
                        found = true
                        addItemToObs(obs, toFixItem, true)
                        break;
                    }
                }
                if (found) {
                    break;
                }
            }
            if (!found) {
                /*
                silently ignored so far
                if (incrementalContinue) {
                    // Incrementally loading more not found yet - might found after fetching more
                } else {
                    //prosLogWrn('WRN - no parent for', toFixItem)
                    // todo should we show an orphan comment / picture for another OBS like mobile and web report
                }
                 */
            }
        }
        return reportList;
    }

    latestSearchStat = {
        searchId: undefined,    // search report id or undefined if was not a search report
        filterText: "",         // text search when was used
        matchingObsCount: 0     // count - valid only when using text search and/or search report
    }

    /**
     * Get search statistics from previous text and/or search report
     */
    getChangedSearchStat(prevStats) {
        if (!this.latestSearchStat.searchId && !this.latestSearchStat.filterText) {
            // was not a search
            return undefined
        }
        let searchStatChanged = !prevStats ||
            this.latestSearchStat.searchId !== prevStats.searchId ||
            this.latestSearchStat.filterText !== prevStats.filterText ||
            this.latestSearchStat.matchingObsCount !== prevStats.matchingObsCount
        return searchStatChanged ? this.latestSearchStat : undefined
    }

    /**
     * Get a three level hierarchical list of UI items
     *  1) reports
     *  2) <report>.obsList - obs and other report root items and
     *  3) <obs>.obsObjList - obs attachments like comments, pictures, videos
     * @param specificListId    - used for location pictures - todo should refactor not to use this function for that
     * @param filterTxt         - text filter to limit matching obs text, id or comment
     * @param showingSearchList - to get obs based on search report criteria
     * @param takeAllReportItems - to get all reports instead of selected only
     * @param takeEmptyReports   - to return also empty reports
     * @returns {[]}        List of reports - three level hierarchy report/obs/items
     */
    getUiList(specificListId, filterTxt, showingSearchList, takeAllReportItems=true, takeEmptyReports) {
        //console.log("getUiList(), filterTxt:", filterTxt, "showingSearchList:", showingSearchList,
        //    "takeAllReportItems:", takeAllReportItems, "takeEmptyReports:", takeEmptyReports)
        // this.dumpItems("getUiList")
        this.observations.length = 0
        if (filterTxt === "") {
            filterTxt = undefined
        }
        projectLoader.refreshUserIsActive();
        this.uiItems.length = 0;
        uiListSizeLimited = false;

        // *** start of method getUiList() ***
        if (!Array.isArray(this.objs)) {
            prosLogErr('no project objects');
            return this.uiItems;
        }

        // 1. Get report object(s)
        //      - showingSearchList: take first all and do search at the end
        if (specificListId) {
            // Location report - list of sub-project location pictures
            let specificList = this.objs.find( (itm) => itm[ATTR_OBJ_ID] === specificListId);
            if (specificList) {
                this.uiItems.push(specificList);
            } else {
                prosLogErr("specific list ID not found");
                return this.uiItems;
            }
        } else {
            if (showingSearchList && !activeProject.selectedSearchId) {
                this.uiItems = []
                // No search selected - return list of public or own search
                return this.uiItems;
            } else {
                // Continue with selected reports or one search been selected
                this.uiItems = this.getReports(filterTxt !== undefined || showingSearchList)
            }
        }

        this.composeTreeHierarchy(this.uiItems, this.objs, specificListId, filterTxt, takeAllReportItems);

        this.latestSearchStat.searchId = undefined
        this.latestSearchStat.filterText = filterTxt
        this.latestSearchStat.matchingObsCount = 0

        if (specificListId || (filterTxt === undefined && !showingSearchList)) {
            if (DEBUG_TO_SAVE_UI_LIST) {
                dumpObjToJsonFile(this.uiItems, 'dbg-ui-list');
            }
            return this.uiItems;
        }

        // 5. when filtering by text make new list with match text
        // Filter by text - ignore upper/lower case + check search rules
        let matchReports;
        if (filterTxt !== undefined) {
            matchReports = this.getMatchingToFilter(filterTxt, takeEmptyReports)
        } else {
            matchReports = this.uiItems;
        }

        // 6. when search list check matching to search rules
        if (showingSearchList && activeProject.selectedSearchId) {
            this.latestSearchStat.searchId = activeProject.selectedSearchId
            this.uiItems = this.getMatchingToSearchRule(matchReports, activeProject.getSelectedSearch());
        } else {
            this.uiItems = matchReports;
        }
        if (DEBUG_TO_SAVE_UI_LIST) {
            dumpObjToJsonFile(this.uiItems, 'dbg-ui-list');
        }
        return this.uiItems;
    }

    getMatchingToSearchRule(uiList, search) {
        let filterByExpiration = false;
        let cbTags = {};
        let rgTags = {};
        let afterTimeCreated;
        let beforeTimeCreated;
        let afterTimeUpdated;
        let beforeTimeUpdated;
        let relativeTimeLimits = [];

        function getTimeLimit(search, tag, defaultValue) {
            let valStr = getObjAttr(search, tag);
            if (!valStr || valStr === STR_NO_VALUE) { return defaultValue}
            return parseInt(valStr);
        }

        function prepareSearch() {
            let YES_YES = ";" + STR_YES + ";" + STR_YES;
            let YES_NO  = ";" + STR_YES + ";" + STR_NO;

            filterByExpiration = getObjAttr(search, ATTR_EXPIRATION_FILTER) === STR_YES;
            afterTimeCreated = getTimeLimit(search, ATTR_FILTER_CREATED_AFTER, 0);
            beforeTimeCreated = getTimeLimit(search, ATTR_FILTER_CREATED_BEFORE, Number.MAX_SAFE_INTEGER);
            afterTimeUpdated = getTimeLimit(search, ATTR_FILTER_UPDATED_AFTER, 0);
            beforeTimeUpdated = getTimeLimit(search, ATTR_FILTER_UPDATED_BEFORE, Number.MAX_SAFE_INTEGER);

            function setRelativeTimeLimits() {
                if (search[ATTR_OBJ_TYPE] !== OBJ_TYPE_LST_SEARCH_R) {
                    return
                }
                Object.keys(search).forEach(key => {
                    if (key.indexOf(RELATIVE_PREFIX) === 0) {
                        let limitStr = search[key]
                        if (limitStr !== STR_NO_VALUE) {
                            let attrName
                            let isBefore
                            if (key.indexOf(RELATIVE_PREFIX_BEFORE) === 0) {
                                attrName = key.replace(RELATIVE_PREFIX_BEFORE, '')
                                isBefore = true
                            } else {
                                attrName = key.replace(RELATIVE_PREFIX_AFTER, '')
                                isBefore = false
                            }
                            const offset = parseInt(search[key])
                            relativeTimeLimits.push({
                                attr: attrName === ATTR_UPDATED_MS_I ? 'ui_lastUpdatedMs' : attrName,
                                isBefore: isBefore,
                                offset: offset,
                                limit: currentTimeMs() + offset
                            })
                        }
                    }
                })
            }

            // take into search selected ch-tag - when selected check either Y or n
            function addCbTag(stag) {
                let tag = stag.substring(1);
                let tagValStr = getObjAttr(search, stag);
                if (tagValStr.indexOf(YES_YES) >= 0) {
                    cbTags[tag] = STR_YES;
                } else if (tagValStr.indexOf(YES_NO) >= 0) {
                    cbTags[tag] = STR_NO;
                }
            }
            for (let stag of activeProject.getChTagsS()) {
                if (search.hasOwnProperty(stag)) {
                    addCbTag(stag)
                }
            }

            // "stag2": "x;;x;n;;x;n;;x;n"
            //  title;inUse;;
            //      sub-title;in-use
            // take into search selected rb-tag - non-selected TAG can be Y or n
            function addRgTag(stag) {
                let tag = stag.substring(1);
                let stagStr = getObjAttr(search, stag);
                let stags = stagStr.split(";;");
                let first = true;
                let i = 0;
                let rbTags = [];
                for (let rbTag of stags) {
                    if (first) {
                        // first is rb-group title
                        first = false;
                        continue
                    }
                    if (rbTag.indexOf(STR_YES) >= 0) {
                        rbTags.push(String(i));
                    }
                    i += 1
                }
                if (rbTags.length) {
                    rgTags[tag] = rbTags;
                }
            }
            // prepareSearch
            for (let stag of activeProject.getRbTagsS()) {
                if (search.hasOwnProperty(stag)) {
                    addRgTag(stag)
                }
            }
            setRelativeTimeLimits()
        }

        function matchToSearch(item) {
            if (filterByExpiration) {
                if (!isLate(item))
                    return false
            }
            // Filter by created timestamp
            if (item[ATTR_CREATED_MS_I] < afterTimeCreated) {
                return false
            }
            if (item[ATTR_CREATED_MS_I] > beforeTimeCreated) {
                return false
            }
            // Filter by created timestamp
            if (item[ATTR_UPDATED_MS_I] < afterTimeUpdated) {
                return false
            }
            if (item[ATTR_UPDATED_MS_I] > beforeTimeUpdated) {
                return false
            }

            // Filter by relative time limits
            for (let relativeTimeLimit of relativeTimeLimits) {
                let obsTime
                if (relativeTimeLimit.attr === ATTR_EXPIRATION) {
                    obsTime = getExpiration(item)
                } else if (item.hasOwnProperty(relativeTimeLimit.attr)) {
                    obsTime = parseInt(item[relativeTimeLimit.attr])
                } else {
                    // Item does not have such time attribute
                    return false
                }
                if ((relativeTimeLimit.isBefore && obsTime > relativeTimeLimit.limit) ||
                    (!relativeTimeLimit.isBefore && obsTime < relativeTimeLimit.limit)) {
                    return false
                }
            }

            // each from CB list
            for (let cbTag in cbTags) {
                let itemTagVal = getObjAttr(item, cbTag);
                if (cbTags[cbTag] === STR_YES && itemTagVal !== STR_YES) {
                    return false;
                }
                if (cbTags[cbTag] === STR_NO && itemTagVal === STR_YES) {
                    return false;
                }
            }
            // also RB search
            for (let tag in rgTags) {
                let rgTag = rgTags[tag];
                let rbMatch = false;
                let tagVal = getObjAttr(item, tag);
                for (let value of rgTag) {
                    if (value === tagVal) {
                        rbMatch = true
                    }
                }
                if (!rbMatch) {
                    return false
                }
            }
            return true
        }

        function makeTitleObj(obj) {
            let titleObj = makeObjCopyForAws(obj);
            if (isReportType(obj)) {
                titleObj[ATTR_TEXT] = getReportInfo(obj);
                titleObj[UI_IS_REPORT] = true;
            }
            titleObj[ATTR_OBJ_TYPE] = OBJ_TYPE_ITM_TITLE;
            titleObj[UI_ATTR_NO_EDIT] = true;
            return titleObj
        }

        // Take selected search as a "report parent"
        let searchObj = deepCopyObj(this.getSelectedSearch())
        if (!searchObj) {
            prosLogErr("Integrity error - no search object", this.selectedSearchId)
            return []
        }
        let matchList = [searchObj]
        if(searchObj.hasOwnProperty(OBS_LIST)) {
            searchObj[OBS_LIST].length = 0
        } else {
            searchObj[OBS_LIST] = []
        }

        let SKIP_ITEM_TYPES = [OBJ_TYPE_ITM_REF, OBJ_TYPE_ITM_TITLE];
        prepareSearch();
        let reportAsTitle = undefined;
        let latestTitle = undefined;
        let matchingObsCount = 0;
        uiList.forEach(report => {
            if (report.hasOwnProperty(OBS_LIST)) {
                reportAsTitle = report;
                report[OBS_LIST].forEach(obs => {
                    if (obs[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE) {
                        latestTitle = obs;
                    }
                    if (SKIP_ITEM_TYPES.indexOf(obs[ATTR_OBJ_TYPE]) < 0) {
                        if (matchToSearch(obs)) {
                            if (reportAsTitle) {
                                // add report name as title
                                searchObj[OBS_LIST].push(makeTitleObj(reportAsTitle));
                                reportAsTitle = undefined;
                            }
                            if (latestTitle) {
                                // add latest title in a report
                                searchObj[OBS_LIST].push(makeTitleObj(latestTitle));
                                latestTitle = undefined;
                            }
                            searchObj[OBS_LIST].push(obs);
                            matchingObsCount += 1;
                        }
                    }
                })
            }
        });
        this.latestSearchStat.matchingObsCount = matchingObsCount
        return matchList;
    }

    getMatchingToFilter(filterTxt, takeEmptyReports) {
        function matchUiFilter(obj, filterTxt) {
            if (filterTxt === undefined) {
                return true
            }
            if (!obj.hasOwnProperty(ATTR_TEXT)) { return false }
            if (obj[ATTR_TEXT] === STR_NO_VALUE) {return false}
            return prosMultiFilterText(filterTxt, getItemText(obj))
        }

        let matchingObsCount = 0
        let matchReports = []
        this.uiItems.forEach(report => {
            let matchObs = []
            if (report.hasOwnProperty(OBS_LIST)) {
                report[OBS_LIST].forEach( obs => {
                    let match = matchUiFilter(obs, filterTxt)
                    if (obs[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS) {
                        obs[OBS_OBJ_LIST].forEach(itm => {
                            if (matchUiFilter(itm, filterTxt)) {
                                match = true
                            }
                        })
                    }
                    if (match) {
                        matchObs.push(obs)
                    }
                })
            } else {
                if (matchUiFilter(report, filterTxt)) {
                    // Orphan item - not actually a report
                    matchReports.push(report)
                }
            }
            let reportToAdd = report
            if (matchObs.length > 0) {
                reportToAdd[OBS_LIST] = matchObs
                matchReports.push(reportToAdd)
                matchingObsCount += matchObs.length
            } else if (takeEmptyReports) {
                reportToAdd[OBS_LIST] = []
                matchReports.push(reportToAdd)
            }
        })
        if (DEBUG_TO_SAVE_UI_LIST) {
            dumpObjToJsonFile(matchReports, 'dbg-ui-list-filtered');
        }
        this.latestSearchStat.matchingObsCount = matchingObsCount
        return matchReports
    }

    getProjectUsers() {
        if (!this.objs) { return []; }
        return this.objs
            .filter((obj)=> {
                return  (obj.hasOwnProperty(ATTR_EMAIL) &&
                    obj[ATTR_OBJ_TYPE] === OBJ_TYPE_USER_ROLE &&
                    obj[ATTR_EMAIL] !== STR_NO_VALUE) })
            .sort((a,b) => (a.email > b.email) ? 1 : ((b.email > a.email) ? -1 : 0));
    }

    updateItemFromAws(obj) {
        function replaceObjAttrs(objInList, fromServer) {
            for (let attr in fromServer) {
                objInList[attr] = fromServer[attr]
            }
        }

        function logObjAttrChanges(before, after) {
            let changes = [];
            for (let attr in before) {
                if (!after.hasOwnProperty(attr)) {
                    changes.push("removed " + attr);
                } else if (before[attr] !== after[attr]) {
                    changes.push(attr + ": " + dbgDecode(before, attr)  + " -> " +  dbgDecode(after, attr));
                }
            }
            if (changes.length) {
                prosLogX("AWS CHANGE " + obj[ATTR_OBJ_TYPE] + " : " + obj[ATTR_OBJ_ID]);
                prosLogX(changes);
                if (obj.hasOwnProperty(ATTR_EXPIRATION)) {
                    prosLogX(ATTR_EXPIRATION + ": " + dbgDecode(obj, ATTR_EXPIRATION));
                }
            }
        }
        if (!obj.hasOwnProperty(ATTR_OBJ_ID)) {
            prosLogErr('update no attr', ATTR_OBJ_ID, obj);
            return;
        }
        let found = false;
        const items = this.objs;
        for (let itemInd in items) {
            if (items[itemInd][ATTR_OBJ_ID] === obj[ATTR_OBJ_ID]) {
                found = true;
                if (isActive(obj)) {
                    if (DEBUG_AWS_CHANGES) {
                        logObjAttrChanges(items[itemInd], obj);
                    }
                    replaceObjAttrs(items[itemInd], obj)
                    prosLog("*** found obj updated", items[itemInd][ATTR_OBJ_ID]);
                } else {
                    let cnt1= items.length;
                    items.splice(itemInd, 1);
                    this.updateObjectStats(obj, -1)
                    prosLog("*** found obj marked as deleted", cnt1, '->', items.length);
                }
                break;
            }
        }
        if (!found) {
            if (isActive(obj)) {
                items.push(obj);
                this.updateObjectStats(obj, 1)
                // prosLog("*** not found itm -> add ", obj[ATTR_OBJ_ID]);
            } else {
                prosLog("*** not found itm ignore as been deleted", obj[ATTR_OBJ_ID]);
            }
        }
        this.objs.sort((a, b) => a.sort_order - b.sort_order);
    }

    refreshObjectsByAge(updatedObjsFromAws) {
        for (let i in updatedObjsFromAws) {
            let obj = updatedObjsFromAws[i];
            if (obj[ATTR_OBJ_TYPE].substring(0, 3) === OBJ_TYPE_ITM) {
                this.updateItemFromAws(obj);
            } else if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_PRJ) {
                this.updateProjectFromAws(obj);
            } else if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST) {
                this.updateListFromAws(obj, ATTR_PROJ_REPORTS);
            } else if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST_SEARCH) {
                this.updateListFromAws(obj, ATTR_PROJ_SEARCHS);
            } else if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST_SEARCH_R) {
                this.updateListFromAws(obj, ATTR_PROJ_SEARCHS);
            }
        }
    }

    async refreshObjectsFromAws(refreshProjects) {
        // prosLogX("Refresh from AWS newer than age:", getAgeAndUpdatedMs(),
        //              ", project:", this.getPid(), "refreshProjects:", refreshProjects);
        try {
            await reserveAwsApi(true, 'GET - refresh objs')
            let result = await API.get("prodect",
                '/websynch?email=' + getUserEmail()
                + '&id=' + getDevId()
                + '&project=' + this.getPid()
                + '&age=' + this.getAgeAndUpdatedMs()
                + '&oper=' + (refreshProjects ? 'manual_refresh' : 'refresh')
            );
            await reserveAwsApi(false, 'GET - refresh objs')
            return result
        } catch (e) {
            prosLogErr(e);
        }
        await reserveAwsApi(false, 'GET - refresh objs-failed')
    }

    /**
     * Handle server response about changes by age
     * @param respObj   Response from AWS
     * @returns         Number of items updated
     */
    handleRefresh(respObj) {
        if (respObj === undefined) {
            prosLogErr("handleRefresh() undefined")
            sessionExceptionDetected('Refresh-1', 'Tietojen päivitys epäonnistui')
            return 0;
        }
        let changeCount = 0
        if (Array.isArray(respObj)) {
            if (respObj.length < 1) {
                prosLog("refresh from AWS - no updates");
            } else {
                changeCount = respObj.length
                this.refreshObjectsByAge(respObj);
                this.refreshUiCallback("handleRefresh");
            }
        } else {
            prosLogErr ('respObj:', respObj);
            sessionExceptionDetected('Refresh-2', 'Tietojen päivitys epäonnistui')
        }
        return changeCount
    }

    async changeItemInAws(list) {
        if ( DEBUG_LOG_SENDING_TO_AWS) {
            prosLogX("POST TO AWS - change objs");
            prosLogX(list);
        }
        return await procedtAwsApiPost(list, 'update objs')
    }

    handleItemUpdateResponse(respObj) {
        if (!respObj) {
            prosLogErr('POST failed - no response');
            throw new Error('Virhe - ei vastausta serveriltä');
        } else if (!respObj.hasOwnProperty('result')) {
            prosLogErr('POST failed - no result', respObj);
            throw new Error('Virhe - server vastaus puuttuu');
        } else if (respObj.result !== 'OK') {
            prosLogErr('Error from server', respObj);
            if (respObj.hasOwnProperty('errorCause')) {
                throw new Error('Virhe serveriltä:' + respObj.errorCause);
            } else {
                throw new Error('Virhe serveriltä:' + JSON.stringify(respObj));
            }
        }
    }

    mayShareWebReport(feature) {
        if (!feature) {
            // No feature to limit
            return true
        }
        if (this.getAttr(ATTR_EXPORT_WEB_REPORT) === STR_NO ||
            (this.getAttr(ATTR_EXPORT_WEB_REPORT_ACT) === STR_NO && feature === FEAT_WEB_ACTIVE)) {
            // Not allowed by project settings
            return false
        }
        return featureEnabled(feature)
    }


    async awaitMakeWebReport(reportId, reportType, emailReceivers, emailMsg, pdf, searchParams, reportViewMode, pdfOptions) {
        if (reportType < REPORT_TYPE_NUMBERING || reportType > REPORT_TYPE_SEARCH) {
            prosLogErr("reportType", reportType, 'valid range between', REPORT_TYPE_NUMBERING, REPORT_TYPE_SEARCH);
            return;
        }
        let request = {
            "projectId": this.getPid(),
            "reportId": reportId,
        };
        if (reportType !== this.REPORT_TYPE_PREVIEW) {
            let req_params = makeAwsReqParams(true)
            if (reportType >= REPORT_TYPE_HISTORY && Array.isArray(emailReceivers)) {
                req_params["send_report_email"] = STR_YES;
                let ind = 1;
                for (let i in emailReceivers) {
                    let email = emailReceivers[i];
                    req_params["email-" + ind] = email;
                    ind += 1;
                }
            } else {
                req_params["send_report_email"] = STR_NO;
            }
            if (searchParams) {
                req_params["searchParams"] = searchParams
            }
            if (reportType === REPORT_TYPE_SEARCH) {
                req_params["report_mode"] = "search";
            } else {
                req_params["report_mode"] = "report";
            }
            if ([REPORT_TYPE_HISTORY, REPORT_TYPE_ACTIVE, REPORT_TYPE_SEARCH].includes(reportType) && emailReceivers) {
                req_params[ATTR_SAVE_REPORT] = STR_YES;
            } else {
                req_params[ATTR_SAVE_REPORT] = STR_NO;
            }
            if (reportType === REPORT_TYPE_NUMBERING) {
                req_params[ATTR_GENERATE_OBS_ID] = STR_YES;
                req_params[ATTR_GENERATE_HTML] = STR_NO;
            } else if (pdf) {
                req_params[ATTR_GENERATE_OBS_ID] = STR_NO;
                req_params[ATTR_GENERATE_PDF] = STR_YES;
                // make a project view specific web link to see current data
                if (featureLimit(FEAT_MAX_USERS, 10000) > 10) {
                    // Prevent web link for a PDF report shared from MyProdect service level #9.68
                    req_params[ATTR_PROJECT_LINK] = await awaitMakeProjectLink();
                }
                if (pdfOptions) {
                    /* pdfOptions structure, e.g.:
                     {
                        reportUserTitle: null,
                        reportUserFooter: null,
                        coverPageEnabled: false,
                        coverPage: {
                            content: [
                                {text: "", style: "bottomLineHeader"},
                                {text: "", style: "bottomLineHeader2"},
                            ]
                        }
                     } */
                    req_params["report_user_title"] = pdfOptions.reportUserTitle;
                    req_params["report_user_footer"] = pdfOptions.reportUserFooter;
                    if(pdfOptions.coverPageEnabled){
                        req_params["coverPage"] = pdfOptions.coverPage;
                    }
                    req_params['show_item_user_info'] = pdfOptions.showItemUserInfo ? STR_YES : STR_NO
                }
            } else {
                req_params[ATTR_GENERATE_OBS_ID] = STR_NO;
                req_params[ATTR_GENERATE_HTML] = STR_YES;
            }
            if (reportType === REPORT_TYPE_ACTIVE) {
                req_params["repair_ui_enabled"] = STR_YES;
            }
            if (emailMsg) {
                req_params["email_msg"] = emailMsg;
            }
            if (reportViewMode){
                req_params["report_view_mode"] = reportViewMode;
            }
            request["reqObj"] = req_params;
        }
        try {
            await reserveAwsApi(true, 'POST - web report')
            let result = await API.post("prodect",'/webreport',{body: request});
            await reserveAwsApi(false, 'POST - web report')
            return result
        } catch (e) {
            checkAwsApiException(e)
        }
        await reserveAwsApi(false, 'POST - web report-failed')
        return undefined;
    }

}

/**
 * Clear report activity and not opening status
 * @param report - report which to be "deactivated"
 */
export function clearUiStatesForReport(report) {
    if (report.ui_isOpen) { report.ui_isOpen = false }
    if (report.ui_isActive) { report.ui_isActive = false }
    if (report.hasOwnProperty(OBS_LIST)) {
        report[OBS_LIST].forEach( (obs) => {
            if (obs.ui_isOpen) { obs.ui_isOpen = false }
            if (obs.ui_isActive) {obs.ui_isActive  = false }
        })
    }
}

export function selectedReportsAmount() {
    return activeProject ? activeProject.selectedReports.length: 0
}

export function isReportToSelect(obj, who, keepOpen = false) {
    if (!activeProject) {
        return false
    }
    prosLog("isReportToSelect()", obj.text, 'by:', who);
    if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST) {
        activeProject.selectedSearchId = undefined
        if (activeProject.selectedReports.find(reportId => reportId === obj[ATTR_OBJ_ID])) {
            activeProject.selectedReports = activeProject.selectedReports
                .filter(reportId => reportId !== obj[ATTR_OBJ_ID])
            if (!keepOpen) {
                clearUiStatesForReport(obj)
            }
        } else {
            activeProject.selectedReports.push(obj[ATTR_OBJ_ID])
        }
        saveSelectedReports()
        prosLog('Num of selected reports', activeProject.selectedReports.length)
        return true
    } else if (obj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST_SEARCH || obj[ATTR_OBJ_TYPE] === OBJ_TYPE_LST_SEARCH_R) {
        activeProject.selectedSearchId = obj[ATTR_OBJ_ID]
        return true
    }
    return false
}

export function getReportInfo(report) {
    if (gloShowingIdentifiers) {
        let reportId = report.hasOwnProperty(ATTR_REPORT_INDEX) ? report[ATTR_REPORT_INDEX]: '';
        return reportId + " " + fixNewLineForUi(getValidAttr(report,ATTR_TEXT));
    }
    return fixNewLineForUi(getValidAttr(report,ATTR_TEXT));
}

// returns object attribute or given default value when missing or empty
export function getValidAttr(obj, attr, defaultValue) {
    if (!obj.hasOwnProperty(attr)
        || obj[attr] === ''
        || obj[attr] === STR_NO_VALUE
        || obj[attr] === undefined) {
        return defaultValue;
    }
    return obj[attr];
}

export function getProjectInfo(projectAttrs, withMainProjectPrefix) {
    if (!projectAttrs) {
        if (!activeProject) {
            return "Projektia ei ole valittu";
        }
        projectAttrs = getActiveProject().attrs
    }
    let projectName = fixNewLineForUi(getValidAttr(projectAttrs, ATTR_TEXT));
    let mainProjectName = fixNewLineForUi(getValidAttr(projectAttrs, ATTR_MAIN_PROJECT_NAME));
    if (withMainProjectPrefix && mainProjectName) {
        return fixNewLineForUi(mainProjectName + ": " + projectName);
    }
    return fixNewLineForUi(projectName)
}

export function getOriginal(item) {
    if (item[ATTR_OBJ_TYPE] !== OBJ_TYPE_ITM_REF) {
        return item;
    }
    let originalId = item[ATTR_REF_ID];
    let originalObj = activeProject.objs.find(function(x){ return x.obj_id === originalId});
    if (!originalObj || !originalObj.hasOwnProperty(ATTR_OBJ_TYPE)) {
        prosLogErr("Original obj not found pid:", getActiveProjectID(),
            "oid:", item[ATTR_OBJ_ID], "ref/originalObj:", originalId);
        return item
    }
    return originalObj;
}

/**
 * Get object attribute and when not existing return given default
 * @param obj           Project object
 * @param attr          Attribute name (key)
 * @param defaultVal    To be returned when not found
 * @returns {string|*}  > 90% of the attributes are string type - a few int - special objects may have object or list
 */
export function getObjAttr(obj, attr, defaultVal = STR_NO_VALUE) {
    if (obj.hasOwnProperty(attr)) {
        return obj[attr]
    }
    return defaultVal;
}

/**
 * Return Objects integer attribute - use for known attrs ( created, updated sort order etc )
 * that are known to be valid or not existing.   Use getValidInteger() when have a doubt to use default value
 * and to limit with expected range limits.
 * @param obj           Object
 * @param attr          Attribute name
 * @returns {number}    -1 when attr does not exist
 */
export function getObjIntAttr(obj, attr) {
    let originalItem = getOriginal(obj);
    if (originalItem.hasOwnProperty(attr) && originalItem[attr] !== STR_NO_VALUE) {
        return parseInt(originalItem[attr])
    }
    return -1;
}

export function getUserTemplateProjects(exclude_ids = []) {
    if ( ! userProjectList) {
        return []
    }
    return userProjectList.filter(project => project[ATTR_IS_TEMPLATE] === STR_YES && ! exclude_ids.includes(project[ATTR_AWS_PROJECT_ID]))
}

/**
 * Get active project object ( report, title, obs, comment, picture,... ) by its id
 * @param id    Object id - also used by server as "sorting key" obj_id
 * @returns {*} Object with all of its attributes - note server DB "project_id" is not included or undefined
 */
export function getObjById(id){
    if (!activeProject || !id) {
        return undefined
    }
    return activeProject.objs.find(function(x){ return x.obj_id === id});
}

/**
 * Get items report object by item id
 * @param objId
 * @returns {*} Report object with all of its attributes - or undefined if not found
 */
export function getItemsReport(objId) {
    let reportId = getObjListIdFromItemId(objId)
    return getObjById(reportId)
}

/**
 * Get items report name including report number
 * @returns {*} Report name or "?" when not found
 * @param objId
 */
export function getItemsReportName(objId) {
    let report = getItemsReport(objId)
    return report ? getReportInfo(report) : "?"
}

/**
 * Render type is used for renderReport to map object
 * @param item
 * @returns {string}
 */
export function renderType(item, str = null) {
    const type = str || getOriginal(item)[ATTR_OBJ_TYPE]
    if (type === OBJ_TYPE_LST) return 'report';
    if (type ===  OBJ_TYPE_LST_PROJ_PICT) return 'loc_pictures';
    if (type ===  OBJ_TYPE_LST_SEARCH) return 'srch_lst';
    if (type ===  OBJ_TYPE_LST_SEARCH_R) return 'srch_lst';
    if (type === OBJ_TYPE_ITM_TITLE) return 'title';
    if (type === OBJ_TYPE_ITM_OBS) return 'obs';
    if (ITEM_TYPES_PICT.indexOf(type) >= 0) return 'pict';
    if (type === OBJ_TYPE_TXT_SOUND) return 'audio_txt';
    if (type === OBJ_TYPE_SOUND) return 'audio';
    if (type === OBJ_TYPE_ITM_VIDEO) return 'video';
    return 'text';
}

export const groupItemsByState = (items, stateKey) => items.reduce(
    (result, item) => {
        let obs = getOriginal(item);
        return {
            ...result,
            [obs[stateKey]]: [
                ...(result[obs[stateKey]] || []),
                item,
            ],
            };
    },
    {},
  );

export function isItem(item) {
    if (!item) {
        return false
    }
    let originalItem = getOriginal(item)
    return originalItem[ATTR_OBJ_TYPE].indexOf(OBJ_TYPE_ITM) === 0
}

export function isObservation(item) {
    if (!item) {
        return false
    }
    let originalItem = getOriginal(item)
    return originalItem[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS
}

export function isTitle(item) {
    if (!item) {
        return false
    }
    let originalItem = getOriginal(item)
    return originalItem[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_TITLE
}

export function isReportType(item) {
    let type = item[ATTR_OBJ_TYPE]
    return type === OBJ_TYPE_LST ||
            type ===  OBJ_TYPE_LST_PROJ_PICT
}

export function getItemThumpPath(item) {
    /// Get url for the thumb nail picture in AWS S3 which is either a
    //  - thumb nail picture for a picture
    /// - or a still picture for a video when available - when not returns undefined
    let originalItem = getOriginal(item)
    if (item[ATTR_OBJ_TYPE] !== OBJ_TYPE_ITM_VIDEO) {
        // Not a video -> use picture file name
        return PROS_THUMPS_PATH + originalItem[ATTR_FILE_NAME]
    }
    if (originalItem.hasOwnProperty(ATTR_VIDEO_STATE)) {
        if (originalItem[ATTR_VIDEO_STATE] === VIDEO_STATE_READY) {
            return PROS_THUMPS_PATH + originalItem[ATTR_STILL_PICTURE]
        }
    }
}

export function getLogoThumpPath(logoFileName) {
    return PROS_THUMPS_PATH + logoFileName
}

export function getItemImagePath(item) {
    let originalItem = getOriginal(item);
    return PROS_IMAGES_PATH + originalItem[ATTR_FILE_NAME];
}

export function getItemVideoPath(item) {
    let originalItem = getOriginal(item);
    let hasHlsVideo = originalItem[ATTR_VIDEO_STATE] === VIDEO_STATE_READY
    return hasHlsVideo ?
        PROS_VIDEO_HLS_PATH + originalItem[ATTR_HLS_VIDEO]:
        PROS_VIDEO_PATH + originalItem[ATTR_FILE_NAME]
}

export function getItemPdfPath(item) {
    let originalItem = getOriginal(item);
    if (originalItem.hasOwnProperty(ATTR_PDF_NAME)) {
        return PROS_PDF_TO_IMAGE_PATH + originalItem[ATTR_PDF_NAME];
    }
    return undefined;
}

export function getItemSavedPdfPath(item) {
    let originalItem = getOriginal(item);
    if (originalItem.hasOwnProperty(ATTR_REPORT_S3_KEY)) {
        return PROS_S3_URL + originalItem[ATTR_REPORT_S3_KEY];
    }
    return undefined;
}

export function getItemHtmlPath(item) {
    let originalItem = getOriginal(item);
    if (originalItem.hasOwnProperty(ATTR_FILE_NAME)) {
        return PROS_HTML_PATH + originalItem[ATTR_FILE_NAME];
    }
    return undefined;
}

export function getItemAudioPath(item) {
    let originalItem = getOriginal(item);
    return PROS_AUDIO_PATH + originalItem[ATTR_FILE_NAME];
}

export function getExpiration(item) {
    let originalItem = getOriginal(item);
    if (originalItem.hasOwnProperty(ATTR_EXPIRATION) && originalItem[ATTR_EXPIRATION] !== STR_NO_VALUE) {
        let expTime = parseInt(originalItem[ATTR_EXPIRATION]);
        if (expTime < MIN_EXPIRE_TIME_MS) {
            return 0
        }
        return expTime;
    }
    return 0;
}

export function getCreation(item) {
    let originalItem = getOriginal(item);
    if (originalItem.hasOwnProperty(ATTR_CREATED_MS_I) && originalItem[ATTR_CREATED_MS_I] !== STR_NO_VALUE) {
        let expTime = parseInt(originalItem[ATTR_CREATED_MS_I]);
        if (expTime < MIN_EXPIRE_TIME_MS) {
            return 0
        }
        return expTime;
    }
    return 0;
}

export function isInStateOngoing(obs) {
    //This only for viewer, can be removed when viewer fetches project data
    if(!getActiveProject()){
        return null
    }
    let originalItem = getOriginal(obs);
    let tag = activeProject.getStateRbTag();
    return activeProject.isProjectStateOngoing(originalItem[tag]);
}

// Returns expiration time in ms for "remaining time":
//        > 0 - expiration time value
//  undefined - expiration time not been set or
//         -1 - based on OBS state no longer relevant
export function getExpirationQualified(obs) {
    if (!isInStateOngoing(obs)) {
        return -1
    }
    let expirationMs = getExpiration(obs)
    if (expirationMs <= 0) {
        return undefined
    }
    return expirationMs
}

export function isLate(obs) {
    if (!isInStateOngoing(obs)) {
        return false;
    }
    let expirationMs = getExpiration(obs);
    return expirationMs > 0 && expirationMs < currentTimeMs();
}

export function getObsStateHistory(obs) {
    let originalObs = getOriginal(obs);
    let history = [];
    if (originalObs.hasOwnProperty(ATTR_OBS_HISTORY)) {
        originalObs[ATTR_OBS_HISTORY].split(";;").forEach(
            hist => {
                let fields = hist.split(";");
                if (fields.length > 2) {
                    history.push({
                        state: fields[0],
                        timeMs: fields[1],
                        email: fields[2]
                        })
                }
            }
        );
    }
    return history;
}

export function getItemText(item, ignoreId, maxLength) {
    let originalItem;
    // let suffix = undefined;
    if (item[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_REF) {
        originalItem = getOriginal(item);
    } else {
        originalItem = item;
    }
    let txt;
    if (getObjAttr(originalItem, ATTR_TEXT) !== STR_NO_VALUE) {
        txt = fixNewLineForUi(originalItem[ATTR_TEXT]);
        if (maxLength && txt.length > maxLength) {
            txt = txt.substr(0, maxLength) + '..'
        }
    } else {
        txt = '';
    }
    if (originalItem[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS
        && originalItem[ATTR_OBS_ID] && !ignoreId && gloShowingIdentifiers) {
        return originalItem[ATTR_OBS_ID] + ". " + txt;
    }
    return txt;
}

// export function range(start, stop, step) {
//     let rangeList = [start];
//     let val = start;
//     while (val < stop) {
//         rangeList.push(val += step || 1);
//     }
//     return rangeList;
// }

/**
 * Parse string to integer with min max range and default
 * @param str String to be converted
 * @param defVal Default -1
 * @param minVal Defaults to min safe integer
 * @param maxVal Defaults to max safe integer
 * @returns {number|*}
 */
export function getValidInteger(str,
                                defVal = -1,
                                minVal = Number.MIN_SAFE_INTEGER,
                                maxVal = Number.MAX_SAFE_INTEGER) {
    let val = parseInt(str)
    if (minVal <= val && maxVal >= val) {
        return val
    }
    return defVal
}

export function isProsStrTrue(str){
    return str === STR_YES;
}

export function isPictureItem(item) {
    let originalItem = getOriginal(item);
    return ITEM_TYPES_PICT.indexOf(originalItem[ATTR_OBJ_TYPE]) >= 0
}

export function isVideoItem(item) {
    let originalItem = getOriginal(item)
    return ITEM_TYPES_VIDEO.indexOf(originalItem[ATTR_OBJ_TYPE]) >= 0
}

/**
 * Get picture zoom info
 * @param item  Picture item that has ATTR_PICT_ZOOM, returns undefined when decoding failed or
 * @returns {{viewW: *, viewH: *, imgH: *, cx: *, imgW: *, cy: *, swVers: *, scale: *, devOS: *}}
 */
export function getPictureZoomInfo(item) {
    if (typeof item === "object") {
        return decodePictZoomInfo(item[ATTR_PICT_ZOOM])
    }
}

export function getPictureMarkerLocationInfo(item) {
    if (        item.hasOwnProperty(ATTR_HAS_PICTURE_LOC)
            &&  item.hasOwnProperty(ATTR_PICTURE_LOC_W)
            &&  item.hasOwnProperty(ATTR_PICTURE_LOC_H)
            &&  item[ATTR_PICTURE_LOC_W]    !== STR_NO_VALUE
            &&  item[ATTR_PICTURE_LOC_H]    !== STR_NO_VALUE )
    {
      return {
          inUse: item[ATTR_HAS_PICTURE_LOC] === STR_YES,
          x: parseFloat(item[ATTR_PICTURE_LOC_W]),
          y: parseFloat(item[ATTR_PICTURE_LOC_H]),
      };
    }
    return { inUse: false, x: 0.5, y: 0.5 };
}

export function setPictureMarkerLocation(item, markerLocationInfo){
  item[ATTR_PICTURE_LOC_W] = markerLocationInfo.x.toString();
  item[ATTR_PICTURE_LOC_H] = markerLocationInfo.y.toString();
  item[ATTR_HAS_PICTURE_LOC] = markerLocationInfo.inUse ? STR_YES : STR_NO;
}

export function toggleImageSize(item) {
    if (isPictureItem(item)) {
        item[ATTR_UI_PICTURE_LARGE] = !item[ATTR_UI_PICTURE_LARGE];
        return true;
    }
    return false;
}

// export function getObsState(obs) {
//     if (getActiveProject().getRbTags().length < 1) {
//         prosLogWrn("Project has no RB tags and thus no OBS state");
//         return undefined;
//     }
//     let tag_id = getActiveProject().getRbTags()[0];
//     if (obs.hasOwnProperty(tag_id)) {
//         return obs[tag_id]
//     }
//     return activeProject ? activeProject.this.getDefaultState() : OBS_DEFAULT_STATE
// }

export const ROLE_ADMIN   = "role_admin";
export const ROLE_INSPECT = "role_inspect";
export const ROLE_REPAIR  = "role_repair";
export const ROLE_READER  = "role_reader";
export const ROLE_NONE    = "role_none";
export const ROLE_UNKNOWN = "role_unknown";

const haveSomeAccessRoles   = [ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR, ROLE_READER];
const projectOperationRoles = [ROLE_ADMIN, ROLE_INSPECT];
const contentCreateRoles    = [ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR];
const markerEditRoles       = [ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR];

export function hasCapacityAndPermissionToAddContent(hardLimit) {
    refreshSession()
    if (!getActiveProject()) return null
    return getActiveProject().hasCapacityToAddItems(hardLimit) &&
    hasPermissionTo("addContent")
}

export function getUserRole() {
    if (!activeProject) {
        return ROLE_UNKNOWN;
    }
    let role = activeProject.getAttr(ATTR_USER_ROLE);
    if (role === STR_NO_VALUE) {
        prosLogErr("No role defined for active project");
        return ROLE_UNKNOWN;
    }
    return role;
}

export function getRoleForUi(role) {
    switch (role ? role : getUserRole()) {
        case ROLE_ADMIN:   return "Hallinta";
        case ROLE_INSPECT: return "Laajat käyttöoikeudet";
        case ROLE_REPAIR:  return "Rajoitetut käyttöoikeudet";
        case ROLE_READER:  return "Katseluoikeus";
        case ROLE_NONE:
        case ROLE_UNKNOWN:
        default: return "Ei oikeuksia";
    }
}

function isInArray(attr, array) {
    return array.indexOf(attr) >= 0;
}
export function isValidAttr(attr) {
    return (attr !== undefined && attr !== STR_NO_VALUE);
}

//Calculates sum of numbers in an array [1, 2, 3] = 6
export function calculateArraySum(array){
    return array.reduce((a, b) => a + b, 0)
}

export function hasAttr(itm, attr) {
    return (itm && itm.hasOwnProperty(attr) && attr !== STR_NO_VALUE)
}

export function prosLocalize(what) {
    const translates = {
        "showProject":  "Projektitietojen katselu",
        "addProject":   "Lisätä projekti",
        "delProject":   "Poistaa projekti",
        "archiveProject": "Arkistoida projekti",
        "editHistory":  "Poistaa jaettu raportti",
        "editAdmin":    "Muuttaa käyttöoikeustietoja",
        "editProject":  "Muokata projektin tietoja",
        "moveProject":  "Siirtää projektia",
        "excelExport":  "Hakea tietoja Exceliin",
        "makeRepairWeb": "Tehdä aktiivinen raportti",
        "reorderItems": "Siirtää tietoja",
        "editReportSettings": "Muokata raportin asetuksia",
        "manageObj":    "Muuttaa tietoa",
        "addContent":   "Lisätä sisältöä",
        "editMarker":   "Muokata sijaintimerkkiä",
        "editObj":      "Muokata tietoa",
        "editExpiration": "Asettaa määräaika",
        "editAllMarker": "Muokata kaikkia kirjauksen valintoja",
        "Name is already in use": "Nimi on jo käytössä",
        "No access" : "Ei käyttöoikeutta projektiin",
        "Link not found": "Linkkiä ei löydy",
        "Project not active": "Projekti ei ole aktiivinen",
    }
    translates[ATTR_TABLE_DEF_BOOKMARK] = "Taulukon oletusasetukset"

    if (translates.hasOwnProperty(what)) {
        return translates[what]
    }
    prosLogErr("Missing translation for", what);
    return what;
}

export function activeProjectEnabled(boolAttr) {
    return activeProject && activeProject.getAttr(boolAttr) === STR_YES
}

var prevActiveProject = undefined;
var prevRole = undefined;
// ref Android ProsProject.kt
export function hasPermissionTo(what, obj, otherProject) {
    let role = otherProject ? otherProject[ATTR_USER_ROLE]: getUserRole()
    let isPrjActive = activeProject && isActive(activeProject.attrs)

    function retVal(val) {
        if ((activeProject !== prevActiveProject || role !== prevRole) && !otherProject) {
            prosLog("Permission change project",
                (activeProject ? activeProject.getPid() : "NO PROJECT"), ", role:", role);
            prevActiveProject = activeProject;
            prevRole = role;
        }
        return val;
    }
    function isRoleIn(roles) {
        return isInArray(role, roles);
    }
    if (isSuperUserOverridePermissionsInUse()) {
        return retVal(true)
    }
    let permitted;
    switch (what) {
        case "showProject": permitted = isRoleIn(haveSomeAccessRoles); break;
        case "orderMainProject" :
        case "addProject" :
        case "delProject" :
        case "archiveProject" :
        case "shareProject" :
        case "editAdmin"  : permitted = isRoleIn([ROLE_ADMIN]); break;
        case "editProjectSettings":
        case "editHistory":
        case "editProject":
        case "moveProject":
        case "excelExport": permitted = isRoleIn(projectOperationRoles); break;
        case "makeRepairWeb": permitted = isRoleIn(contentCreateRoles); break;
        case "reorderItems": permitted = isRoleIn(projectOperationRoles) && isPrjActive; break;
        case "editReportSettings":
        case "manageObj": permitted = isRoleIn(projectOperationRoles) ||
            (obj && obj[ATTR_CREATED_BY] === getUserEmail(true));
            break;
        case "addContent":
        case "editDashboard":
        case "editMarker": permitted = isRoleIn(markerEditRoles) && isPrjActive; break;
        case "editAllMarker": permitted = isRoleIn(projectOperationRoles) && isPrjActive; break;
        case "editObj": {
            if (!isPrjActive) {
                permitted = false
            } else if (isRoleIn(projectOperationRoles)) {
                permitted = true
            } else if (obj && obj[ATTR_OBJ_TYPE] === OBJ_TYPE_ITM_OBS && role === ROLE_REPAIR) {
                permitted = true
            } else {
                permitted = (obj && obj[ATTR_CREATED_BY] === getUserEmail(true) && role !== ROLE_READER)
            }
            break;
        }
        case "editExpiration": {
            permitted = isPrjActive &&
                (isRoleIn(projectOperationRoles) ||
                (role === ROLE_REPAIR &&
                (activeProjectEnabled(ATTR_EXPIRATION_RESTRIC_SET) ||
                    (obj && obj[ATTR_CREATED_BY] === getUserEmail(true) &&
                        activeProjectEnabled(ATTR_EXPIRATION_RESTRIC_OWN)))))
            break;
        }
        default: {
            permitted = false;
            prosLogErr('ERR Invalid permission req what', what);
        }
    }
    return retVal(permitted)
}

export function hasPermissionToReorder() {
    return activeProject && hasPermissionTo("reorderItems", undefined, undefined, false);
}

export function hasCustomerHeadMasterRole() {
    if (!activeProject) {
        return false
    }
    if (isSuperUserModeInUse()) {
        return true
    }
    return activeProject.attrs.hasOwnProperty(ATTR_CUSTOMER_ADMIN_EMAILS) &&
           activeProject.attrs[ATTR_CUSTOMER_ADMIN_EMAILS].includes(getUserEmail(true))
}

/**
 * Check if an active project is archived
 * @returns {boolean|boolean}
 */
export function isProjectArchived() {
    return !activeProject || !activeProject.isProjectActive()
}

/**
 * Get text reason why not permitted - either archived or no permission
 * @param what      Permission
 * @param obj       Optional item for which to check permission
 * @returns {string|null}    Reason/disclaimer why not or - or null when permitted
 */
export function getDisclaimerWhyDisabled(what, obj) {
    if (isProjectArchived()) {
        return "Osaprojekti on arkistoitu"
    }
    return hasPermissionTo(what, obj) ? null: "Ei käyttöoikeutta"
}



function getReportViewModeUiText(reportViewMode){
    switch(reportViewMode){
        case VIEW_MODE_LIST:
            return "Lista";
        case VIEW_MODE_TABLE:
            return "Taulukko";
        case VIEW_MODE_CALENDAR:
             return "Kalenteri";
        case VIEW_MODE_DASHBOARD:
            return "Tilanne";
        default:
            return "";     
    }
}

export function getProjectSharedReports(project, onlyWithPdfCoverPage) {
    let userEmail = getUserEmail();
    let historyList = project.objs.filter(historyObj =>
        historyObj[ATTR_OBJ_ID].startsWith(PREFIX_REPORT_HISTORY) &&
        historyObj[ATTR_OBJ_TYPE] !== OBJ_TYPE_LST_REPORT_HISTORY &&
        (hasPermissionTo("editHistory", historyObj, undefined, false) ||
            userEmail === historyObj[ATTR_CREATED_BY])
    );

    if(onlyWithPdfCoverPage){
        historyList = historyList.filter(historyObj => 
            historyObj[ATTR_OBJ_TYPE] === OBJ_TYPE_PDF_REPORT 
            && historyObj.report_req_obj 
            && historyObj.report_req_obj.coverPage);
    }

    function onlyUnique(value, index, self) {
        return self.indexOf(value) === index;
    }

    // Prepare data for UI
    historyList.forEach(historyObj => {
        // eslint-disable-next-line no-undef
        let emailReceiversTxt = historyObj[ATTR_UPDATED_BY];
        if (historyObj[ATTR_SENT_TO]) {
            emailReceiversTxt += ',' + historyObj[ATTR_SENT_TO];
        }
        emailReceiversTxt = emailReceiversTxt.replace(/;/g, ",").replace(STR_NO_VALUE, '')
        emailReceiversTxt = emailReceiversTxt.replace('no-receivers', 'Ei vastaanottajia')
        let emailReceivers = emailReceiversTxt.split(',')
            .filter(onlyUnique)
            .join(' ');
        let type = historyObj[ATTR_OBJ_TYPE];
        let listRef = getObjById(historyObj[ATTR_LIST_REF]);
        let reportName;
        if (type === OBJ_TYPE_PDF_REPORT && historyObj.report_req_obj.searchParams && historyObj.report_req_obj.searchParams.name){
            const pdfType = getReportViewModeUiText(historyObj.report_req_obj.report_view_mode)
            const textPdfType = pdfType !== ""
                ? ` (${pdfType})`
                : "";
            reportName = `${historyObj.report_req_obj.searchParams.name}${textPdfType}`;
        } else {
            reportName = listRef ? getReportInfo(listRef) : historyObj[ATTR_TEXT];
        }
        
        // ui_ prefix attributes can be used to add UI related obj data to obj context
        // These attributes are filtered by prosConnect before sending changes to server
        historyObj.ui_reportType = REPORT_TYPE_FOR_UI[type] || "???"
        historyObj.ui_reportName = reportName !== STR_NO_VALUE ? reportName: '-'
        historyObj.ui_message = ""
        historyObj.ui_sentTo = emailReceivers;
    })
    return historyList;
}

//TODO - remove - should use a function to get a valid data or default and then no need to check if empty
export function isValueEmpty(val){
    return val == null
        || val === STR_NO_VALUE
        || val === 'undefined'
        || val === ''
        || val === undefined
}

// Todo replace those using this to use getBoolStr(obj, attr, default) or some other access function
export function isFalse(val) {
    return val === STR_NO_VALUE
        || val === "undefined"
        || val === undefined
        || val === STR_NO
        || val === ""
        || val == null
}

/**
 * Validate if given color code is a string with 6 hex numbers
 * @param inStr         color code string to be tested
 * @returns {boolean}   true when color code is valid
 */
export function isValidColorCode(inStr) {
    let regexp = /^[0-9a-fA-F]+$/;
    return regexp.test(inStr) && (inStr.length === 6 || inStr.length === 8)
}


//Is this duplicate?
export function hasPermissionAndCapacityToAddContent(isObs) {
    return hasPermissionTo("addContent", undefined, undefined) && getActiveProject().hasCapacityToAddItems(isObs)
}
// /


//Todo Jere, add real functionality
export function toggleFollowObs(obs, isSelected){
    const msg = isSelected ? "Lisätty seurattaviin" : "Poistettu seurattavista"
    prosAppNotif(msg)
}


export const createNewObsComment = async (objId, commentIn)=> {
    let comment = validateTextInput(commentIn)
    if (!comment) return
    let obj = getObjById(objId)
    let project = getActiveProject()

    if (isReportType(obj)) {
        // Adds a comment at the eof report
        await project.awaitAddTextItem(comment, obj.obj_id);
    } else if (isObservation(obj)) {
        // Adds a comment at the eof OBS items
        await project.awaitCommentObs(comment, obj)
    } else {
        // Add a comment after specific item like picture or sound
        let listId = getObjListId(this.state.selectedItem)
        await project.awaitAddTextItem(comment, listId, obj)
    }
    checkToWarnCloseToCapacityLimit()
    //this.props.refreshParentUi()//hox: is this needed? how to refresh without using props
}

export function pictureHasMarker(item) {
    return item && item[ATTR_HAS_PICTURE_LOC] === STR_YES
}

export function pictureHasMarkerCoordinates(item) {
    return item
        && item[ATTR_PICTURE_LOC_H] !== STR_NO_VALUE
        && item[ATTR_PICTURE_LOC_W] !== STR_NO_VALUE
}